const map = {
        "type": "FeatureCollection",
        "features": [
                {
                        "type": "Feature",
                        "geometry": {
                                "type": "Polygon",
                                "coordinates": [
                                        [
                                                [
                                                        23.54957,
                                                        56.063211
                                                ],
                                                [
                                                        23.568876,
                                                        56.066313
                                                ],
                                                [
                                                        23.582165,
                                                        56.08609
                                                ],
                                                [
                                                        23.604313,
                                                        56.072907
                                                ],
                                                [
                                                        23.631629,
                                                        56.095563
                                                ],
                                                [
                                                        23.684046,
                                                        56.125203
                                                ],
                                                [
                                                        23.664851,
                                                        56.134255
                                                ],
                                                [
                                                        23.714315,
                                                        56.167975
                                                ],
                                                [
                                                        23.740893,
                                                        56.179893
                                                ],
                                                [
                                                        23.807338,
                                                        56.176605
                                                ],
                                                [
                                                        23.832439,
                                                        56.183591
                                                ],
                                                [
                                                        23.824318,
                                                        56.200844
                                                ],
                                                [
                                                        23.866399,
                                                        56.245993
                                                ],
                                                [
                                                        23.889286,
                                                        56.249274
                                                ],
                                                [
                                                        23.907742,
                                                        56.284533
                                                ],
                                                [
                                                        23.928935,
                                                        56.308603
                                                ],
                                                [
                                                        23.960727,
                                                        56.309516
                                                ],
                                                [
                                                        23.961747,
                                                        56.330452
                                                ],
                                                [
                                                        24.018937,
                                                        56.329754
                                                ],
                                                [
                                                        24.022631,
                                                        56.310708
                                                ],
                                                [
                                                        24.04924,
                                                        56.299341
                                                ],
                                                [
                                                        24.046005,
                                                        56.279661
                                                ],
                                                [
                                                        24.097692,
                                                        56.277291
                                                ],
                                                [
                                                        24.118901,
                                                        56.261756
                                                ],
                                                [
                                                        24.121463,
                                                        56.248898
                                                ],
                                                [
                                                        24.151503,
                                                        56.253297
                                                ],
                                                [
                                                        24.129591,
                                                        56.24452
                                                ],
                                                [
                                                        24.147623,
                                                        56.215833
                                                ],
                                                [
                                                        24.142467,
                                                        56.203398
                                                ],
                                                [
                                                        24.169078,
                                                        56.194993
                                                ],
                                                [
                                                        24.151145,
                                                        56.174843
                                                ],
                                                [
                                                        24.182323,
                                                        56.171237
                                                ],
                                                [
                                                        24.172685,
                                                        56.146248
                                                ],
                                                [
                                                        24.177267,
                                                        56.12691
                                                ],
                                                [
                                                        24.128499,
                                                        56.123622
                                                ],
                                                [
                                                        24.11607,
                                                        56.109147
                                                ],
                                                [
                                                        24.104145,
                                                        56.074086
                                                ],
                                                [
                                                        24.073756,
                                                        56.069075
                                                ],
                                                [
                                                        24.069265,
                                                        56.03166
                                                ],
                                                [
                                                        24.04042,
                                                        56.037793
                                                ],
                                                [
                                                        24.042984,
                                                        56.013077
                                                ],
                                                [
                                                        24.022713,
                                                        55.999011
                                                ],
                                                [
                                                        24.027761,
                                                        55.981398
                                                ],
                                                [
                                                        24.012537,
                                                        55.961445
                                                ],
                                                [
                                                        24.049506,
                                                        55.954044
                                                ],
                                                [
                                                        24.056365,
                                                        55.942344
                                                ],
                                                [
                                                        24.094376,
                                                        55.942703
                                                ],
                                                [
                                                        24.093781,
                                                        55.91217
                                                ],
                                                [
                                                        24.076133,
                                                        55.887887
                                                ],
                                                [
                                                        24.0843,
                                                        55.879773
                                                ],
                                                [
                                                        24.03323,
                                                        55.863072
                                                ],
                                                [
                                                        24.035824,
                                                        55.850732
                                                ],
                                                [
                                                        24.014795,
                                                        55.838236
                                                ],
                                                [
                                                        23.97021,
                                                        55.841839
                                                ],
                                                [
                                                        23.960022,
                                                        55.835588
                                                ],
                                                [
                                                        23.897018,
                                                        55.82282
                                                ],
                                                [
                                                        23.848269,
                                                        55.817911
                                                ],
                                                [
                                                        23.821641,
                                                        55.826886
                                                ],
                                                [
                                                        23.820549,
                                                        55.874794
                                                ],
                                                [
                                                        23.763879,
                                                        55.859393
                                                ],
                                                [
                                                        23.731857,
                                                        55.865026
                                                ],
                                                [
                                                        23.722435,
                                                        55.880999
                                                ],
                                                [
                                                        23.683381,
                                                        55.867593
                                                ],
                                                [
                                                        23.646717,
                                                        55.873415
                                                ],
                                                [
                                                        23.653135,
                                                        55.886169
                                                ],
                                                [
                                                        23.552201,
                                                        55.913868
                                                ],
                                                [
                                                        23.571298,
                                                        55.92931
                                                ],
                                                [
                                                        23.572743,
                                                        55.959098
                                                ],
                                                [
                                                        23.554399,
                                                        55.966812
                                                ],
                                                [
                                                        23.54407,
                                                        55.983669
                                                ],
                                                [
                                                        23.590035,
                                                        56.018116
                                                ],
                                                [
                                                        23.547747,
                                                        56.031027
                                                ],
                                                [
                                                        23.573048,
                                                        56.053358
                                                ],
                                                [
                                                        23.54957,
                                                        56.063211
                                                ]
                                        ]
                                ]
                        },
                        "properties": {
                                "longName": "Pakruojo rajonas",
                                "name": "Pakruojo r. sav.",
                                "id": "65",
                                "osmId": 17198,
                                "org_id": 29
                        },
                        "id": "65"
                },
                {
                        "type": "Feature",
                        "geometry": {
                                "type": "Polygon",
                                "coordinates": [
                                        [
                                                [
                                                        23.128062,
                                                        56.203098
                                                ],
                                                [
                                                        23.108358,
                                                        56.240202
                                                ],
                                                [
                                                        23.078758,
                                                        56.242692
                                                ],
                                                [
                                                        23.076433,
                                                        56.261716
                                                ],
                                                [
                                                        23.10013,
                                                        56.264237
                                                ],
                                                [
                                                        23.088279,
                                                        56.285182
                                                ],
                                                [
                                                        23.09325,
                                                        56.304638
                                                ],
                                                [
                                                        23.14602,
                                                        56.32677
                                                ],
                                                [
                                                        23.18411,
                                                        56.337416
                                                ],
                                                [
                                                        23.172421,
                                                        56.354541
                                                ],
                                                [
                                                        23.177013,
                                                        56.368595
                                                ],
                                                [
                                                        23.279376,
                                                        56.372025
                                                ],
                                                [
                                                        23.306452,
                                                        56.383054
                                                ],
                                                [
                                                        23.387975,
                                                        56.378923
                                                ],
                                                [
                                                        23.41839,
                                                        56.37058
                                                ],
                                                [
                                                        23.439079,
                                                        56.351688
                                                ],
                                                [
                                                        23.492579,
                                                        56.34522
                                                ],
                                                [
                                                        23.510595,
                                                        56.335802
                                                ],
                                                [
                                                        23.544936,
                                                        56.3321
                                                ],
                                                [
                                                        23.572428,
                                                        56.338473
                                                ],
                                                [
                                                        23.630077,
                                                        56.359934
                                                ],
                                                [
                                                        23.661357,
                                                        56.364741
                                                ],
                                                [
                                                        23.74331,
                                                        56.36901
                                                ],
                                                [
                                                        23.780611,
                                                        56.36771
                                                ],
                                                [
                                                        23.76214,
                                                        56.333238
                                                ],
                                                [
                                                        23.781478,
                                                        56.320518
                                                ],
                                                [
                                                        23.795223,
                                                        56.33913
                                                ],
                                                [
                                                        23.912623,
                                                        56.33869
                                                ],
                                                [
                                                        23.915153,
                                                        56.331117
                                                ],
                                                [
                                                        23.961747,
                                                        56.330452
                                                ],
                                                [
                                                        23.960727,
                                                        56.309516
                                                ],
                                                [
                                                        23.928935,
                                                        56.308603
                                                ],
                                                [
                                                        23.907742,
                                                        56.284533
                                                ],
                                                [
                                                        23.889286,
                                                        56.249274
                                                ],
                                                [
                                                        23.866399,
                                                        56.245993
                                                ],
                                                [
                                                        23.824318,
                                                        56.200844
                                                ],
                                                [
                                                        23.832439,
                                                        56.183591
                                                ],
                                                [
                                                        23.807338,
                                                        56.176605
                                                ],
                                                [
                                                        23.740893,
                                                        56.179893
                                                ],
                                                [
                                                        23.714315,
                                                        56.167975
                                                ],
                                                [
                                                        23.664851,
                                                        56.134255
                                                ],
                                                [
                                                        23.684046,
                                                        56.125203
                                                ],
                                                [
                                                        23.631629,
                                                        56.095563
                                                ],
                                                [
                                                        23.604313,
                                                        56.072907
                                                ],
                                                [
                                                        23.582165,
                                                        56.08609
                                                ],
                                                [
                                                        23.568876,
                                                        56.066313
                                                ],
                                                [
                                                        23.54957,
                                                        56.063211
                                                ],
                                                [
                                                        23.48358,
                                                        56.086585
                                                ],
                                                [
                                                        23.439562,
                                                        56.092905
                                                ],
                                                [
                                                        23.441113,
                                                        56.104177
                                                ],
                                                [
                                                        23.409085,
                                                        56.108781
                                                ],
                                                [
                                                        23.36288,
                                                        56.129505
                                                ],
                                                [
                                                        23.350297,
                                                        56.144889
                                                ],
                                                [
                                                        23.285091,
                                                        56.14534
                                                ],
                                                [
                                                        23.313137,
                                                        56.166417
                                                ],
                                                [
                                                        23.273327,
                                                        56.185441
                                                ],
                                                [
                                                        23.256115,
                                                        56.187598
                                                ],
                                                [
                                                        23.232087,
                                                        56.169423
                                                ],
                                                [
                                                        23.200061,
                                                        56.179708
                                                ],
                                                [
                                                        23.19303,
                                                        56.204117
                                                ],
                                                [
                                                        23.163025,
                                                        56.214535
                                                ],
                                                [
                                                        23.128062,
                                                        56.203098
                                                ]
                                        ]
                                ]
                        },
                        "properties": {
                                "longName": "Joni\u0161kio rajonas",
                                "name": "Joni\u0161kio r. sav.",
                                "id": "47",
                                "osmId": 17199,
                                "org_id": 10
                        },
                        "id": "47"
                },
                {
                        "type": "Feature",
                        "geometry": {
                                "type": "Polygon",
                                "coordinates": [
                                        [
                                                [
                                                        22.073847,
                                                        56.0902
                                                ],
                                                [
                                                        22.113325,
                                                        56.113418
                                                ],
                                                [
                                                        22.110255,
                                                        56.127277
                                                ],
                                                [
                                                        22.144206,
                                                        56.130287
                                                ],
                                                [
                                                        22.127022,
                                                        56.108624
                                                ],
                                                [
                                                        22.164822,
                                                        56.099546
                                                ],
                                                [
                                                        22.166756,
                                                        56.112568
                                                ],
                                                [
                                                        22.237903,
                                                        56.106836
                                                ],
                                                [
                                                        22.251626,
                                                        56.147383
                                                ],
                                                [
                                                        22.276951,
                                                        56.154763
                                                ],
                                                [
                                                        22.339465,
                                                        56.163667
                                                ],
                                                [
                                                        22.359371,
                                                        56.162278
                                                ],
                                                [
                                                        22.399996,
                                                        56.146103
                                                ],
                                                [
                                                        22.437484,
                                                        56.139338
                                                ],
                                                [
                                                        22.434013,
                                                        56.12646
                                                ],
                                                [
                                                        22.446797,
                                                        56.111681
                                                ],
                                                [
                                                        22.474339,
                                                        56.097386
                                                ],
                                                [
                                                        22.506727,
                                                        56.088274
                                                ],
                                                [
                                                        22.510635,
                                                        56.104703
                                                ],
                                                [
                                                        22.564438,
                                                        56.101776
                                                ],
                                                [
                                                        22.580012,
                                                        56.094627
                                                ],
                                                [
                                                        22.612683,
                                                        56.085912
                                                ],
                                                [
                                                        22.654364,
                                                        56.10574
                                                ],
                                                [
                                                        22.702977,
                                                        56.117227
                                                ],
                                                [
                                                        22.716755,
                                                        56.109112
                                                ],
                                                [
                                                        22.715434,
                                                        56.08371
                                                ],
                                                [
                                                        22.739125,
                                                        56.06949
                                                ],
                                                [
                                                        22.707881,
                                                        56.064184
                                                ],
                                                [
                                                        22.700377,
                                                        56.046737
                                                ],
                                                [
                                                        22.678381,
                                                        56.053277
                                                ],
                                                [
                                                        22.621265,
                                                        56.042683
                                                ],
                                                [
                                                        22.630083,
                                                        56.016125
                                                ],
                                                [
                                                        22.613944,
                                                        55.988655
                                                ],
                                                [
                                                        22.584564,
                                                        55.978997
                                                ],
                                                [
                                                        22.607807,
                                                        55.96769
                                                ],
                                                [
                                                        22.605684,
                                                        55.951335
                                                ],
                                                [
                                                        22.658715,
                                                        55.951142
                                                ],
                                                [
                                                        22.682333,
                                                        55.939522
                                                ],
                                                [
                                                        22.677273,
                                                        55.922306
                                                ],
                                                [
                                                        22.694977,
                                                        55.908395
                                                ],
                                                [
                                                        22.688612,
                                                        55.893095
                                                ],
                                                [
                                                        22.653573,
                                                        55.901827
                                                ],
                                                [
                                                        22.663831,
                                                        55.879178
                                                ],
                                                [
                                                        22.632709,
                                                        55.858625
                                                ],
                                                [
                                                        22.578518,
                                                        55.863067
                                                ],
                                                [
                                                        22.583841,
                                                        55.811837
                                                ],
                                                [
                                                        22.486805,
                                                        55.788198
                                                ],
                                                [
                                                        22.525096,
                                                        55.752954
                                                ],
                                                [
                                                        22.516142,
                                                        55.731076
                                                ],
                                                [
                                                        22.530814,
                                                        55.709656
                                                ],
                                                [
                                                        22.516431,
                                                        55.689815
                                                ],
                                                [
                                                        22.481931,
                                                        55.690836
                                                ],
                                                [
                                                        22.466209,
                                                        55.67323
                                                ],
                                                [
                                                        22.446737,
                                                        55.66433
                                                ],
                                                [
                                                        22.420555,
                                                        55.669615
                                                ],
                                                [
                                                        22.364759,
                                                        55.66024
                                                ],
                                                [
                                                        22.353801,
                                                        55.6708
                                                ],
                                                [
                                                        22.311644,
                                                        55.676844
                                                ],
                                                [
                                                        22.301152,
                                                        55.667099
                                                ],
                                                [
                                                        22.26017,
                                                        55.688794
                                                ],
                                                [
                                                        22.251829,
                                                        55.684183
                                                ],
                                                [
                                                        22.231176,
                                                        55.691776
                                                ],
                                                [
                                                        22.251496,
                                                        55.72206
                                                ],
                                                [
                                                        22.251289,
                                                        55.737287
                                                ],
                                                [
                                                        22.227789,
                                                        55.752373
                                                ],
                                                [
                                                        22.227691,
                                                        55.77049
                                                ],
                                                [
                                                        22.240196,
                                                        55.784749
                                                ],
                                                [
                                                        22.168781,
                                                        55.803904
                                                ],
                                                [
                                                        22.157001,
                                                        55.817224
                                                ],
                                                [
                                                        22.163591,
                                                        55.833114
                                                ],
                                                [
                                                        22.123131,
                                                        55.844862
                                                ],
                                                [
                                                        22.126993,
                                                        55.866541
                                                ],
                                                [
                                                        22.162879,
                                                        55.873271
                                                ],
                                                [
                                                        22.166418,
                                                        55.893401
                                                ],
                                                [
                                                        22.132033,
                                                        55.904129
                                                ],
                                                [
                                                        22.12805,
                                                        55.936285
                                                ],
                                                [
                                                        22.076573,
                                                        55.950288
                                                ],
                                                [
                                                        22.08337,
                                                        55.966117
                                                ],
                                                [
                                                        22.065278,
                                                        55.996791
                                                ],
                                                [
                                                        22.098457,
                                                        56.0098
                                                ],
                                                [
                                                        22.109111,
                                                        56.036278
                                                ],
                                                [
                                                        22.076169,
                                                        56.039567
                                                ],
                                                [
                                                        22.083367,
                                                        56.055951
                                                ],
                                                [
                                                        22.072295,
                                                        56.068586
                                                ],
                                                [
                                                        22.073847,
                                                        56.0902
                                                ]
                                        ]
                                ]
                        },
                        "properties": {
                                "longName": "Tel\u0161i\u0173 rajonas",
                                "name": "Tel\u0161i\u0173 r. sav.",
                                "id": "78",
                                "osmId": 17212,
                                "org_id": 50
                        },
                        "id": "78"
                },
                {
                        "type": "Feature",
                        "geometry": {
                                "type": "Polygon",
                                "coordinates": [
                                        [
                                                [
                                                        24.170093,
                                                        54.536058
                                                ],
                                                [
                                                        24.128944,
                                                        54.538024
                                                ],
                                                [
                                                        24.106715,
                                                        54.526829
                                                ],
                                                [
                                                        24.086147,
                                                        54.549786
                                                ],
                                                [
                                                        24.067607,
                                                        54.554366
                                                ],
                                                [
                                                        24.013971,
                                                        54.5458
                                                ],
                                                [
                                                        23.996499,
                                                        54.51255
                                                ],
                                                [
                                                        24.006839,
                                                        54.497981
                                                ],
                                                [
                                                        23.971954,
                                                        54.492272
                                                ],
                                                [
                                                        23.927532,
                                                        54.515323
                                                ],
                                                [
                                                        23.886362,
                                                        54.531982
                                                ],
                                                [
                                                        23.891532,
                                                        54.541863
                                                ],
                                                [
                                                        23.97594,
                                                        54.571485
                                                ],
                                                [
                                                        23.986565,
                                                        54.587889
                                                ],
                                                [
                                                        24.010292,
                                                        54.586336
                                                ],
                                                [
                                                        24.008092,
                                                        54.602744
                                                ],
                                                [
                                                        23.975275,
                                                        54.607725
                                                ],
                                                [
                                                        23.957744,
                                                        54.623794
                                                ],
                                                [
                                                        23.964595,
                                                        54.643766
                                                ],
                                                [
                                                        23.986541,
                                                        54.647316
                                                ],
                                                [
                                                        24.018676,
                                                        54.624277
                                                ],
                                                [
                                                        24.056613,
                                                        54.621693
                                                ],
                                                [
                                                        24.085552,
                                                        54.607361
                                                ],
                                                [
                                                        24.103785,
                                                        54.587218
                                                ],
                                                [
                                                        24.138747,
                                                        54.577869
                                                ],
                                                [
                                                        24.152045,
                                                        54.563235
                                                ],
                                                [
                                                        24.140801,
                                                        54.553244
                                                ],
                                                [
                                                        24.170093,
                                                        54.536058
                                                ]
                                        ]
                                ]
                        },
                        "properties": {
                                "longName": "Bir\u0161tono savivaldyb\u0117",
                                "name": "Bir\u0161tono sav.",
                                "id": "12",
                                "osmId": 240013,
                                "org_id": 4
                        },
                        "id": "12"
                },
                {
                        "type": "Feature",
                        "geometry": {
                                "type": "Polygon",
                                "coordinates": [
                                        [
                                                [
                                                        25.078932,
                                                        56.012389
                                                ],
                                                [
                                                        25.064373,
                                                        55.997982
                                                ],
                                                [
                                                        25.068672,
                                                        55.977374
                                                ],
                                                [
                                                        25.097683,
                                                        55.967556
                                                ],
                                                [
                                                        25.139903,
                                                        55.94296
                                                ],
                                                [
                                                        25.191213,
                                                        55.953135
                                                ],
                                                [
                                                        25.22744,
                                                        55.948711
                                                ],
                                                [
                                                        25.252857,
                                                        55.936293
                                                ],
                                                [
                                                        25.272322,
                                                        55.936796
                                                ],
                                                [
                                                        25.279858,
                                                        55.961142
                                                ],
                                                [
                                                        25.312813,
                                                        55.975132
                                                ],
                                                [
                                                        25.323406,
                                                        55.966858
                                                ],
                                                [
                                                        25.323982,
                                                        55.923278
                                                ],
                                                [
                                                        25.332886,
                                                        55.901119
                                                ],
                                                [
                                                        25.321216,
                                                        55.866294
                                                ],
                                                [
                                                        25.300238,
                                                        55.854119
                                                ],
                                                [
                                                        25.293475,
                                                        55.828218
                                                ],
                                                [
                                                        25.336396,
                                                        55.796073
                                                ],
                                                [
                                                        25.364793,
                                                        55.761779
                                                ],
                                                [
                                                        25.333622,
                                                        55.734484
                                                ],
                                                [
                                                        25.295177,
                                                        55.733708
                                                ],
                                                [
                                                        25.300695,
                                                        55.7024
                                                ],
                                                [
                                                        25.267318,
                                                        55.717944
                                                ],
                                                [
                                                        25.239325,
                                                        55.714078
                                                ],
                                                [
                                                        25.098179,
                                                        55.683
                                                ],
                                                [
                                                        25.085688,
                                                        55.715535
                                                ],
                                                [
                                                        25.009163,
                                                        55.732745
                                                ],
                                                [
                                                        24.969363,
                                                        55.734845
                                                ],
                                                [
                                                        24.950266,
                                                        55.723762
                                                ],
                                                [
                                                        24.869128,
                                                        55.720682
                                                ],
                                                [
                                                        24.862781,
                                                        55.70902
                                                ],
                                                [
                                                        24.828145,
                                                        55.723491
                                                ],
                                                [
                                                        24.791227,
                                                        55.710581
                                                ],
                                                [
                                                        24.715099,
                                                        55.720956
                                                ],
                                                [
                                                        24.690296,
                                                        55.742642
                                                ],
                                                [
                                                        24.686685,
                                                        55.767163
                                                ],
                                                [
                                                        24.705227,
                                                        55.778699
                                                ],
                                                [
                                                        24.743569,
                                                        55.787791
                                                ],
                                                [
                                                        24.738343,
                                                        55.810907
                                                ],
                                                [
                                                        24.758747,
                                                        55.82209
                                                ],
                                                [
                                                        24.755202,
                                                        55.838884
                                                ],
                                                [
                                                        24.739479,
                                                        55.850747
                                                ],
                                                [
                                                        24.741388,
                                                        55.871455
                                                ],
                                                [
                                                        24.721711,
                                                        55.879765
                                                ],
                                                [
                                                        24.715259,
                                                        55.922489
                                                ],
                                                [
                                                        24.756467,
                                                        55.923405
                                                ],
                                                [
                                                        24.776105,
                                                        55.934808
                                                ],
                                                [
                                                        24.806208,
                                                        55.933926
                                                ],
                                                [
                                                        24.825109,
                                                        55.949053
                                                ],
                                                [
                                                        24.888224,
                                                        55.947207
                                                ],
                                                [
                                                        24.892418,
                                                        55.974406
                                                ],
                                                [
                                                        24.87744,
                                                        55.989758
                                                ],
                                                [
                                                        24.886187,
                                                        56.006376
                                                ],
                                                [
                                                        24.916085,
                                                        56.018869
                                                ],
                                                [
                                                        24.952211,
                                                        56.021733
                                                ],
                                                [
                                                        25.032261,
                                                        56.048766
                                                ],
                                                [
                                                        25.050311,
                                                        56.032994
                                                ],
                                                [
                                                        25.031812,
                                                        56.017854
                                                ],
                                                [
                                                        25.078932,
                                                        56.012389
                                                ]
                                        ]
                                ]
                        },
                        "properties": {
                                "longName": "Kupi\u0161kio rajonas",
                                "name": "Kupi\u0161kio r. sav.",
                                "id": "57",
                                "osmId": 240016,
                                "org_id": 22
                        },
                        "id": "57"
                },
                {
                        "type": "Feature",
                        "geometry": {
                                "type": "Polygon",
                                "coordinates": [
                                        [
                                                [
                                                        23.234311,
                                                        55.733199
                                                ],
                                                [
                                                        23.306081,
                                                        55.778578
                                                ],
                                                [
                                                        23.326703,
                                                        55.813729
                                                ],
                                                [
                                                        23.363956,
                                                        55.797653
                                                ],
                                                [
                                                        23.388569,
                                                        55.814477
                                                ],
                                                [
                                                        23.3746,
                                                        55.836523
                                                ],
                                                [
                                                        23.389235,
                                                        55.847728
                                                ],
                                                [
                                                        23.408526,
                                                        55.841752
                                                ],
                                                [
                                                        23.454427,
                                                        55.882444
                                                ],
                                                [
                                                        23.492345,
                                                        55.885429
                                                ],
                                                [
                                                        23.50698,
                                                        55.892517
                                                ],
                                                [
                                                        23.534127,
                                                        55.919313
                                                ],
                                                [
                                                        23.552201,
                                                        55.913868
                                                ],
                                                [
                                                        23.653135,
                                                        55.886169
                                                ],
                                                [
                                                        23.646717,
                                                        55.873415
                                                ],
                                                [
                                                        23.683381,
                                                        55.867593
                                                ],
                                                [
                                                        23.722435,
                                                        55.880999
                                                ],
                                                [
                                                        23.731857,
                                                        55.865026
                                                ],
                                                [
                                                        23.763879,
                                                        55.859393
                                                ],
                                                [
                                                        23.820549,
                                                        55.874794
                                                ],
                                                [
                                                        23.821641,
                                                        55.826886
                                                ],
                                                [
                                                        23.848269,
                                                        55.817911
                                                ],
                                                [
                                                        23.897018,
                                                        55.82282
                                                ],
                                                [
                                                        23.960022,
                                                        55.835588
                                                ],
                                                [
                                                        23.969593,
                                                        55.797411
                                                ],
                                                [
                                                        23.988008,
                                                        55.78162
                                                ],
                                                [
                                                        24.016068,
                                                        55.783068
                                                ],
                                                [
                                                        24.031942,
                                                        55.745004
                                                ],
                                                [
                                                        24.046299,
                                                        55.745729
                                                ],
                                                [
                                                        24.029929,
                                                        55.71105
                                                ],
                                                [
                                                        24.062932,
                                                        55.704486
                                                ],
                                                [
                                                        24.058625,
                                                        55.68822
                                                ],
                                                [
                                                        24.031645,
                                                        55.690917
                                                ],
                                                [
                                                        24.012338,
                                                        55.672962
                                                ],
                                                [
                                                        24.038479,
                                                        55.635469
                                                ],
                                                [
                                                        24.014927,
                                                        55.627976
                                                ],
                                                [
                                                        23.982138,
                                                        55.628517
                                                ],
                                                [
                                                        23.973591,
                                                        55.616236
                                                ],
                                                [
                                                        23.925043,
                                                        55.626597
                                                ],
                                                [
                                                        23.91961,
                                                        55.604047
                                                ],
                                                [
                                                        23.898401,
                                                        55.573342
                                                ],
                                                [
                                                        23.879556,
                                                        55.557817
                                                ],
                                                [
                                                        23.852878,
                                                        55.54749
                                                ],
                                                [
                                                        23.726606,
                                                        55.513013
                                                ],
                                                [
                                                        23.727804,
                                                        55.502832
                                                ],
                                                [
                                                        23.681062,
                                                        55.49808
                                                ],
                                                [
                                                        23.653496,
                                                        55.481783
                                                ],
                                                [
                                                        23.651099,
                                                        55.464801
                                                ],
                                                [
                                                        23.595623,
                                                        55.468734
                                                ],
                                                [
                                                        23.567202,
                                                        55.466839
                                                ],
                                                [
                                                        23.557614,
                                                        55.4845
                                                ],
                                                [
                                                        23.569599,
                                                        55.502832
                                                ],
                                                [
                                                        23.522857,
                                                        55.517084
                                                ],
                                                [
                                                        23.476115,
                                                        55.510298
                                                ],
                                                [
                                                        23.483306,
                                                        55.498759
                                                ],
                                                [
                                                        23.474916,
                                                        55.483142
                                                ],
                                                [
                                                        23.411394,
                                                        55.504868
                                                ],
                                                [
                                                        23.391103,
                                                        55.520702
                                                ],
                                                [
                                                        23.328696,
                                                        55.545573
                                                ],
                                                [
                                                        23.361697,
                                                        55.548911
                                                ],
                                                [
                                                        23.3565,
                                                        55.564343
                                                ],
                                                [
                                                        23.326617,
                                                        55.563608
                                                ],
                                                [
                                                        23.314923,
                                                        55.576096
                                                ],
                                                [
                                                        23.32142,
                                                        55.610602
                                                ],
                                                [
                                                        23.340909,
                                                        55.612804
                                                ],
                                                [
                                                        23.330515,
                                                        55.634812
                                                ],
                                                [
                                                        23.313624,
                                                        55.633345
                                                ],
                                                [
                                                        23.30323,
                                                        55.664869
                                                ],
                                                [
                                                        23.288938,
                                                        55.680988
                                                ],
                                                [
                                                        23.242164,
                                                        55.67879
                                                ],
                                                [
                                                        23.23177,
                                                        55.696368
                                                ],
                                                [
                                                        23.208383,
                                                        55.702958
                                                ],
                                                [
                                                        23.234311,
                                                        55.733199
                                                ]
                                        ]
                                ]
                        },
                        "properties": {
                                "longName": "Radvili\u0161kio rajonas",
                                "name": "Radvili\u0161kio r. sav.",
                                "id": "71",
                                "osmId": 240063,
                                "org_id": 36
                        },
                        "id": "71"
                },
                {
                        "type": "Feature",
                        "geometry": {
                                "type": "Polygon",
                                "coordinates": [
                                        [
                                                [
                                                        23.652968,
                                                        54.646346
                                                ],
                                                [
                                                        23.608851,
                                                        54.650617
                                                ],
                                                [
                                                        23.543448,
                                                        54.639194
                                                ],
                                                [
                                                        23.489203,
                                                        54.679408
                                                ],
                                                [
                                                        23.486971,
                                                        54.70441
                                                ],
                                                [
                                                        23.462424,
                                                        54.707882
                                                ],
                                                [
                                                        23.400833,
                                                        54.691255
                                                ],
                                                [
                                                        23.378419,
                                                        54.702198
                                                ],
                                                [
                                                        23.315612,
                                                        54.694158
                                                ],
                                                [
                                                        23.25854,
                                                        54.706832
                                                ],
                                                [
                                                        23.275315,
                                                        54.729559
                                                ],
                                                [
                                                        23.275144,
                                                        54.753143
                                                ],
                                                [
                                                        23.294398,
                                                        54.76346
                                                ],
                                                [
                                                        23.26866,
                                                        54.782956
                                                ],
                                                [
                                                        23.305411,
                                                        54.828179
                                                ],
                                                [
                                                        23.27568,
                                                        54.848859
                                                ],
                                                [
                                                        23.314412,
                                                        54.889642
                                                ],
                                                [
                                                        23.33426,
                                                        54.88524
                                                ],
                                                [
                                                        23.393985,
                                                        54.936723
                                                ],
                                                [
                                                        23.39179,
                                                        54.949696
                                                ],
                                                [
                                                        23.416344,
                                                        54.955426
                                                ],
                                                [
                                                        23.477015,
                                                        54.932487
                                                ],
                                                [
                                                        23.481993,
                                                        54.89045
                                                ],
                                                [
                                                        23.507056,
                                                        54.886994
                                                ],
                                                [
                                                        23.539671,
                                                        54.89203
                                                ],
                                                [
                                                        23.583788,
                                                        54.874255
                                                ],
                                                [
                                                        23.581728,
                                                        54.854101
                                                ],
                                                [
                                                        23.626532,
                                                        54.848666
                                                ],
                                                [
                                                        23.624129,
                                                        54.836211
                                                ],
                                                [
                                                        23.667216,
                                                        54.819895
                                                ],
                                                [
                                                        23.652072,
                                                        54.804568
                                                ],
                                                [
                                                        23.619494,
                                                        54.795756
                                                ],
                                                [
                                                        23.632712,
                                                        54.785364
                                                ],
                                                [
                                                        23.61915,
                                                        54.772097
                                                ],
                                                [
                                                        23.645071,
                                                        54.765165
                                                ],
                                                [
                                                        23.633913,
                                                        54.744461
                                                ],
                                                [
                                                        23.656744,
                                                        54.717104
                                                ],
                                                [
                                                        23.646788,
                                                        54.714229
                                                ],
                                                [
                                                        23.692965,
                                                        54.68437
                                                ],
                                                [
                                                        23.698115,
                                                        54.671666
                                                ],
                                                [
                                                        23.652968,
                                                        54.646346
                                                ]
                                        ]
                                ]
                        },
                        "properties": {
                                "longName": "Kazl\u0173 R\u016bdos savivaldyb\u0117",
                                "name": "Kazl\u0173 R\u016bdos sav.",
                                "id": "58",
                                "osmId": 240526,
                                "org_id": 16
                        },
                        "id": "58"
                },
                {
                        "type": "Feature",
                        "geometry": {
                                "type": "Polygon",
                                "coordinates": [
                                        [
                                                [
                                                        21.895994,
                                                        55.287983
                                                ],
                                                [
                                                        21.878923,
                                                        55.279652
                                                ],
                                                [
                                                        21.906046,
                                                        55.268015
                                                ],
                                                [
                                                        22.003649,
                                                        55.247019
                                                ],
                                                [
                                                        22.040215,
                                                        55.234641
                                                ],
                                                [
                                                        22.034067,
                                                        55.220866
                                                ],
                                                [
                                                        22.043414,
                                                        55.197285
                                                ],
                                                [
                                                        22.068305,
                                                        55.169692
                                                ],
                                                [
                                                        22.058627,
                                                        55.152339
                                                ],
                                                [
                                                        22.083082,
                                                        55.151772
                                                ],
                                                [
                                                        22.126116,
                                                        55.166857
                                                ],
                                                [
                                                        22.169203,
                                                        55.173132
                                                ],
                                                [
                                                        22.192377,
                                                        55.152834
                                                ],
                                                [
                                                        22.215894,
                                                        55.154991
                                                ],
                                                [
                                                        22.246622,
                                                        55.147929
                                                ],
                                                [
                                                        22.289022,
                                                        55.149106
                                                ],
                                                [
                                                        22.297262,
                                                        55.141748
                                                ],
                                                [
                                                        22.261556,
                                                        55.117213
                                                ],
                                                [
                                                        22.275282,
                                                        55.063967
                                                ],
                                                [
                                                        22.215612,
                                                        55.060023
                                                ],
                                                [
                                                        22.184439,
                                                        55.0531
                                                ],
                                                [
                                                        22.162123,
                                                        55.055656
                                                ],
                                                [
                                                        22.136374,
                                                        55.047396
                                                ],
                                                [
                                                        22.117148,
                                                        55.026739
                                                ],
                                                [
                                                        22.093115,
                                                        55.02359
                                                ],
                                                [
                                                        22.051479,
                                                        55.032125
                                                ],
                                                [
                                                        22.031252,
                                                        55.053061
                                                ],
                                                [
                                                        22.03784,
                                                        55.081802
                                                ],
                                                [
                                                        21.985312,
                                                        55.084946
                                                ],
                                                [
                                                        21.964733,
                                                        55.074052
                                                ],
                                                [
                                                        21.911154,
                                                        55.082392
                                                ],
                                                [
                                                        21.880599,
                                                        55.093592
                                                ],
                                                [
                                                        21.847983,
                                                        55.097717
                                                ],
                                                [
                                                        21.822234,
                                                        55.116178
                                                ],
                                                [
                                                        21.783438,
                                                        55.118927
                                                ],
                                                [
                                                        21.71752,
                                                        55.136201
                                                ],
                                                [
                                                        21.712714,
                                                        55.149936
                                                ],
                                                [
                                                        21.649863,
                                                        55.180533
                                                ],
                                                [
                                                        21.666013,
                                                        55.199428
                                                ],
                                                [
                                                        21.691405,
                                                        55.211675
                                                ],
                                                [
                                                        21.719417,
                                                        55.211459
                                                ],
                                                [
                                                        21.74848,
                                                        55.228808
                                                ],
                                                [
                                                        21.779757,
                                                        55.223347
                                                ],
                                                [
                                                        21.790627,
                                                        55.229968
                                                ],
                                                [
                                                        21.825777,
                                                        55.211483
                                                ],
                                                [
                                                        21.865826,
                                                        55.202868
                                                ],
                                                [
                                                        21.882806,
                                                        55.238513
                                                ],
                                                [
                                                        21.865517,
                                                        55.246544
                                                ],
                                                [
                                                        21.849544,
                                                        55.269916
                                                ],
                                                [
                                                        21.884223,
                                                        55.296523
                                                ],
                                                [
                                                        21.895994,
                                                        55.287983
                                                ]
                                        ]
                                ]
                        },
                        "properties": {
                                "longName": "Pag\u0117gi\u0173 savivaldyb\u0117",
                                "name": "Pag\u0117gi\u0173 sav.",
                                "id": "63",
                                "osmId": 365541,
                                "org_id": 28
                        },
                        "id": "63"
                },
                {
                        "type": "Feature",
                        "geometry": {
                                "type": "Polygon",
                                "coordinates": [
                                        [
                                                [
                                                        25.526205,
                                                        55.04086
                                                ],
                                                [
                                                        25.422192,
                                                        55.03399
                                                ],
                                                [
                                                        25.401771,
                                                        55.04038
                                                ],
                                                [
                                                        25.382157,
                                                        55.031652
                                                ],
                                                [
                                                        25.331497,
                                                        55.032052
                                                ],
                                                [
                                                        25.303038,
                                                        55.045986
                                                ],
                                                [
                                                        25.222264,
                                                        55.042678
                                                ],
                                                [
                                                        25.213937,
                                                        55.054518
                                                ],
                                                [
                                                        25.22594,
                                                        55.069916
                                                ],
                                                [
                                                        25.221987,
                                                        55.08896
                                                ],
                                                [
                                                        25.202981,
                                                        55.0962
                                                ],
                                                [
                                                        25.163559,
                                                        55.097516
                                                ],
                                                [
                                                        25.149104,
                                                        55.112175
                                                ],
                                                [
                                                        25.162327,
                                                        55.119315
                                                ],
                                                [
                                                        25.167252,
                                                        55.152414
                                                ],
                                                [
                                                        25.190936,
                                                        55.154084
                                                ],
                                                [
                                                        25.233107,
                                                        55.170408
                                                ],
                                                [
                                                        25.241366,
                                                        55.197592
                                                ],
                                                [
                                                        25.211787,
                                                        55.213712
                                                ],
                                                [
                                                        25.177359,
                                                        55.208532
                                                ],
                                                [
                                                        25.157179,
                                                        55.22187
                                                ],
                                                [
                                                        25.178085,
                                                        55.237192
                                                ],
                                                [
                                                        25.185915,
                                                        55.261698
                                                ],
                                                [
                                                        25.171989,
                                                        55.266839
                                                ],
                                                [
                                                        25.141668,
                                                        55.257459
                                                ],
                                                [
                                                        25.106421,
                                                        55.265105
                                                ],
                                                [
                                                        25.1112,
                                                        55.280724
                                                ],
                                                [
                                                        25.080399,
                                                        55.294535
                                                ],
                                                [
                                                        25.072721,
                                                        55.313553
                                                ],
                                                [
                                                        25.124454,
                                                        55.321032
                                                ],
                                                [
                                                        25.10924,
                                                        55.345429
                                                ],
                                                [
                                                        25.082489,
                                                        55.349361
                                                ],
                                                [
                                                        25.077669,
                                                        55.360009
                                                ],
                                                [
                                                        25.112946,
                                                        55.376511
                                                ],
                                                [
                                                        25.149185,
                                                        55.369712
                                                ],
                                                [
                                                        25.171087,
                                                        55.385392
                                                ],
                                                [
                                                        25.167068,
                                                        55.394337
                                                ],
                                                [
                                                        25.190648,
                                                        55.407703
                                                ],
                                                [
                                                        25.217197,
                                                        55.404946
                                                ],
                                                [
                                                        25.261343,
                                                        55.386017
                                                ],
                                                [
                                                        25.329007,
                                                        55.395037
                                                ],
                                                [
                                                        25.368131,
                                                        55.389028
                                                ],
                                                [
                                                        25.38906,
                                                        55.423133
                                                ],
                                                [
                                                        25.418835,
                                                        55.420074
                                                ],
                                                [
                                                        25.436808,
                                                        55.403937
                                                ],
                                                [
                                                        25.476041,
                                                        55.403606
                                                ],
                                                [
                                                        25.503972,
                                                        55.384803
                                                ],
                                                [
                                                        25.520048,
                                                        55.393227
                                                ],
                                                [
                                                        25.549329,
                                                        55.377596
                                                ],
                                                [
                                                        25.567999,
                                                        55.386635
                                                ],
                                                [
                                                        25.606076,
                                                        55.380915
                                                ],
                                                [
                                                        25.622535,
                                                        55.384344
                                                ],
                                                [
                                                        25.650366,
                                                        55.371476
                                                ],
                                                [
                                                        25.665488,
                                                        55.376264
                                                ],
                                                [
                                                        25.713564,
                                                        55.370952
                                                ],
                                                [
                                                        25.755201,
                                                        55.358813
                                                ],
                                                [
                                                        25.754935,
                                                        55.344809
                                                ],
                                                [
                                                        25.725149,
                                                        55.314348
                                                ],
                                                [
                                                        25.734141,
                                                        55.305915
                                                ],
                                                [
                                                        25.726965,
                                                        55.290674
                                                ],
                                                [
                                                        25.702885,
                                                        55.266556
                                                ],
                                                [
                                                        25.683844,
                                                        55.260513
                                                ],
                                                [
                                                        25.663019,
                                                        55.232684
                                                ],
                                                [
                                                        25.665405,
                                                        55.221042
                                                ],
                                                [
                                                        25.648727,
                                                        55.204201
                                                ],
                                                [
                                                        25.654935,
                                                        55.182686
                                                ],
                                                [
                                                        25.708032,
                                                        55.172574
                                                ],
                                                [
                                                        25.707093,
                                                        55.142993
                                                ],
                                                [
                                                        25.751253,
                                                        55.133382
                                                ],
                                                [
                                                        25.78145,
                                                        55.114558
                                                ],
                                                [
                                                        25.765831,
                                                        55.093997
                                                ],
                                                [
                                                        25.747422,
                                                        55.088446
                                                ],
                                                [
                                                        25.755846,
                                                        55.073102
                                                ],
                                                [
                                                        25.74311,
                                                        55.062462
                                                ],
                                                [
                                                        25.735496,
                                                        55.035944
                                                ],
                                                [
                                                        25.665949,
                                                        55.042226
                                                ],
                                                [
                                                        25.655968,
                                                        55.059849
                                                ],
                                                [
                                                        25.580062,
                                                        55.061337
                                                ],
                                                [
                                                        25.573878,
                                                        55.048532
                                                ],
                                                [
                                                        25.535739,
                                                        55.054096
                                                ],
                                                [
                                                        25.526205,
                                                        55.04086
                                                ]
                                        ]
                                ]
                        },
                        "properties": {
                                "longName": "Mol\u0117t\u0173 rajonas",
                                "name": "Mol\u0117t\u0173 r. sav.",
                                "id": "62",
                                "osmId": 365542,
                                "org_id": 26
                        },
                        "id": "62"
                },
                {
                        "type": "Feature",
                        "geometry": {
                                "type": "Polygon",
                                "coordinates": [
                                        [
                                                [
                                                        24.715099,
                                                        55.720956
                                                ],
                                                [
                                                        24.791227,
                                                        55.710581
                                                ],
                                                [
                                                        24.828145,
                                                        55.723491
                                                ],
                                                [
                                                        24.862781,
                                                        55.70902
                                                ],
                                                [
                                                        24.869128,
                                                        55.720682
                                                ],
                                                [
                                                        24.950266,
                                                        55.723762
                                                ],
                                                [
                                                        24.969363,
                                                        55.734845
                                                ],
                                                [
                                                        25.009163,
                                                        55.732745
                                                ],
                                                [
                                                        25.085688,
                                                        55.715535
                                                ],
                                                [
                                                        25.098179,
                                                        55.683
                                                ],
                                                [
                                                        25.239325,
                                                        55.714078
                                                ],
                                                [
                                                        25.267318,
                                                        55.717944
                                                ],
                                                [
                                                        25.300695,
                                                        55.7024
                                                ],
                                                [
                                                        25.295177,
                                                        55.733708
                                                ],
                                                [
                                                        25.333622,
                                                        55.734484
                                                ],
                                                [
                                                        25.364793,
                                                        55.761779
                                                ],
                                                [
                                                        25.390616,
                                                        55.764124
                                                ],
                                                [
                                                        25.465021,
                                                        55.732614
                                                ],
                                                [
                                                        25.474032,
                                                        55.743957
                                                ],
                                                [
                                                        25.503698,
                                                        55.737402
                                                ],
                                                [
                                                        25.519145,
                                                        55.720467
                                                ],
                                                [
                                                        25.495127,
                                                        55.699322
                                                ],
                                                [
                                                        25.499934,
                                                        55.68103
                                                ],
                                                [
                                                        25.485511,
                                                        55.664085
                                                ],
                                                [
                                                        25.454938,
                                                        55.642613
                                                ],
                                                [
                                                        25.494772,
                                                        55.630403
                                                ],
                                                [
                                                        25.485031,
                                                        55.601901
                                                ],
                                                [
                                                        25.433567,
                                                        55.595747
                                                ],
                                                [
                                                        25.41717,
                                                        55.581376
                                                ],
                                                [
                                                        25.429981,
                                                        55.557093
                                                ],
                                                [
                                                        25.407872,
                                                        55.550551
                                                ],
                                                [
                                                        25.423178,
                                                        55.530584
                                                ],
                                                [
                                                        25.393807,
                                                        55.493974
                                                ],
                                                [
                                                        25.362637,
                                                        55.482642
                                                ],
                                                [
                                                        25.387106,
                                                        55.457792
                                                ],
                                                [
                                                        25.374133,
                                                        55.450739
                                                ],
                                                [
                                                        25.365893,
                                                        55.423573
                                                ],
                                                [
                                                        25.38906,
                                                        55.423133
                                                ],
                                                [
                                                        25.368131,
                                                        55.389028
                                                ],
                                                [
                                                        25.329007,
                                                        55.395037
                                                ],
                                                [
                                                        25.261343,
                                                        55.386017
                                                ],
                                                [
                                                        25.217197,
                                                        55.404946
                                                ],
                                                [
                                                        25.190648,
                                                        55.407703
                                                ],
                                                [
                                                        25.167068,
                                                        55.394337
                                                ],
                                                [
                                                        25.171087,
                                                        55.385392
                                                ],
                                                [
                                                        25.149185,
                                                        55.369712
                                                ],
                                                [
                                                        25.112946,
                                                        55.376511
                                                ],
                                                [
                                                        25.077669,
                                                        55.360009
                                                ],
                                                [
                                                        25.082489,
                                                        55.349361
                                                ],
                                                [
                                                        25.10924,
                                                        55.345429
                                                ],
                                                [
                                                        25.124454,
                                                        55.321032
                                                ],
                                                [
                                                        25.072721,
                                                        55.313553
                                                ],
                                                [
                                                        25.065308,
                                                        55.30838
                                                ],
                                                [
                                                        25.006415,
                                                        55.3139
                                                ],
                                                [
                                                        24.982569,
                                                        55.312786
                                                ],
                                                [
                                                        24.967093,
                                                        55.356254
                                                ],
                                                [
                                                        24.904856,
                                                        55.339694
                                                ],
                                                [
                                                        24.901024,
                                                        55.357057
                                                ],
                                                [
                                                        24.873163,
                                                        55.359558
                                                ],
                                                [
                                                        24.851965,
                                                        55.352369
                                                ],
                                                [
                                                        24.792766,
                                                        55.373635
                                                ],
                                                [
                                                        24.78436,
                                                        55.381621
                                                ],
                                                [
                                                        24.782962,
                                                        55.40956
                                                ],
                                                [
                                                        24.820176,
                                                        55.438226
                                                ],
                                                [
                                                        24.784573,
                                                        55.451894
                                                ],
                                                [
                                                        24.772219,
                                                        55.479615
                                                ],
                                                [
                                                        24.743377,
                                                        55.478678
                                                ],
                                                [
                                                        24.733032,
                                                        55.49319
                                                ],
                                                [
                                                        24.696353,
                                                        55.506633
                                                ],
                                                [
                                                        24.662577,
                                                        55.498018
                                                ],
                                                [
                                                        24.65437,
                                                        55.517724
                                                ],
                                                [
                                                        24.673307,
                                                        55.546025
                                                ],
                                                [
                                                        24.663559,
                                                        55.563548
                                                ],
                                                [
                                                        24.677643,
                                                        55.601175
                                                ],
                                                [
                                                        24.725221,
                                                        55.609625
                                                ],
                                                [
                                                        24.72092,
                                                        55.63454
                                                ],
                                                [
                                                        24.693442,
                                                        55.656233
                                                ],
                                                [
                                                        24.678437,
                                                        55.645782
                                                ],
                                                [
                                                        24.65786,
                                                        55.648409
                                                ],
                                                [
                                                        24.655268,
                                                        55.664978
                                                ],
                                                [
                                                        24.690839,
                                                        55.669358
                                                ],
                                                [
                                                        24.727638,
                                                        55.65563
                                                ],
                                                [
                                                        24.743065,
                                                        55.670677
                                                ],
                                                [
                                                        24.718597,
                                                        55.681249
                                                ],
                                                [
                                                        24.723262,
                                                        55.705671
                                                ],
                                                [
                                                        24.715099,
                                                        55.720956
                                                ]
                                        ]
                                ]
                        },
                        "properties": {
                                "longName": "Anyk\u0161\u010di\u0173 rajonas",
                                "name": "Anyk\u0161\u010di\u0173 r. sav.",
                                "id": "34",
                                "osmId": 365543,
                                "org_id": 3
                        },
                        "id": "34"
                },
                {
                        "type": "Feature",
                        "geometry": {
                                "type": "Polygon",
                                "coordinates": [
                                        [
                                                [
                                                        21.103583,
                                                        55.667253
                                                ],
                                                [
                                                        21.093868805873363,
                                                        55.722199868924115
                                                ],
                                                [
                                                        21.08530019412664,
                                                        55.73240463349396
                                                ],
                                                [
                                                        21.075258,
                                                        55.77419
                                                ],
                                                [
                                                        21.118405,
                                                        55.780864
                                                ],
                                                [
                                                        21.165536,
                                                        55.760806
                                                ],
                                                [
                                                        21.241092,
                                                        55.649311
                                                ],
                                                [
                                                        21.172065,
                                                        55.635203
                                                ],
                                                [
                                                        21.15701224637553,
                                                        55.63424233695843
                                                ],
                                                [
                                                        21.14262042906113,
                                                        55.661175922267795
                                                ],
                                                [
                                                        21.14477375260553,
                                                        55.67553951368958
                                                ],
                                                [
                                                        21.103583,
                                                        55.667253
                                                ]
                                        ]
                                ]
                        },
                        "properties": {
                                "longName": "Klaip\u0117dos m. savivaldyb\u0117",
                                "name": "Klaip\u0117dos m. sav.",
                                "id": "21",
                                "osmId": 365544,
                                "org_id": 19
                        },
                        "id": "21"
                },
                {
                        "type": "Feature",
                        "geometry": {
                                "type": "Polygon",
                                "coordinates": [
                                        [
                                                [
                                                        25.146146,
                                                        54.490753
                                                ],
                                                [
                                                        25.156385,
                                                        54.471968
                                                ],
                                                [
                                                        25.186639,
                                                        54.486694
                                                ],
                                                [
                                                        25.212426,
                                                        54.507034
                                                ],
                                                [
                                                        25.232069,
                                                        54.488258
                                                ],
                                                [
                                                        25.221253,
                                                        54.475534
                                                ],
                                                [
                                                        25.24162,
                                                        54.46419
                                                ],
                                                [
                                                        25.30479,
                                                        54.464671
                                                ],
                                                [
                                                        25.319236,
                                                        54.470224
                                                ],
                                                [
                                                        25.318656,
                                                        54.493799
                                                ],
                                                [
                                                        25.334625,
                                                        54.497827
                                                ],
                                                [
                                                        25.408361,
                                                        54.499694
                                                ],
                                                [
                                                        25.422195,
                                                        54.488658
                                                ],
                                                [
                                                        25.445369,
                                                        54.503644
                                                ],
                                                [
                                                        25.490941,
                                                        54.480995
                                                ],
                                                [
                                                        25.51661,
                                                        54.481582
                                                ],
                                                [
                                                        25.526822,
                                                        54.468376
                                                ],
                                                [
                                                        25.573835,
                                                        54.470929
                                                ],
                                                [
                                                        25.576547,
                                                        54.478033
                                                ],
                                                [
                                                        25.626399,
                                                        54.490119
                                                ],
                                                [
                                                        25.638641,
                                                        54.476816
                                                ],
                                                [
                                                        25.602473,
                                                        54.460902
                                                ],
                                                [
                                                        25.620206,
                                                        54.450415
                                                ],
                                                [
                                                        25.633822,
                                                        54.423397
                                                ],
                                                [
                                                        25.60565,
                                                        54.396459
                                                ],
                                                [
                                                        25.586635,
                                                        54.391635
                                                ],
                                                [
                                                        25.594281,
                                                        54.375325
                                                ],
                                                [
                                                        25.56253,
                                                        54.36164
                                                ],
                                                [
                                                        25.55738,
                                                        54.34395
                                                ],
                                                [
                                                        25.53185,
                                                        54.341914
                                                ],
                                                [
                                                        25.55497,
                                                        54.31374
                                                ],
                                                [
                                                        25.58742,
                                                        54.3231
                                                ],
                                                [
                                                        25.61832,
                                                        54.31023
                                                ],
                                                [
                                                        25.64467,
                                                        54.3116
                                                ],
                                                [
                                                        25.67709,
                                                        54.3239
                                                ],
                                                [
                                                        25.710792,
                                                        54.297
                                                ],
                                                [
                                                        25.698708,
                                                        54.280604
                                                ],
                                                [
                                                        25.750643,
                                                        54.268144
                                                ],
                                                [
                                                        25.756906,
                                                        54.251704
                                                ],
                                                [
                                                        25.785632,
                                                        54.233658
                                                ],
                                                [
                                                        25.750006,
                                                        54.22197
                                                ],
                                                [
                                                        25.780426,
                                                        54.193771
                                                ],
                                                [
                                                        25.78225,
                                                        54.16019
                                                ],
                                                [
                                                        25.724451,
                                                        54.162909
                                                ],
                                                [
                                                        25.710543,
                                                        54.169433
                                                ],
                                                [
                                                        25.687321,
                                                        54.15508
                                                ],
                                                [
                                                        25.684947,
                                                        54.140813
                                                ],
                                                [
                                                        25.662311,
                                                        54.140534
                                                ],
                                                [
                                                        25.65162,
                                                        54.12947
                                                ],
                                                [
                                                        25.62544,
                                                        54.14337
                                                ],
                                                [
                                                        25.533984,
                                                        54.156126
                                                ],
                                                [
                                                        25.513689,
                                                        54.181079
                                                ],
                                                [
                                                        25.56167,
                                                        54.1977
                                                ],
                                                [
                                                        25.56579,
                                                        54.21135
                                                ],
                                                [
                                                        25.54931,
                                                        54.21993
                                                ],
                                                [
                                                        25.56639,
                                                        54.2316
                                                ],
                                                [
                                                        25.57634,
                                                        54.254
                                                ],
                                                [
                                                        25.55428,
                                                        54.273997
                                                ],
                                                [
                                                        25.52034,
                                                        54.280933
                                                ],
                                                [
                                                        25.511452,
                                                        54.301158
                                                ],
                                                [
                                                        25.496866,
                                                        54.309921
                                                ],
                                                [
                                                        25.466062,
                                                        54.289914
                                                ],
                                                [
                                                        25.455374,
                                                        54.298058
                                                ],
                                                [
                                                        25.381015,
                                                        54.278084
                                                ],
                                                [
                                                        25.354375,
                                                        54.264599
                                                ],
                                                [
                                                        25.28752,
                                                        54.26491
                                                ],
                                                [
                                                        25.268928,
                                                        54.274825
                                                ],
                                                [
                                                        25.251619,
                                                        54.251188
                                                ],
                                                [
                                                        25.234367,
                                                        54.263464
                                                ],
                                                [
                                                        25.21461,
                                                        54.255916
                                                ],
                                                [
                                                        25.202536,
                                                        54.221103
                                                ],
                                                [
                                                        25.188619,
                                                        54.208845
                                                ],
                                                [
                                                        25.16119,
                                                        54.199652
                                                ],
                                                [
                                                        25.090792,
                                                        54.14575
                                                ],
                                                [
                                                        25.069631,
                                                        54.133179
                                                ],
                                                [
                                                        25.014121,
                                                        54.137203
                                                ],
                                                [
                                                        24.983369,
                                                        54.148499
                                                ],
                                                [
                                                        24.981335,
                                                        54.160135
                                                ],
                                                [
                                                        24.955928,
                                                        54.171268
                                                ],
                                                [
                                                        24.86362,
                                                        54.146723
                                                ],
                                                [
                                                        24.834594,
                                                        54.148709
                                                ],
                                                [
                                                        24.815852,
                                                        54.166931
                                                ],
                                                [
                                                        24.815289,
                                                        54.186795
                                                ],
                                                [
                                                        24.756897,
                                                        54.199424
                                                ],
                                                [
                                                        24.753709,
                                                        54.223284
                                                ],
                                                [
                                                        24.784943,
                                                        54.234276
                                                ],
                                                [
                                                        24.81191,
                                                        54.232992
                                                ],
                                                [
                                                        24.821049,
                                                        54.245506
                                                ],
                                                [
                                                        24.854548,
                                                        54.256138
                                                ],
                                                [
                                                        24.878977,
                                                        54.293382
                                                ],
                                                [
                                                        24.932252,
                                                        54.294744
                                                ],
                                                [
                                                        24.910606,
                                                        54.361261
                                                ],
                                                [
                                                        24.922541,
                                                        54.374902
                                                ],
                                                [
                                                        24.997701,
                                                        54.384134
                                                ],
                                                [
                                                        25.017442,
                                                        54.398457
                                                ],
                                                [
                                                        25.009197,
                                                        54.422943
                                                ],
                                                [
                                                        25.019632,
                                                        54.441528
                                                ],
                                                [
                                                        25.072095,
                                                        54.452375
                                                ],
                                                [
                                                        25.068259,
                                                        54.472624
                                                ],
                                                [
                                                        25.146146,
                                                        54.490753
                                                ]
                                        ]
                                ]
                        },
                        "properties": {
                                "longName": "\u0160al\u010dinink\u0173 rajonas",
                                "name": "\u0160al\u010dinink\u0173 r. sav.",
                                "id": "85",
                                "osmId": 365545,
                                "org_id": 42
                        },
                        "id": "85"
                },
                {
                        "type": "Feature",
                        "geometry": {
                                "type": "Polygon",
                                "coordinates": [
                                        [
                                                [
                                                        24.589553,
                                                        55.086972
                                                ],
                                                [
                                                        24.603014,
                                                        55.086872
                                                ],
                                                [
                                                        24.645933,
                                                        55.111347
                                                ],
                                                [
                                                        24.65765,
                                                        55.098576
                                                ],
                                                [
                                                        24.703923,
                                                        55.093637
                                                ],
                                                [
                                                        24.728271,
                                                        55.10789
                                                ],
                                                [
                                                        24.754318,
                                                        55.114385
                                                ],
                                                [
                                                        24.826408,
                                                        55.112771
                                                ],
                                                [
                                                        24.841923,
                                                        55.103419
                                                ],
                                                [
                                                        24.883649,
                                                        55.103652
                                                ],
                                                [
                                                        24.947887,
                                                        55.118592
                                                ],
                                                [
                                                        24.947073,
                                                        55.130891
                                                ],
                                                [
                                                        25.017633,
                                                        55.155375
                                                ],
                                                [
                                                        25.054995,
                                                        55.151792
                                                ],
                                                [
                                                        25.10715,
                                                        55.126989
                                                ],
                                                [
                                                        25.152146,
                                                        55.13961
                                                ],
                                                [
                                                        25.167252,
                                                        55.152414
                                                ],
                                                [
                                                        25.162327,
                                                        55.119315
                                                ],
                                                [
                                                        25.149104,
                                                        55.112175
                                                ],
                                                [
                                                        25.163559,
                                                        55.097516
                                                ],
                                                [
                                                        25.202981,
                                                        55.0962
                                                ],
                                                [
                                                        25.221987,
                                                        55.08896
                                                ],
                                                [
                                                        25.22594,
                                                        55.069916
                                                ],
                                                [
                                                        25.213937,
                                                        55.054518
                                                ],
                                                [
                                                        25.222264,
                                                        55.042678
                                                ],
                                                [
                                                        25.18709,
                                                        55.033024
                                                ],
                                                [
                                                        25.200548,
                                                        54.995687
                                                ],
                                                [
                                                        25.180976,
                                                        54.958533
                                                ],
                                                [
                                                        25.159394,
                                                        54.965475
                                                ],
                                                [
                                                        25.13552,
                                                        54.935355
                                                ],
                                                [
                                                        25.147949,
                                                        54.906247
                                                ],
                                                [
                                                        25.11636,
                                                        54.902823
                                                ],
                                                [
                                                        25.127101,
                                                        54.888781
                                                ],
                                                [
                                                        25.115825,
                                                        54.880472
                                                ],
                                                [
                                                        25.079175,
                                                        54.888298
                                                ],
                                                [
                                                        25.048,
                                                        54.883
                                                ],
                                                [
                                                        24.970253,
                                                        54.880848
                                                ],
                                                [
                                                        24.960743,
                                                        54.867948
                                                ],
                                                [
                                                        24.900681,
                                                        54.879413
                                                ],
                                                [
                                                        24.865646,
                                                        54.87559
                                                ],
                                                [
                                                        24.85338,
                                                        54.859237
                                                ],
                                                [
                                                        24.848527,
                                                        54.873759
                                                ],
                                                [
                                                        24.810257,
                                                        54.890007
                                                ],
                                                [
                                                        24.811592,
                                                        54.903024
                                                ],
                                                [
                                                        24.766294,
                                                        54.918243
                                                ],
                                                [
                                                        24.74876,
                                                        54.9316
                                                ],
                                                [
                                                        24.689536,
                                                        54.927754
                                                ],
                                                [
                                                        24.6837,
                                                        54.942941
                                                ],
                                                [
                                                        24.649928,
                                                        54.951605
                                                ],
                                                [
                                                        24.6192,
                                                        54.974448
                                                ],
                                                [
                                                        24.581218,
                                                        54.973102
                                                ],
                                                [
                                                        24.551775,
                                                        54.99068
                                                ],
                                                [
                                                        24.559458,
                                                        55.00449
                                                ],
                                                [
                                                        24.58802,
                                                        55.012883
                                                ],
                                                [
                                                        24.585094,
                                                        55.028365
                                                ],
                                                [
                                                        24.621487,
                                                        55.030585
                                                ],
                                                [
                                                        24.635556,
                                                        55.04354
                                                ],
                                                [
                                                        24.628518,
                                                        55.062321
                                                ],
                                                [
                                                        24.589553,
                                                        55.086972
                                                ]
                                        ]
                                ]
                        },
                        "properties": {
                                "longName": "\u0160irvint\u0173 rajonas",
                                "name": "\u0160irvint\u0173 r. sav.",
                                "id": "89",
                                "osmId": 365546,
                                "org_id": 47
                        },
                        "id": "89"
                },
                {
                        "type": "Feature",
                        "geometry": {
                                "type": "Polygon",
                                "coordinates": [
                                        [
                                                [
                                                        24.437462,
                                                        54.425445
                                                ],
                                                [
                                                        24.416995,
                                                        54.435903
                                                ],
                                                [
                                                        24.438418,
                                                        54.451595
                                                ],
                                                [
                                                        24.433891,
                                                        54.463823
                                                ],
                                                [
                                                        24.393822,
                                                        54.483315
                                                ],
                                                [
                                                        24.418901,
                                                        54.489876
                                                ],
                                                [
                                                        24.404361,
                                                        54.518938
                                                ],
                                                [
                                                        24.414168,
                                                        54.533019
                                                ],
                                                [
                                                        24.423232,
                                                        54.587892
                                                ],
                                                [
                                                        24.456435,
                                                        54.595094
                                                ],
                                                [
                                                        24.473466,
                                                        54.61781
                                                ],
                                                [
                                                        24.457257,
                                                        54.631247
                                                ],
                                                [
                                                        24.470446,
                                                        54.641447
                                                ],
                                                [
                                                        24.529855,
                                                        54.654155
                                                ],
                                                [
                                                        24.580933,
                                                        54.645227
                                                ],
                                                [
                                                        24.608044,
                                                        54.652156
                                                ],
                                                [
                                                        24.64417,
                                                        54.651853
                                                ],
                                                [
                                                        24.672265,
                                                        54.643214
                                                ],
                                                [
                                                        24.702783,
                                                        54.653845
                                                ],
                                                [
                                                        24.775417,
                                                        54.639909
                                                ],
                                                [
                                                        24.802965,
                                                        54.657107
                                                ],
                                                [
                                                        24.815893,
                                                        54.690447
                                                ],
                                                [
                                                        24.846245,
                                                        54.706428
                                                ],
                                                [
                                                        24.865295,
                                                        54.72729
                                                ],
                                                [
                                                        24.925094,
                                                        54.722059
                                                ],
                                                [
                                                        24.94815,
                                                        54.72432
                                                ],
                                                [
                                                        24.974695,
                                                        54.737304
                                                ],
                                                [
                                                        25.017557,
                                                        54.739074
                                                ],
                                                [
                                                        25.027374,
                                                        54.720411
                                                ],
                                                [
                                                        25.049338,
                                                        54.721819
                                                ],
                                                [
                                                        25.075508,
                                                        54.703444
                                                ],
                                                [
                                                        25.071019,
                                                        54.690289
                                                ],
                                                [
                                                        25.081535,
                                                        54.663376
                                                ],
                                                [
                                                        25.076861,
                                                        54.639986
                                                ],
                                                [
                                                        25.024535,
                                                        54.623194
                                                ],
                                                [
                                                        25.066091,
                                                        54.61973
                                                ],
                                                [
                                                        25.078418,
                                                        54.599229
                                                ],
                                                [
                                                        25.02874,
                                                        54.556293
                                                ],
                                                [
                                                        25.039748,
                                                        54.552291
                                                ],
                                                [
                                                        25.107463,
                                                        54.549978
                                                ],
                                                [
                                                        25.142039,
                                                        54.539008
                                                ],
                                                [
                                                        25.165508,
                                                        54.539934
                                                ],
                                                [
                                                        25.167629,
                                                        54.523721
                                                ],
                                                [
                                                        25.146146,
                                                        54.490753
                                                ],
                                                [
                                                        25.068259,
                                                        54.472624
                                                ],
                                                [
                                                        25.072095,
                                                        54.452375
                                                ],
                                                [
                                                        25.019632,
                                                        54.441528
                                                ],
                                                [
                                                        24.962799,
                                                        54.43418
                                                ],
                                                [
                                                        24.902661,
                                                        54.418733
                                                ],
                                                [
                                                        24.873833,
                                                        54.415127
                                                ],
                                                [
                                                        24.828476,
                                                        54.400522
                                                ],
                                                [
                                                        24.803249,
                                                        54.405397
                                                ],
                                                [
                                                        24.74475,
                                                        54.398656
                                                ],
                                                [
                                                        24.722802,
                                                        54.388601
                                                ],
                                                [
                                                        24.707007,
                                                        54.408528
                                                ],
                                                [
                                                        24.721258,
                                                        54.429364
                                                ],
                                                [
                                                        24.689374,
                                                        54.432484
                                                ],
                                                [
                                                        24.66848,
                                                        54.447593
                                                ],
                                                [
                                                        24.655497,
                                                        54.439273
                                                ],
                                                [
                                                        24.619683,
                                                        54.441092
                                                ],
                                                [
                                                        24.584581,
                                                        54.413069
                                                ],
                                                [
                                                        24.539962,
                                                        54.417393
                                                ],
                                                [
                                                        24.546084,
                                                        54.429595
                                                ],
                                                [
                                                        24.503107,
                                                        54.427819
                                                ],
                                                [
                                                        24.4881,
                                                        54.421935
                                                ],
                                                [
                                                        24.437462,
                                                        54.425445
                                                ]
                                        ]
                                ]
                        },
                        "properties": {
                                "longName": "Trak\u0173 rajonas",
                                "name": "Trak\u0173 r. sav.",
                                "id": "79",
                                "osmId": 365547,
                                "org_id": 51
                        },
                        "id": "79"
                },
                {
                        "type": "Feature",
                        "geometry": {
                                "type": "Polygon",
                                "coordinates": [
                                        [
                                                [
                                                        21.092609,
                                                        55.861105
                                                ],
                                                [
                                                        21.081665,
                                                        55.863632
                                                ],
                                                [
                                                        21.08273,
                                                        55.862039
                                                ],
                                                [
                                                        21.058411,
                                                        55.854593
                                                ],
                                                [
                                                        21.051457,
                                                        55.879608
                                                ],
                                                [
                                                        21.048814,
                                                        55.920122
                                                ],
                                                [
                                                        21.067405,
                                                        55.958902
                                                ],
                                                [
                                                        21.072152,
                                                        56.035258
                                                ],
                                                [
                                                        21.064623,
                                                        56.069205
                                                ],
                                                [
                                                        21.122569,
                                                        56.077102
                                                ],
                                                [
                                                        21.119131,
                                                        56.032514
                                                ],
                                                [
                                                        21.127029,
                                                        55.976841
                                                ],
                                                [
                                                        21.127151,
                                                        55.937211
                                                ],
                                                [
                                                        21.105508,
                                                        55.927286
                                                ],
                                                [
                                                        21.100829,
                                                        55.891953
                                                ],
                                                [
                                                        21.090966,
                                                        55.872282
                                                ],
                                                [
                                                        21.090238,
                                                        55.870265
                                                ],
                                                [
                                                        21.090096,
                                                        55.867702
                                                ],
                                                [
                                                        21.091288,
                                                        55.864308
                                                ],
                                                [
                                                        21.093114,
                                                        55.861977
                                                ],
                                                [
                                                        21.092609,
                                                        55.861105
                                                ]
                                        ]
                                ]
                        },
                        "properties": {
                                "longName": "Palangos miesto savivaldyb\u0117",
                                "name": "Palangos m. sav.",
                                "id": "25",
                                "osmId": 365548,
                                "org_id": 30
                        },
                        "id": "25"
                },
                {
                        "type": "Feature",
                        "geometry": {
                                "type": "Polygon",
                                "coordinates": [
                                        [
                                                [
                                                        21.122569,
                                                        56.077102
                                                ],
                                                [
                                                        21.162333,
                                                        56.085694
                                                ],
                                                [
                                                        21.200529,
                                                        56.076629
                                                ],
                                                [
                                                        21.233971,
                                                        56.115093
                                                ],
                                                [
                                                        21.238999,
                                                        56.12947
                                                ],
                                                [
                                                        21.227887,
                                                        56.146563
                                                ],
                                                [
                                                        21.237569,
                                                        56.136905
                                                ],
                                                [
                                                        21.265096,
                                                        56.138644
                                                ],
                                                [
                                                        21.307783,
                                                        56.130413
                                                ],
                                                [
                                                        21.322731,
                                                        56.15213
                                                ],
                                                [
                                                        21.408,
                                                        56.134891
                                                ],
                                                [
                                                        21.412373,
                                                        56.141174
                                                ],
                                                [
                                                        21.472285,
                                                        56.130691
                                                ],
                                                [
                                                        21.464758,
                                                        56.11983
                                                ],
                                                [
                                                        21.534539,
                                                        56.105251
                                                ],
                                                [
                                                        21.593594,
                                                        56.10798
                                                ],
                                                [
                                                        21.622152,
                                                        56.102425
                                                ],
                                                [
                                                        21.61885,
                                                        56.091319
                                                ],
                                                [
                                                        21.644968,
                                                        56.081933
                                                ],
                                                [
                                                        21.699821,
                                                        56.069965
                                                ],
                                                [
                                                        21.677993,
                                                        56.038741
                                                ],
                                                [
                                                        21.666041,
                                                        56.03923
                                                ],
                                                [
                                                        21.638582,
                                                        56.003039
                                                ],
                                                [
                                                        21.625393,
                                                        55.996326
                                                ],
                                                [
                                                        21.58624,
                                                        56.001512
                                                ],
                                                [
                                                        21.572279,
                                                        55.980246
                                                ],
                                                [
                                                        21.600511,
                                                        55.973963
                                                ],
                                                [
                                                        21.582119,
                                                        55.944403
                                                ],
                                                [
                                                        21.592783,
                                                        55.938604
                                                ],
                                                [
                                                        21.593282,
                                                        55.91687
                                                ],
                                                [
                                                        21.579714,
                                                        55.907076
                                                ],
                                                [
                                                        21.618057,
                                                        55.896868
                                                ],
                                                [
                                                        21.586185,
                                                        55.876038
                                                ],
                                                [
                                                        21.590652,
                                                        55.85953
                                                ],
                                                [
                                                        21.558753,
                                                        55.86226
                                                ],
                                                [
                                                        21.554219,
                                                        55.847223
                                                ],
                                                [
                                                        21.525699,
                                                        55.831996
                                                ],
                                                [
                                                        21.511854,
                                                        55.809066
                                                ],
                                                [
                                                        21.496928,
                                                        55.787512
                                                ],
                                                [
                                                        21.4742,
                                                        55.786431
                                                ],
                                                [
                                                        21.45338,
                                                        55.802704
                                                ],
                                                [
                                                        21.448625,
                                                        55.817434
                                                ],
                                                [
                                                        21.42206,
                                                        55.822725
                                                ],
                                                [
                                                        21.41165,
                                                        55.806369
                                                ],
                                                [
                                                        21.368526,
                                                        55.815557
                                                ],
                                                [
                                                        21.354046,
                                                        55.813156
                                                ],
                                                [
                                                        21.313173,
                                                        55.822049
                                                ],
                                                [
                                                        21.284766,
                                                        55.83946
                                                ],
                                                [
                                                        21.243844,
                                                        55.821061
                                                ],
                                                [
                                                        21.226572,
                                                        55.825619
                                                ],
                                                [
                                                        21.22078,
                                                        55.860379
                                                ],
                                                [
                                                        21.21642,
                                                        55.857341
                                                ],
                                                [
                                                        21.203044,
                                                        55.866978
                                                ],
                                                [
                                                        21.19869,
                                                        55.865763
                                                ],
                                                [
                                                        21.160449,
                                                        55.864959
                                                ],
                                                [
                                                        21.115895,
                                                        55.880912
                                                ],
                                                [
                                                        21.100829,
                                                        55.891953
                                                ],
                                                [
                                                        21.105508,
                                                        55.927286
                                                ],
                                                [
                                                        21.127151,
                                                        55.937211
                                                ],
                                                [
                                                        21.127029,
                                                        55.976841
                                                ],
                                                [
                                                        21.119131,
                                                        56.032514
                                                ],
                                                [
                                                        21.122569,
                                                        56.077102
                                                ]
                                        ]
                                ]
                        },
                        "properties": {
                                "longName": "Kretingos rajono savivaldyb\u0117",
                                "name": "Kretingos r. sav.",
                                "id": "56",
                                "osmId": 365549,
                                "org_id": 21
                        },
                        "id": "56"
                },
                {
                        "type": "Feature",
                        "geometry": {
                                "type": "Polygon",
                                "coordinates": [
                                        [
                                                [
                                                        24.589553,
                                                        55.086972
                                                ],
                                                [
                                                        24.584745,
                                                        55.105651
                                                ],
                                                [
                                                        24.557965,
                                                        55.106731
                                                ],
                                                [
                                                        24.546629,
                                                        55.123317
                                                ],
                                                [
                                                        24.521392,
                                                        55.140124
                                                ],
                                                [
                                                        24.519795,
                                                        55.154052
                                                ],
                                                [
                                                        24.500313,
                                                        55.160735
                                                ],
                                                [
                                                        24.480214,
                                                        55.200008
                                                ],
                                                [
                                                        24.505598,
                                                        55.222601
                                                ],
                                                [
                                                        24.445706,
                                                        55.233084
                                                ],
                                                [
                                                        24.409504,
                                                        55.234288
                                                ],
                                                [
                                                        24.425095,
                                                        55.259478
                                                ],
                                                [
                                                        24.413674,
                                                        55.288693
                                                ],
                                                [
                                                        24.392062,
                                                        55.294771
                                                ],
                                                [
                                                        24.38504,
                                                        55.329062
                                                ],
                                                [
                                                        24.434318,
                                                        55.386328
                                                ],
                                                [
                                                        24.43047,
                                                        55.390909
                                                ],
                                                [
                                                        24.454963,
                                                        55.401945
                                                ],
                                                [
                                                        24.486027,
                                                        55.40684
                                                ],
                                                [
                                                        24.550719,
                                                        55.426377
                                                ],
                                                [
                                                        24.534578,
                                                        55.446568
                                                ],
                                                [
                                                        24.554539,
                                                        55.460104
                                                ],
                                                [
                                                        24.603908,
                                                        55.451257
                                                ],
                                                [
                                                        24.649729,
                                                        55.462362
                                                ],
                                                [
                                                        24.64653,
                                                        55.49622
                                                ],
                                                [
                                                        24.628893,
                                                        55.510615
                                                ],
                                                [
                                                        24.65437,
                                                        55.517724
                                                ],
                                                [
                                                        24.662577,
                                                        55.498018
                                                ],
                                                [
                                                        24.696353,
                                                        55.506633
                                                ],
                                                [
                                                        24.733032,
                                                        55.49319
                                                ],
                                                [
                                                        24.743377,
                                                        55.478678
                                                ],
                                                [
                                                        24.772219,
                                                        55.479615
                                                ],
                                                [
                                                        24.784573,
                                                        55.451894
                                                ],
                                                [
                                                        24.820176,
                                                        55.438226
                                                ],
                                                [
                                                        24.782962,
                                                        55.40956
                                                ],
                                                [
                                                        24.78436,
                                                        55.381621
                                                ],
                                                [
                                                        24.792766,
                                                        55.373635
                                                ],
                                                [
                                                        24.851965,
                                                        55.352369
                                                ],
                                                [
                                                        24.873163,
                                                        55.359558
                                                ],
                                                [
                                                        24.901024,
                                                        55.357057
                                                ],
                                                [
                                                        24.904856,
                                                        55.339694
                                                ],
                                                [
                                                        24.967093,
                                                        55.356254
                                                ],
                                                [
                                                        24.982569,
                                                        55.312786
                                                ],
                                                [
                                                        25.006415,
                                                        55.3139
                                                ],
                                                [
                                                        25.065308,
                                                        55.30838
                                                ],
                                                [
                                                        25.072721,
                                                        55.313553
                                                ],
                                                [
                                                        25.080399,
                                                        55.294535
                                                ],
                                                [
                                                        25.1112,
                                                        55.280724
                                                ],
                                                [
                                                        25.106421,
                                                        55.265105
                                                ],
                                                [
                                                        25.141668,
                                                        55.257459
                                                ],
                                                [
                                                        25.171989,
                                                        55.266839
                                                ],
                                                [
                                                        25.185915,
                                                        55.261698
                                                ],
                                                [
                                                        25.178085,
                                                        55.237192
                                                ],
                                                [
                                                        25.157179,
                                                        55.22187
                                                ],
                                                [
                                                        25.177359,
                                                        55.208532
                                                ],
                                                [
                                                        25.211787,
                                                        55.213712
                                                ],
                                                [
                                                        25.241366,
                                                        55.197592
                                                ],
                                                [
                                                        25.233107,
                                                        55.170408
                                                ],
                                                [
                                                        25.190936,
                                                        55.154084
                                                ],
                                                [
                                                        25.167252,
                                                        55.152414
                                                ],
                                                [
                                                        25.152146,
                                                        55.13961
                                                ],
                                                [
                                                        25.10715,
                                                        55.126989
                                                ],
                                                [
                                                        25.054995,
                                                        55.151792
                                                ],
                                                [
                                                        25.017633,
                                                        55.155375
                                                ],
                                                [
                                                        24.947073,
                                                        55.130891
                                                ],
                                                [
                                                        24.947887,
                                                        55.118592
                                                ],
                                                [
                                                        24.883649,
                                                        55.103652
                                                ],
                                                [
                                                        24.841923,
                                                        55.103419
                                                ],
                                                [
                                                        24.826408,
                                                        55.112771
                                                ],
                                                [
                                                        24.754318,
                                                        55.114385
                                                ],
                                                [
                                                        24.728271,
                                                        55.10789
                                                ],
                                                [
                                                        24.703923,
                                                        55.093637
                                                ],
                                                [
                                                        24.65765,
                                                        55.098576
                                                ],
                                                [
                                                        24.645933,
                                                        55.111347
                                                ],
                                                [
                                                        24.603014,
                                                        55.086872
                                                ],
                                                [
                                                        24.589553,
                                                        55.086972
                                                ]
                                        ]
                                ]
                        },
                        "properties": {
                                "longName": "Ukmerg\u0117s rajonas",
                                "name": "Ukmerg\u0117s r. sav.",
                                "id": "81",
                                "osmId": 365550,
                                "org_id": 52
                        },
                        "id": "81"
                },
                {
                        "type": "Feature",
                        "geometry": {
                                "type": "Polygon",
                                "coordinates": [
                                        [
                                                [
                                                        24.43047,
                                                        55.390909
                                                ],
                                                [
                                                        24.399788,
                                                        55.392718
                                                ],
                                                [
                                                        24.384776,
                                                        55.413969
                                                ],
                                                [
                                                        24.384434,
                                                        55.435325
                                                ],
                                                [
                                                        24.318288,
                                                        55.445706
                                                ],
                                                [
                                                        24.301495,
                                                        55.438669
                                                ],
                                                [
                                                        24.242821,
                                                        55.453248
                                                ],
                                                [
                                                        24.242958,
                                                        55.466345
                                                ],
                                                [
                                                        24.201008,
                                                        55.475359
                                                ],
                                                [
                                                        24.200803,
                                                        55.450643
                                                ],
                                                [
                                                        24.163994,
                                                        55.451304
                                                ],
                                                [
                                                        24.1496,
                                                        55.437658
                                                ],
                                                [
                                                        24.120126,
                                                        55.438591
                                                ],
                                                [
                                                        24.11944,
                                                        55.450488
                                                ],
                                                [
                                                        24.063945,
                                                        55.438721
                                                ],
                                                [
                                                        24.038461,
                                                        55.443403
                                                ],
                                                [
                                                        24.0543,
                                                        55.475589
                                                ],
                                                [
                                                        24.039669,
                                                        55.479732
                                                ],
                                                [
                                                        24.002746,
                                                        55.514597
                                                ],
                                                [
                                                        23.957149,
                                                        55.503912
                                                ],
                                                [
                                                        23.940153,
                                                        55.510435
                                                ],
                                                [
                                                        23.911252,
                                                        55.540488
                                                ],
                                                [
                                                        23.914098,
                                                        55.563917
                                                ],
                                                [
                                                        23.879556,
                                                        55.557817
                                                ],
                                                [
                                                        23.898401,
                                                        55.573342
                                                ],
                                                [
                                                        23.91961,
                                                        55.604047
                                                ],
                                                [
                                                        23.925043,
                                                        55.626597
                                                ],
                                                [
                                                        23.973591,
                                                        55.616236
                                                ],
                                                [
                                                        23.982138,
                                                        55.628517
                                                ],
                                                [
                                                        24.014927,
                                                        55.627976
                                                ],
                                                [
                                                        24.038479,
                                                        55.635469
                                                ],
                                                [
                                                        24.012338,
                                                        55.672962
                                                ],
                                                [
                                                        24.031645,
                                                        55.690917
                                                ],
                                                [
                                                        24.058625,
                                                        55.68822
                                                ],
                                                [
                                                        24.062932,
                                                        55.704486
                                                ],
                                                [
                                                        24.029929,
                                                        55.71105
                                                ],
                                                [
                                                        24.046299,
                                                        55.745729
                                                ],
                                                [
                                                        24.031942,
                                                        55.745004
                                                ],
                                                [
                                                        24.016068,
                                                        55.783068
                                                ],
                                                [
                                                        23.988008,
                                                        55.78162
                                                ],
                                                [
                                                        23.969593,
                                                        55.797411
                                                ],
                                                [
                                                        23.960022,
                                                        55.835588
                                                ],
                                                [
                                                        23.97021,
                                                        55.841839
                                                ],
                                                [
                                                        24.014795,
                                                        55.838236
                                                ],
                                                [
                                                        24.035824,
                                                        55.850732
                                                ],
                                                [
                                                        24.03323,
                                                        55.863072
                                                ],
                                                [
                                                        24.0843,
                                                        55.879773
                                                ],
                                                [
                                                        24.10492,
                                                        55.880769
                                                ],
                                                [
                                                        24.113386,
                                                        55.840536
                                                ],
                                                [
                                                        24.176952,
                                                        55.840268
                                                ],
                                                [
                                                        24.208852,
                                                        55.864945
                                                ],
                                                [
                                                        24.206889,
                                                        55.888609
                                                ],
                                                [
                                                        24.239399,
                                                        55.887212
                                                ],
                                                [
                                                        24.246035,
                                                        55.904413
                                                ],
                                                [
                                                        24.280961,
                                                        55.906397
                                                ],
                                                [
                                                        24.356727,
                                                        55.892531
                                                ],
                                                [
                                                        24.363837,
                                                        55.916161
                                                ],
                                                [
                                                        24.393787,
                                                        55.920004
                                                ],
                                                [
                                                        24.396459,
                                                        55.899967
                                                ],
                                                [
                                                        24.418897,
                                                        55.902595
                                                ],
                                                [
                                                        24.424141,
                                                        55.862917
                                                ],
                                                [
                                                        24.551858,
                                                        55.874262
                                                ],
                                                [
                                                        24.566884,
                                                        55.889478
                                                ],
                                                [
                                                        24.52811,
                                                        55.892475
                                                ],
                                                [
                                                        24.542984,
                                                        55.913307
                                                ],
                                                [
                                                        24.560027,
                                                        55.908135
                                                ],
                                                [
                                                        24.585994,
                                                        55.915963
                                                ],
                                                [
                                                        24.581053,
                                                        55.928338
                                                ],
                                                [
                                                        24.607447,
                                                        55.935535
                                                ],
                                                [
                                                        24.626233,
                                                        55.923316
                                                ],
                                                [
                                                        24.626311,
                                                        55.903924
                                                ],
                                                [
                                                        24.652184,
                                                        55.911569
                                                ],
                                                [
                                                        24.681633,
                                                        55.936177
                                                ],
                                                [
                                                        24.715259,
                                                        55.922489
                                                ],
                                                [
                                                        24.721711,
                                                        55.879765
                                                ],
                                                [
                                                        24.741388,
                                                        55.871455
                                                ],
                                                [
                                                        24.739479,
                                                        55.850747
                                                ],
                                                [
                                                        24.755202,
                                                        55.838884
                                                ],
                                                [
                                                        24.758747,
                                                        55.82209
                                                ],
                                                [
                                                        24.738343,
                                                        55.810907
                                                ],
                                                [
                                                        24.743569,
                                                        55.787791
                                                ],
                                                [
                                                        24.705227,
                                                        55.778699
                                                ],
                                                [
                                                        24.686685,
                                                        55.767163
                                                ],
                                                [
                                                        24.690296,
                                                        55.742642
                                                ],
                                                [
                                                        24.715099,
                                                        55.720956
                                                ],
                                                [
                                                        24.723262,
                                                        55.705671
                                                ],
                                                [
                                                        24.718597,
                                                        55.681249
                                                ],
                                                [
                                                        24.743065,
                                                        55.670677
                                                ],
                                                [
                                                        24.727638,
                                                        55.65563
                                                ],
                                                [
                                                        24.690839,
                                                        55.669358
                                                ],
                                                [
                                                        24.655268,
                                                        55.664978
                                                ],
                                                [
                                                        24.65786,
                                                        55.648409
                                                ],
                                                [
                                                        24.678437,
                                                        55.645782
                                                ],
                                                [
                                                        24.693442,
                                                        55.656233
                                                ],
                                                [
                                                        24.72092,
                                                        55.63454
                                                ],
                                                [
                                                        24.725221,
                                                        55.609625
                                                ],
                                                [
                                                        24.677643,
                                                        55.601175
                                                ],
                                                [
                                                        24.663559,
                                                        55.563548
                                                ],
                                                [
                                                        24.673307,
                                                        55.546025
                                                ],
                                                [
                                                        24.65437,
                                                        55.517724
                                                ],
                                                [
                                                        24.628893,
                                                        55.510615
                                                ],
                                                [
                                                        24.64653,
                                                        55.49622
                                                ],
                                                [
                                                        24.649729,
                                                        55.462362
                                                ],
                                                [
                                                        24.603908,
                                                        55.451257
                                                ],
                                                [
                                                        24.554539,
                                                        55.460104
                                                ],
                                                [
                                                        24.534578,
                                                        55.446568
                                                ],
                                                [
                                                        24.550719,
                                                        55.426377
                                                ],
                                                [
                                                        24.486027,
                                                        55.40684
                                                ],
                                                [
                                                        24.454963,
                                                        55.401945
                                                ],
                                                [
                                                        24.43047,
                                                        55.390909
                                                ]
                                        ],
                                        [
                                                [
                                                        24.334054,
                                                        55.696958
                                                ],
                                                [
                                                        24.399629,
                                                        55.709403
                                                ],
                                                [
                                                        24.39574,
                                                        55.727904
                                                ],
                                                [
                                                        24.409173,
                                                        55.749556
                                                ],
                                                [
                                                        24.383666,
                                                        55.753897
                                                ],
                                                [
                                                        24.366008,
                                                        55.769349
                                                ],
                                                [
                                                        24.332337,
                                                        55.755604
                                                ],
                                                [
                                                        24.289765,
                                                        55.758019
                                                ],
                                                [
                                                        24.277921,
                                                        55.739565
                                                ],
                                                [
                                                        24.310708,
                                                        55.695183
                                                ],
                                                [
                                                        24.334054,
                                                        55.696958
                                                ]
                                        ]
                                ]
                        },
                        "properties": {
                                "longName": "Panev\u0117\u017eio rajonas",
                                "name": "Panev\u0117\u017eio r. sav.",
                                "id": "66",
                                "osmId": 365551,
                                "org_id": 32
                        },
                        "id": "66"
                },
                {
                        "type": "Feature",
                        "geometry": {
                                "type": "Polygon",
                                "coordinates": [
                                        [
                                                [
                                                        24.100556,
                                                        54.912693
                                                ],
                                                [
                                                        24.099,
                                                        54.911831
                                                ],
                                                [
                                                        24.079073,
                                                        54.91424
                                                ],
                                                [
                                                        24.051036,
                                                        54.899487
                                                ],
                                                [
                                                        24.014913,
                                                        54.858051
                                                ],
                                                [
                                                        24.010853,
                                                        54.842671
                                                ],
                                                [
                                                        23.988092,
                                                        54.834161
                                                ],
                                                [
                                                        23.95853,
                                                        54.836126
                                                ],
                                                [
                                                        23.935557,
                                                        54.83076
                                                ],
                                                [
                                                        23.927672,
                                                        54.850939
                                                ],
                                                [
                                                        23.884344,
                                                        54.856866
                                                ],
                                                [
                                                        23.880589,
                                                        54.846253
                                                ],
                                                [
                                                        23.842619,
                                                        54.850672
                                                ],
                                                [
                                                        23.829808,
                                                        54.868298
                                                ],
                                                [
                                                        23.868006,
                                                        54.876277
                                                ],
                                                [
                                                        23.864088,
                                                        54.897625
                                                ],
                                                [
                                                        23.820709,
                                                        54.90291
                                                ],
                                                [
                                                        23.77956,
                                                        54.918777
                                                ],
                                                [
                                                        23.812014,
                                                        54.945167
                                                ],
                                                [
                                                        23.85571,
                                                        54.941454
                                                ],
                                                [
                                                        23.880858,
                                                        54.953226
                                                ],
                                                [
                                                        23.913106,
                                                        54.959675
                                                ],
                                                [
                                                        23.946809,
                                                        54.959457
                                                ],
                                                [
                                                        23.978347,
                                                        54.9318
                                                ],
                                                [
                                                        24.068437,
                                                        54.926056
                                                ],
                                                [
                                                        24.100556,
                                                        54.912693
                                                ]
                                        ]
                                ]
                        },
                        "properties": {
                                "longName": "Kauno miesto savivaldyb\u0117",
                                "name": "Kauno m. sav.",
                                "id": "19",
                                "osmId": 365552,
                                "org_id": 14
                        },
                        "id": "19"
                },
                {
                        "type": "Feature",
                        "geometry": {
                                "type": "Polygon",
                                "coordinates": [
                                        [
                                                [
                                                        23.835587,
                                                        53.953805
                                                ],
                                                [
                                                        23.803733,
                                                        53.982168
                                                ],
                                                [
                                                        23.843807,
                                                        54.003866
                                                ],
                                                [
                                                        23.863159,
                                                        54.025038
                                                ],
                                                [
                                                        23.835936,
                                                        54.027093
                                                ],
                                                [
                                                        23.851202,
                                                        54.048812
                                                ],
                                                [
                                                        23.839365,
                                                        54.067002
                                                ],
                                                [
                                                        23.85485,
                                                        54.089831
                                                ],
                                                [
                                                        23.802711,
                                                        54.103654
                                                ],
                                                [
                                                        23.808658,
                                                        54.135001
                                                ],
                                                [
                                                        23.802472,
                                                        54.143819
                                                ],
                                                [
                                                        23.857487,
                                                        54.157647
                                                ],
                                                [
                                                        23.874912,
                                                        54.155274
                                                ],
                                                [
                                                        23.889103,
                                                        54.168592
                                                ],
                                                [
                                                        23.916633,
                                                        54.177919
                                                ],
                                                [
                                                        23.966418,
                                                        54.176052
                                                ],
                                                [
                                                        23.994444,
                                                        54.16746
                                                ],
                                                [
                                                        23.992029,
                                                        54.128717
                                                ],
                                                [
                                                        23.968045,
                                                        54.129172
                                                ],
                                                [
                                                        23.976082,
                                                        54.105393
                                                ],
                                                [
                                                        23.996837,
                                                        54.115984
                                                ],
                                                [
                                                        24.032895,
                                                        54.100244
                                                ],
                                                [
                                                        24.009542,
                                                        54.078737
                                                ],
                                                [
                                                        24.030286,
                                                        54.070764
                                                ],
                                                [
                                                        24.052952,
                                                        54.080026
                                                ],
                                                [
                                                        24.068349,
                                                        54.073613
                                                ],
                                                [
                                                        24.137135,
                                                        54.063668
                                                ],
                                                [
                                                        24.160551,
                                                        54.073089
                                                ],
                                                [
                                                        24.17802,
                                                        54.063973
                                                ],
                                                [
                                                        24.200358,
                                                        54.064933
                                                ],
                                                [
                                                        24.206155,
                                                        53.999265
                                                ],
                                                [
                                                        24.191668,
                                                        53.998526
                                                ],
                                                [
                                                        24.201596,
                                                        53.970139
                                                ],
                                                [
                                                        24.142221,
                                                        53.953978
                                                ],
                                                [
                                                        24.118673,
                                                        53.955527
                                                ],
                                                [
                                                        24.102438,
                                                        53.940527
                                                ],
                                                [
                                                        23.98329,
                                                        53.92408
                                                ],
                                                [
                                                        23.96693,
                                                        53.92862
                                                ],
                                                [
                                                        23.96135,
                                                        53.95394
                                                ],
                                                [
                                                        23.907392,
                                                        53.965665
                                                ],
                                                [
                                                        23.908461,
                                                        53.954325
                                                ],
                                                [
                                                        23.885828,
                                                        53.943518
                                                ],
                                                [
                                                        23.860002,
                                                        53.953621
                                                ],
                                                [
                                                        23.835587,
                                                        53.953805
                                                ]
                                        ]
                                ]
                        },
                        "properties": {
                                "longName": "Druskinink\u0173 savivaldyb\u0117",
                                "name": "Druskinink\u0173 sav.",
                                "id": "15",
                                "osmId": 365553,
                                "org_id": 6
                        },
                        "id": "15"
                },
                {
                        "type": "Feature",
                        "geometry": {
                                "type": "Polygon",
                                "coordinates": [
                                        [
                                                [
                                                        25.019632,
                                                        54.441528
                                                ],
                                                [
                                                        25.009197,
                                                        54.422943
                                                ],
                                                [
                                                        25.017442,
                                                        54.398457
                                                ],
                                                [
                                                        24.997701,
                                                        54.384134
                                                ],
                                                [
                                                        24.922541,
                                                        54.374902
                                                ],
                                                [
                                                        24.910606,
                                                        54.361261
                                                ],
                                                [
                                                        24.932252,
                                                        54.294744
                                                ],
                                                [
                                                        24.878977,
                                                        54.293382
                                                ],
                                                [
                                                        24.854548,
                                                        54.256138
                                                ],
                                                [
                                                        24.821049,
                                                        54.245506
                                                ],
                                                [
                                                        24.81191,
                                                        54.232992
                                                ],
                                                [
                                                        24.784943,
                                                        54.234276
                                                ],
                                                [
                                                        24.753709,
                                                        54.223284
                                                ],
                                                [
                                                        24.756897,
                                                        54.199424
                                                ],
                                                [
                                                        24.815289,
                                                        54.186795
                                                ],
                                                [
                                                        24.815852,
                                                        54.166931
                                                ],
                                                [
                                                        24.834594,
                                                        54.148709
                                                ],
                                                [
                                                        24.830275,
                                                        54.131975
                                                ],
                                                [
                                                        24.792205,
                                                        54.1141
                                                ],
                                                [
                                                        24.778034,
                                                        54.099362
                                                ],
                                                [
                                                        24.796123,
                                                        54.091665
                                                ],
                                                [
                                                        24.818943,
                                                        54.068439
                                                ],
                                                [
                                                        24.822134,
                                                        54.043174
                                                ],
                                                [
                                                        24.840026,
                                                        54.033605
                                                ],
                                                [
                                                        24.831353,
                                                        54.012428
                                                ],
                                                [
                                                        24.80796,
                                                        54.001606
                                                ],
                                                [
                                                        24.758631,
                                                        53.990139
                                                ],
                                                [
                                                        24.725556,
                                                        53.9671
                                                ],
                                                [
                                                        24.684111,
                                                        53.962086
                                                ],
                                                [
                                                        24.705057,
                                                        54.009713
                                                ],
                                                [
                                                        24.6721,
                                                        54.016916
                                                ],
                                                [
                                                        24.65986,
                                                        54.005373
                                                ],
                                                [
                                                        24.616131,
                                                        54.00401
                                                ],
                                                [
                                                        24.595703,
                                                        53.990791
                                                ],
                                                [
                                                        24.563244,
                                                        53.983074
                                                ],
                                                [
                                                        24.523186,
                                                        53.964522
                                                ],
                                                [
                                                        24.491591,
                                                        53.937262
                                                ],
                                                [
                                                        24.459118,
                                                        53.918885
                                                ],
                                                [
                                                        24.448237,
                                                        53.904392
                                                ],
                                                [
                                                        24.389916,
                                                        53.90357
                                                ],
                                                [
                                                        24.352102,
                                                        53.896897
                                                ],
                                                [
                                                        24.287431,
                                                        53.922263
                                                ],
                                                [
                                                        24.260401,
                                                        53.948918
                                                ],
                                                [
                                                        24.233101,
                                                        53.94496
                                                ],
                                                [
                                                        24.201596,
                                                        53.970139
                                                ],
                                                [
                                                        24.191668,
                                                        53.998526
                                                ],
                                                [
                                                        24.206155,
                                                        53.999265
                                                ],
                                                [
                                                        24.200358,
                                                        54.064933
                                                ],
                                                [
                                                        24.17802,
                                                        54.063973
                                                ],
                                                [
                                                        24.160551,
                                                        54.073089
                                                ],
                                                [
                                                        24.137135,
                                                        54.063668
                                                ],
                                                [
                                                        24.068349,
                                                        54.073613
                                                ],
                                                [
                                                        24.052952,
                                                        54.080026
                                                ],
                                                [
                                                        24.030286,
                                                        54.070764
                                                ],
                                                [
                                                        24.009542,
                                                        54.078737
                                                ],
                                                [
                                                        24.032895,
                                                        54.100244
                                                ],
                                                [
                                                        23.996837,
                                                        54.115984
                                                ],
                                                [
                                                        23.976082,
                                                        54.105393
                                                ],
                                                [
                                                        23.968045,
                                                        54.129172
                                                ],
                                                [
                                                        23.992029,
                                                        54.128717
                                                ],
                                                [
                                                        23.994444,
                                                        54.16746
                                                ],
                                                [
                                                        24.021285,
                                                        54.182492
                                                ],
                                                [
                                                        24.045165,
                                                        54.174813
                                                ],
                                                [
                                                        24.078597,
                                                        54.184222
                                                ],
                                                [
                                                        24.078743,
                                                        54.205326
                                                ],
                                                [
                                                        24.107221,
                                                        54.207142
                                                ],
                                                [
                                                        24.105813,
                                                        54.221377
                                                ],
                                                [
                                                        24.126086,
                                                        54.226743
                                                ],
                                                [
                                                        24.143492,
                                                        54.243642
                                                ],
                                                [
                                                        24.137001,
                                                        54.266604
                                                ],
                                                [
                                                        24.15418,
                                                        54.2774
                                                ],
                                                [
                                                        24.192997,
                                                        54.279923
                                                ],
                                                [
                                                        24.242703,
                                                        54.267632
                                                ],
                                                [
                                                        24.321134,
                                                        54.288116
                                                ],
                                                [
                                                        24.330586,
                                                        54.29878
                                                ],
                                                [
                                                        24.385875,
                                                        54.3016
                                                ],
                                                [
                                                        24.398171,
                                                        54.370956
                                                ],
                                                [
                                                        24.427701,
                                                        54.372284
                                                ],
                                                [
                                                        24.450273,
                                                        54.352096
                                                ],
                                                [
                                                        24.478363,
                                                        54.36275
                                                ],
                                                [
                                                        24.453244,
                                                        54.377696
                                                ],
                                                [
                                                        24.454274,
                                                        54.401874
                                                ],
                                                [
                                                        24.434123,
                                                        54.408541
                                                ],
                                                [
                                                        24.437462,
                                                        54.425445
                                                ],
                                                [
                                                        24.4881,
                                                        54.421935
                                                ],
                                                [
                                                        24.503107,
                                                        54.427819
                                                ],
                                                [
                                                        24.546084,
                                                        54.429595
                                                ],
                                                [
                                                        24.539962,
                                                        54.417393
                                                ],
                                                [
                                                        24.584581,
                                                        54.413069
                                                ],
                                                [
                                                        24.619683,
                                                        54.441092
                                                ],
                                                [
                                                        24.655497,
                                                        54.439273
                                                ],
                                                [
                                                        24.66848,
                                                        54.447593
                                                ],
                                                [
                                                        24.689374,
                                                        54.432484
                                                ],
                                                [
                                                        24.721258,
                                                        54.429364
                                                ],
                                                [
                                                        24.707007,
                                                        54.408528
                                                ],
                                                [
                                                        24.722802,
                                                        54.388601
                                                ],
                                                [
                                                        24.74475,
                                                        54.398656
                                                ],
                                                [
                                                        24.803249,
                                                        54.405397
                                                ],
                                                [
                                                        24.828476,
                                                        54.400522
                                                ],
                                                [
                                                        24.873833,
                                                        54.415127
                                                ],
                                                [
                                                        24.902661,
                                                        54.418733
                                                ],
                                                [
                                                        24.962799,
                                                        54.43418
                                                ],
                                                [
                                                        25.019632,
                                                        54.441528
                                                ]
                                        ]
                                ]
                        },
                        "properties": {
                                "longName": "Var\u0117nos rajonas",
                                "name": "Var\u0117nos r. sav.",
                                "id": "38",
                                "osmId": 365554,
                                "org_id": 54
                        },
                        "id": "38"
                },
                {
                        "type": "Feature",
                        "geometry": {
                                "type": "Polygon",
                                "coordinates": [
                                        [
                                                [
                                                        21.103583,
                                                        55.667253
                                                ],
                                                [
                                                        21.129486,
                                                        55.661117
                                                ],
                                                [
                                                        21.13581,
                                                        55.61538
                                                ],
                                                [
                                                        21.127098,
                                                        55.558349
                                                ],
                                                [
                                                        21.115285,
                                                        55.520423
                                                ],
                                                [
                                                        21.120145,
                                                        55.51404
                                                ],
                                                [
                                                        21.110025,
                                                        55.481618
                                                ],
                                                [
                                                        21.090386,
                                                        55.438553
                                                ],
                                                [
                                                        21.111033,
                                                        55.420621
                                                ],
                                                [
                                                        21.085664,
                                                        55.408724
                                                ],
                                                [
                                                        21.078074,
                                                        55.382901
                                                ],
                                                [
                                                        21.057861,
                                                        55.367778
                                                ],
                                                [
                                                        21.058297,
                                                        55.331067
                                                ],
                                                [
                                                        21.010447,
                                                        55.310156
                                                ],
                                                [
                                                        21.001293,
                                                        55.289936
                                                ],
                                                [
                                                        20.984437,
                                                        55.277644
                                                ],
                                                [
                                                        20.966737,
                                                        55.293247
                                                ],
                                                [
                                                        21.029662,
                                                        55.375841
                                                ],
                                                [
                                                        21.062713,
                                                        55.434623
                                                ],
                                                [
                                                        21.096772,
                                                        55.530842
                                                ],
                                                [
                                                        21.105421,
                                                        55.5976
                                                ],
                                                [
                                                        21.103583,
                                                        55.667253
                                                ]
                                        ]
                                ]
                        },
                        "properties": {
                                "longName": "Neringos savivaldyb\u0117",
                                "name": "Neringos sav.",
                                "id": "23",
                                "osmId": 365555,
                                "org_id": 27
                        },
                        "id": "23"
                },
                {
                        "type": "Feature",
                        "geometry": {
                                "type": "Polygon",
                                "coordinates": [
                                        [
                                                [
                                                        23.835587,
                                                        53.953805
                                                ],
                                                [
                                                        23.79771,
                                                        53.92893
                                                ],
                                                [
                                                        23.818174,
                                                        53.914719
                                                ],
                                                [
                                                        23.797893,
                                                        53.89992
                                                ],
                                                [
                                                        23.765757,
                                                        53.923255
                                                ],
                                                [
                                                        23.721218,
                                                        53.936801
                                                ],
                                                [
                                                        23.666952,
                                                        53.931003
                                                ],
                                                [
                                                        23.650567,
                                                        53.93458
                                                ],
                                                [
                                                        23.610633,
                                                        53.924322
                                                ],
                                                [
                                                        23.601671,
                                                        53.934957
                                                ],
                                                [
                                                        23.570861,
                                                        53.943884
                                                ],
                                                [
                                                        23.538548,
                                                        53.942365
                                                ],
                                                [
                                                        23.530784,
                                                        53.953757
                                                ],
                                                [
                                                        23.490209,
                                                        53.974906
                                                ],
                                                [
                                                        23.481753,
                                                        53.997806
                                                ],
                                                [
                                                        23.509317,
                                                        54.011522
                                                ],
                                                [
                                                        23.524885,
                                                        54.031133
                                                ],
                                                [
                                                        23.528573,
                                                        54.065791
                                                ],
                                                [
                                                        23.51831,
                                                        54.089793
                                                ],
                                                [
                                                        23.492864,
                                                        54.117042
                                                ],
                                                [
                                                        23.495716,
                                                        54.132487
                                                ],
                                                [
                                                        23.485815,
                                                        54.153251
                                                ],
                                                [
                                                        23.459031,
                                                        54.175546
                                                ],
                                                [
                                                        23.424536,
                                                        54.17734
                                                ],
                                                [
                                                        23.380917,
                                                        54.229073
                                                ],
                                                [
                                                        23.35819,
                                                        54.233657
                                                ],
                                                [
                                                        23.337606,
                                                        54.251797
                                                ],
                                                [
                                                        23.321542,
                                                        54.253404
                                                ],
                                                [
                                                        23.331589,
                                                        54.277617
                                                ],
                                                [
                                                        23.311761,
                                                        54.296741
                                                ],
                                                [
                                                        23.342738,
                                                        54.308183
                                                ],
                                                [
                                                        23.337507,
                                                        54.328615
                                                ],
                                                [
                                                        23.365039,
                                                        54.359067
                                                ],
                                                [
                                                        23.399233,
                                                        54.367313
                                                ],
                                                [
                                                        23.444251,
                                                        54.366083
                                                ],
                                                [
                                                        23.432376,
                                                        54.401194
                                                ],
                                                [
                                                        23.45721,
                                                        54.400843
                                                ],
                                                [
                                                        23.491121,
                                                        54.414576
                                                ],
                                                [
                                                        23.50966,
                                                        54.414776
                                                ],
                                                [
                                                        23.540545,
                                                        54.413207
                                                ],
                                                [
                                                        23.58169,
                                                        54.394959
                                                ],
                                                [
                                                        23.587057,
                                                        54.369387
                                                ],
                                                [
                                                        23.562616,
                                                        54.370048
                                                ],
                                                [
                                                        23.563237,
                                                        54.340034
                                                ],
                                                [
                                                        23.60302,
                                                        54.339937
                                                ],
                                                [
                                                        23.628734,
                                                        54.352702
                                                ],
                                                [
                                                        23.659403,
                                                        54.344617
                                                ],
                                                [
                                                        23.679091,
                                                        54.324572
                                                ],
                                                [
                                                        23.724091,
                                                        54.337842
                                                ],
                                                [
                                                        23.750754,
                                                        54.329687
                                                ],
                                                [
                                                        23.764015,
                                                        54.313749
                                                ],
                                                [
                                                        23.797014,
                                                        54.294963
                                                ],
                                                [
                                                        23.815964,
                                                        54.295377
                                                ],
                                                [
                                                        23.873242,
                                                        54.283178
                                                ],
                                                [
                                                        23.911535,
                                                        54.287182
                                                ],
                                                [
                                                        23.933164,
                                                        54.261175
                                                ],
                                                [
                                                        23.971733,
                                                        54.25024
                                                ],
                                                [
                                                        23.960832,
                                                        54.20539
                                                ],
                                                [
                                                        23.949848,
                                                        54.19139
                                                ],
                                                [
                                                        23.966418,
                                                        54.176052
                                                ],
                                                [
                                                        23.916633,
                                                        54.177919
                                                ],
                                                [
                                                        23.889103,
                                                        54.168592
                                                ],
                                                [
                                                        23.874912,
                                                        54.155274
                                                ],
                                                [
                                                        23.857487,
                                                        54.157647
                                                ],
                                                [
                                                        23.802472,
                                                        54.143819
                                                ],
                                                [
                                                        23.808658,
                                                        54.135001
                                                ],
                                                [
                                                        23.802711,
                                                        54.103654
                                                ],
                                                [
                                                        23.85485,
                                                        54.089831
                                                ],
                                                [
                                                        23.839365,
                                                        54.067002
                                                ],
                                                [
                                                        23.851202,
                                                        54.048812
                                                ],
                                                [
                                                        23.835936,
                                                        54.027093
                                                ],
                                                [
                                                        23.863159,
                                                        54.025038
                                                ],
                                                [
                                                        23.843807,
                                                        54.003866
                                                ],
                                                [
                                                        23.803733,
                                                        53.982168
                                                ],
                                                [
                                                        23.835587,
                                                        53.953805
                                                ]
                                        ]
                                ]
                        },
                        "properties": {
                                "longName": "Lazdij\u0173 rajonas",
                                "name": "Lazdij\u0173 r. sav.",
                                "id": "59",
                                "osmId": 365556,
                                "org_id": 23
                        },
                        "id": "59"
                },
                {
                        "type": "Feature",
                        "geometry": {
                                "type": "Polygon",
                                "coordinates": [
                                        [
                                                [
                                                        24.170093,
                                                        54.536058
                                                ],
                                                [
                                                        24.197405,
                                                        54.536526
                                                ],
                                                [
                                                        24.205208,
                                                        54.553354
                                                ],
                                                [
                                                        24.263775,
                                                        54.555766
                                                ],
                                                [
                                                        24.27328,
                                                        54.528979
                                                ],
                                                [
                                                        24.317283,
                                                        54.520936
                                                ],
                                                [
                                                        24.342715,
                                                        54.526659
                                                ],
                                                [
                                                        24.398573,
                                                        54.522796
                                                ],
                                                [
                                                        24.414168,
                                                        54.533019
                                                ],
                                                [
                                                        24.404361,
                                                        54.518938
                                                ],
                                                [
                                                        24.418901,
                                                        54.489876
                                                ],
                                                [
                                                        24.393822,
                                                        54.483315
                                                ],
                                                [
                                                        24.433891,
                                                        54.463823
                                                ],
                                                [
                                                        24.438418,
                                                        54.451595
                                                ],
                                                [
                                                        24.416995,
                                                        54.435903
                                                ],
                                                [
                                                        24.437462,
                                                        54.425445
                                                ],
                                                [
                                                        24.434123,
                                                        54.408541
                                                ],
                                                [
                                                        24.454274,
                                                        54.401874
                                                ],
                                                [
                                                        24.453244,
                                                        54.377696
                                                ],
                                                [
                                                        24.478363,
                                                        54.36275
                                                ],
                                                [
                                                        24.450273,
                                                        54.352096
                                                ],
                                                [
                                                        24.427701,
                                                        54.372284
                                                ],
                                                [
                                                        24.398171,
                                                        54.370956
                                                ],
                                                [
                                                        24.385875,
                                                        54.3016
                                                ],
                                                [
                                                        24.330586,
                                                        54.29878
                                                ],
                                                [
                                                        24.321134,
                                                        54.288116
                                                ],
                                                [
                                                        24.242703,
                                                        54.267632
                                                ],
                                                [
                                                        24.192997,
                                                        54.279923
                                                ],
                                                [
                                                        24.15418,
                                                        54.2774
                                                ],
                                                [
                                                        24.137001,
                                                        54.266604
                                                ],
                                                [
                                                        24.143492,
                                                        54.243642
                                                ],
                                                [
                                                        24.126086,
                                                        54.226743
                                                ],
                                                [
                                                        24.105813,
                                                        54.221377
                                                ],
                                                [
                                                        24.107221,
                                                        54.207142
                                                ],
                                                [
                                                        24.078743,
                                                        54.205326
                                                ],
                                                [
                                                        24.078597,
                                                        54.184222
                                                ],
                                                [
                                                        24.045165,
                                                        54.174813
                                                ],
                                                [
                                                        24.021285,
                                                        54.182492
                                                ],
                                                [
                                                        23.994444,
                                                        54.16746
                                                ],
                                                [
                                                        23.966418,
                                                        54.176052
                                                ],
                                                [
                                                        23.949848,
                                                        54.19139
                                                ],
                                                [
                                                        23.960832,
                                                        54.20539
                                                ],
                                                [
                                                        23.971733,
                                                        54.25024
                                                ],
                                                [
                                                        23.933164,
                                                        54.261175
                                                ],
                                                [
                                                        23.911535,
                                                        54.287182
                                                ],
                                                [
                                                        23.873242,
                                                        54.283178
                                                ],
                                                [
                                                        23.815964,
                                                        54.295377
                                                ],
                                                [
                                                        23.797014,
                                                        54.294963
                                                ],
                                                [
                                                        23.764015,
                                                        54.313749
                                                ],
                                                [
                                                        23.750754,
                                                        54.329687
                                                ],
                                                [
                                                        23.724091,
                                                        54.337842
                                                ],
                                                [
                                                        23.679091,
                                                        54.324572
                                                ],
                                                [
                                                        23.659403,
                                                        54.344617
                                                ],
                                                [
                                                        23.628734,
                                                        54.352702
                                                ],
                                                [
                                                        23.60302,
                                                        54.339937
                                                ],
                                                [
                                                        23.563237,
                                                        54.340034
                                                ],
                                                [
                                                        23.562616,
                                                        54.370048
                                                ],
                                                [
                                                        23.587057,
                                                        54.369387
                                                ],
                                                [
                                                        23.58169,
                                                        54.394959
                                                ],
                                                [
                                                        23.540545,
                                                        54.413207
                                                ],
                                                [
                                                        23.50966,
                                                        54.414776
                                                ],
                                                [
                                                        23.525796,
                                                        54.465989
                                                ],
                                                [
                                                        23.61403,
                                                        54.485239
                                                ],
                                                [
                                                        23.628793,
                                                        54.50787
                                                ],
                                                [
                                                        23.657461,
                                                        54.510261
                                                ],
                                                [
                                                        23.687175,
                                                        54.474224
                                                ],
                                                [
                                                        23.71765,
                                                        54.483551
                                                ],
                                                [
                                                        23.727797,
                                                        54.472999
                                                ],
                                                [
                                                        23.758059,
                                                        54.46844
                                                ],
                                                [
                                                        23.778303,
                                                        54.459304
                                                ],
                                                [
                                                        23.796522,
                                                        54.469018
                                                ],
                                                [
                                                        23.838715,
                                                        54.470317
                                                ],
                                                [
                                                        23.910608,
                                                        54.464758
                                                ],
                                                [
                                                        23.906778,
                                                        54.483546
                                                ],
                                                [
                                                        23.968768,
                                                        54.485552
                                                ],
                                                [
                                                        23.971954,
                                                        54.492272
                                                ],
                                                [
                                                        24.006839,
                                                        54.497981
                                                ],
                                                [
                                                        23.996499,
                                                        54.51255
                                                ],
                                                [
                                                        24.013971,
                                                        54.5458
                                                ],
                                                [
                                                        24.067607,
                                                        54.554366
                                                ],
                                                [
                                                        24.086147,
                                                        54.549786
                                                ],
                                                [
                                                        24.106715,
                                                        54.526829
                                                ],
                                                [
                                                        24.128944,
                                                        54.538024
                                                ],
                                                [
                                                        24.170093,
                                                        54.536058
                                                ]
                                        ],
                                        [
                                                [
                                                        24.013801,
                                                        54.3786
                                                ],
                                                [
                                                        24.03852,
                                                        54.3762
                                                ],
                                                [
                                                        24.063239,
                                                        54.3643
                                                ],
                                                [
                                                        24.094481,
                                                        54.400889
                                                ],
                                                [
                                                        24.069762,
                                                        54.41158
                                                ],
                                                [
                                                        24.040408,
                                                        54.433552
                                                ],
                                                [
                                                        24.008651,
                                                        54.443136
                                                ],
                                                [
                                                        24.005732,
                                                        54.419371
                                                ],
                                                [
                                                        23.971228,
                                                        54.394793
                                                ],
                                                [
                                                        23.998555,
                                                        54.392766
                                                ],
                                                [
                                                        24.013801,
                                                        54.3786
                                                ]
                                        ]
                                ]
                        },
                        "properties": {
                                "longName": "Alytaus rajonas",
                                "name": "Alytaus r. sav.",
                                "id": "33",
                                "osmId": 365557,
                                "org_id": 2
                        },
                        "id": "33"
                },
                {
                        "type": "Feature",
                        "geometry": {
                                "type": "Polygon",
                                "coordinates": [
                                        [
                                                [
                                                        24.013801,
                                                        54.3786
                                                ],
                                                [
                                                        23.998555,
                                                        54.392766
                                                ],
                                                [
                                                        23.971228,
                                                        54.394793
                                                ],
                                                [
                                                        24.005732,
                                                        54.419371
                                                ],
                                                [
                                                        24.008651,
                                                        54.443136
                                                ],
                                                [
                                                        24.040408,
                                                        54.433552
                                                ],
                                                [
                                                        24.069762,
                                                        54.41158
                                                ],
                                                [
                                                        24.094481,
                                                        54.400889
                                                ],
                                                [
                                                        24.063239,
                                                        54.3643
                                                ],
                                                [
                                                        24.03852,
                                                        54.3762
                                                ],
                                                [
                                                        24.013801,
                                                        54.3786
                                                ]
                                        ]
                                ]
                        },
                        "properties": {
                                "longName": "Alytaus m. savivaldyb\u0117",
                                "name": "Alytaus m. sav.",
                                "id": "11",
                                "osmId": 365558,
                                "org_id": 1
                        },
                        "id": "11"
                },
                {
                        "type": "Feature",
                        "geometry": {
                                "type": "Polygon",
                                "coordinates": [
                                        [
                                                [
                                                        25.686184,
                                                        55.714946
                                                ],
                                                [
                                                        25.681659,
                                                        55.73835
                                                ],
                                                [
                                                        25.64535,
                                                        55.730422
                                                ],
                                                [
                                                        25.599445,
                                                        55.7427
                                                ],
                                                [
                                                        25.581977,
                                                        55.721528
                                                ],
                                                [
                                                        25.543254,
                                                        55.731236
                                                ],
                                                [
                                                        25.519145,
                                                        55.720467
                                                ],
                                                [
                                                        25.503698,
                                                        55.737402
                                                ],
                                                [
                                                        25.474032,
                                                        55.743957
                                                ],
                                                [
                                                        25.465021,
                                                        55.732614
                                                ],
                                                [
                                                        25.390616,
                                                        55.764124
                                                ],
                                                [
                                                        25.364793,
                                                        55.761779
                                                ],
                                                [
                                                        25.336396,
                                                        55.796073
                                                ],
                                                [
                                                        25.293475,
                                                        55.828218
                                                ],
                                                [
                                                        25.300238,
                                                        55.854119
                                                ],
                                                [
                                                        25.321216,
                                                        55.866294
                                                ],
                                                [
                                                        25.332886,
                                                        55.901119
                                                ],
                                                [
                                                        25.323982,
                                                        55.923278
                                                ],
                                                [
                                                        25.323406,
                                                        55.966858
                                                ],
                                                [
                                                        25.312813,
                                                        55.975132
                                                ],
                                                [
                                                        25.279858,
                                                        55.961142
                                                ],
                                                [
                                                        25.272322,
                                                        55.936796
                                                ],
                                                [
                                                        25.252857,
                                                        55.936293
                                                ],
                                                [
                                                        25.22744,
                                                        55.948711
                                                ],
                                                [
                                                        25.191213,
                                                        55.953135
                                                ],
                                                [
                                                        25.139903,
                                                        55.94296
                                                ],
                                                [
                                                        25.097683,
                                                        55.967556
                                                ],
                                                [
                                                        25.068672,
                                                        55.977374
                                                ],
                                                [
                                                        25.064373,
                                                        55.997982
                                                ],
                                                [
                                                        25.078932,
                                                        56.012389
                                                ],
                                                [
                                                        25.116909,
                                                        56.031712
                                                ],
                                                [
                                                        25.090938,
                                                        56.05878
                                                ],
                                                [
                                                        25.114304,
                                                        56.067209
                                                ],
                                                [
                                                        25.114857,
                                                        56.087665
                                                ],
                                                [
                                                        25.140381,
                                                        56.105641
                                                ],
                                                [
                                                        25.176481,
                                                        56.097898
                                                ],
                                                [
                                                        25.222863,
                                                        56.112832
                                                ],
                                                [
                                                        25.194159,
                                                        56.138834
                                                ],
                                                [
                                                        25.166183,
                                                        56.155983
                                                ],
                                                [
                                                        25.17111,
                                                        56.174232
                                                ],
                                                [
                                                        25.200272,
                                                        56.17645
                                                ],
                                                [
                                                        25.234098,
                                                        56.192008
                                                ],
                                                [
                                                        25.27946,
                                                        56.158302
                                                ],
                                                [
                                                        25.314861,
                                                        56.144918
                                                ],
                                                [
                                                        25.337098,
                                                        56.154344
                                                ],
                                                [
                                                        25.404075,
                                                        56.158216
                                                ],
                                                [
                                                        25.480171,
                                                        56.142794
                                                ],
                                                [
                                                        25.504691,
                                                        56.14444
                                                ],
                                                [
                                                        25.508209,
                                                        56.158101
                                                ],
                                                [
                                                        25.536573,
                                                        56.165472
                                                ],
                                                [
                                                        25.552055,
                                                        56.160852
                                                ],
                                                [
                                                        25.565441,
                                                        56.13993
                                                ],
                                                [
                                                        25.601924,
                                                        56.134477
                                                ],
                                                [
                                                        25.6506,
                                                        56.134931
                                                ],
                                                [
                                                        25.699832,
                                                        56.119181
                                                ],
                                                [
                                                        25.688135,
                                                        56.086481
                                                ],
                                                [
                                                        25.736707,
                                                        56.076835
                                                ],
                                                [
                                                        25.760725,
                                                        56.06366
                                                ],
                                                [
                                                        25.820083,
                                                        56.054775
                                                ],
                                                [
                                                        25.83888,
                                                        56.030564
                                                ],
                                                [
                                                        25.850351,
                                                        56.030496
                                                ],
                                                [
                                                        25.860289,
                                                        55.999742
                                                ],
                                                [
                                                        25.900573,
                                                        55.996926
                                                ],
                                                [
                                                        25.973968,
                                                        55.981594
                                                ],
                                                [
                                                        26.045951,
                                                        55.954231
                                                ],
                                                [
                                                        26.045737,
                                                        55.944546
                                                ],
                                                [
                                                        26.006177,
                                                        55.94296
                                                ],
                                                [
                                                        25.970412,
                                                        55.921827
                                                ],
                                                [
                                                        25.966387,
                                                        55.910018
                                                ],
                                                [
                                                        25.986626,
                                                        55.88941
                                                ],
                                                [
                                                        25.961007,
                                                        55.866955
                                                ],
                                                [
                                                        25.900662,
                                                        55.861255
                                                ],
                                                [
                                                        25.902336,
                                                        55.825936
                                                ],
                                                [
                                                        25.872705,
                                                        55.821011
                                                ],
                                                [
                                                        25.840297,
                                                        55.835011
                                                ],
                                                [
                                                        25.83914,
                                                        55.796501
                                                ],
                                                [
                                                        25.822407,
                                                        55.773482
                                                ],
                                                [
                                                        25.788834,
                                                        55.773774
                                                ],
                                                [
                                                        25.752917,
                                                        55.786118
                                                ],
                                                [
                                                        25.733929,
                                                        55.779342
                                                ],
                                                [
                                                        25.729884,
                                                        55.751263
                                                ],
                                                [
                                                        25.712502,
                                                        55.731017
                                                ],
                                                [
                                                        25.686184,
                                                        55.714946
                                                ]
                                        ]
                                ]
                        },
                        "properties": {
                                "longName": "Roki\u0161kio rajonas",
                                "name": "Roki\u0161kio r. sav.",
                                "id": "73",
                                "osmId": 365559,
                                "org_id": 39
                        },
                        "id": "73"
                },
                {
                        "type": "Feature",
                        "geometry": {
                                "type": "Polygon",
                                "coordinates": [
                                        [
                                                [
                                                        24.715259,
                                                        55.922489
                                                ],
                                                [
                                                        24.681633,
                                                        55.936177
                                                ],
                                                [
                                                        24.652184,
                                                        55.911569
                                                ],
                                                [
                                                        24.626311,
                                                        55.903924
                                                ],
                                                [
                                                        24.626233,
                                                        55.923316
                                                ],
                                                [
                                                        24.607447,
                                                        55.935535
                                                ],
                                                [
                                                        24.619064,
                                                        55.951775
                                                ],
                                                [
                                                        24.602892,
                                                        55.960152
                                                ],
                                                [
                                                        24.616764,
                                                        55.972975
                                                ],
                                                [
                                                        24.600891,
                                                        56.01239
                                                ],
                                                [
                                                        24.628478,
                                                        56.033208
                                                ],
                                                [
                                                        24.62879,
                                                        56.053449
                                                ],
                                                [
                                                        24.681627,
                                                        56.055147
                                                ],
                                                [
                                                        24.673133,
                                                        56.094031
                                                ],
                                                [
                                                        24.64913,
                                                        56.092813
                                                ],
                                                [
                                                        24.638687,
                                                        56.12749
                                                ],
                                                [
                                                        24.623718,
                                                        56.134867
                                                ],
                                                [
                                                        24.596753,
                                                        56.105205
                                                ],
                                                [
                                                        24.543756,
                                                        56.124672
                                                ],
                                                [
                                                        24.561472,
                                                        56.139395
                                                ],
                                                [
                                                        24.5412,
                                                        56.170236
                                                ],
                                                [
                                                        24.520734,
                                                        56.166945
                                                ],
                                                [
                                                        24.497313,
                                                        56.182902
                                                ],
                                                [
                                                        24.491254,
                                                        56.208429
                                                ],
                                                [
                                                        24.47234,
                                                        56.212826
                                                ],
                                                [
                                                        24.503149,
                                                        56.248514
                                                ],
                                                [
                                                        24.504028,
                                                        56.27621
                                                ],
                                                [
                                                        24.564774,
                                                        56.289198
                                                ],
                                                [
                                                        24.583327,
                                                        56.305589
                                                ],
                                                [
                                                        24.575598,
                                                        56.315602
                                                ],
                                                [
                                                        24.587005,
                                                        56.331679
                                                ],
                                                [
                                                        24.606955,
                                                        56.335951
                                                ],
                                                [
                                                        24.627922,
                                                        56.355418
                                                ],
                                                [
                                                        24.62881,
                                                        56.375625
                                                ],
                                                [
                                                        24.685523,
                                                        56.376025
                                                ],
                                                [
                                                        24.725933,
                                                        56.402801
                                                ],
                                                [
                                                        24.774512,
                                                        56.399539
                                                ],
                                                [
                                                        24.803008,
                                                        56.411521
                                                ],
                                                [
                                                        24.861782,
                                                        56.41581
                                                ],
                                                [
                                                        24.853457,
                                                        56.433475
                                                ],
                                                [
                                                        24.872537,
                                                        56.449697
                                                ],
                                                [
                                                        24.903779,
                                                        56.447626
                                                ],
                                                [
                                                        24.919401,
                                                        56.435115
                                                ],
                                                [
                                                        24.902742,
                                                        56.420906
                                                ],
                                                [
                                                        24.927063,
                                                        56.400616
                                                ],
                                                [
                                                        24.940023,
                                                        56.380737
                                                ],
                                                [
                                                        24.969027,
                                                        56.365833
                                                ],
                                                [
                                                        24.966601,
                                                        56.343739
                                                ],
                                                [
                                                        24.97317,
                                                        56.310612
                                                ],
                                                [
                                                        25.016261,
                                                        56.291255
                                                ],
                                                [
                                                        25.022015,
                                                        56.275966
                                                ],
                                                [
                                                        25.055858,
                                                        56.266076
                                                ],
                                                [
                                                        25.067108,
                                                        56.241745
                                                ],
                                                [
                                                        25.070281,
                                                        56.210643
                                                ],
                                                [
                                                        25.091978,
                                                        56.18609
                                                ],
                                                [
                                                        25.126298,
                                                        56.184116
                                                ],
                                                [
                                                        25.17111,
                                                        56.174232
                                                ],
                                                [
                                                        25.166183,
                                                        56.155983
                                                ],
                                                [
                                                        25.194159,
                                                        56.138834
                                                ],
                                                [
                                                        25.222863,
                                                        56.112832
                                                ],
                                                [
                                                        25.176481,
                                                        56.097898
                                                ],
                                                [
                                                        25.140381,
                                                        56.105641
                                                ],
                                                [
                                                        25.114857,
                                                        56.087665
                                                ],
                                                [
                                                        25.114304,
                                                        56.067209
                                                ],
                                                [
                                                        25.090938,
                                                        56.05878
                                                ],
                                                [
                                                        25.116909,
                                                        56.031712
                                                ],
                                                [
                                                        25.078932,
                                                        56.012389
                                                ],
                                                [
                                                        25.031812,
                                                        56.017854
                                                ],
                                                [
                                                        25.050311,
                                                        56.032994
                                                ],
                                                [
                                                        25.032261,
                                                        56.048766
                                                ],
                                                [
                                                        24.952211,
                                                        56.021733
                                                ],
                                                [
                                                        24.916085,
                                                        56.018869
                                                ],
                                                [
                                                        24.886187,
                                                        56.006376
                                                ],
                                                [
                                                        24.87744,
                                                        55.989758
                                                ],
                                                [
                                                        24.892418,
                                                        55.974406
                                                ],
                                                [
                                                        24.888224,
                                                        55.947207
                                                ],
                                                [
                                                        24.825109,
                                                        55.949053
                                                ],
                                                [
                                                        24.806208,
                                                        55.933926
                                                ],
                                                [
                                                        24.776105,
                                                        55.934808
                                                ],
                                                [
                                                        24.756467,
                                                        55.923405
                                                ],
                                                [
                                                        24.715259,
                                                        55.922489
                                                ]
                                        ]
                                ]
                        },
                        "properties": {
                                "longName": "Bir\u017e\u0173 rajonas",
                                "name": "Bir\u017e\u0173 r. sav.",
                                "id": "36",
                                "osmId": 365560,
                                "org_id": 5
                        },
                        "id": "36"
                },
                {
                        "type": "Feature",
                        "geometry": {
                                "type": "Polygon",
                                "coordinates": [
                                        [
                                                [
                                                        22.123131,
                                                        55.844862
                                                ],
                                                [
                                                        22.163591,
                                                        55.833114
                                                ],
                                                [
                                                        22.157001,
                                                        55.817224
                                                ],
                                                [
                                                        22.168781,
                                                        55.803904
                                                ],
                                                [
                                                        22.240196,
                                                        55.784749
                                                ],
                                                [
                                                        22.227691,
                                                        55.77049
                                                ],
                                                [
                                                        22.227789,
                                                        55.752373
                                                ],
                                                [
                                                        22.251289,
                                                        55.737287
                                                ],
                                                [
                                                        22.251496,
                                                        55.72206
                                                ],
                                                [
                                                        22.231176,
                                                        55.691776
                                                ],
                                                [
                                                        22.251829,
                                                        55.684183
                                                ],
                                                [
                                                        22.153823,
                                                        55.671238
                                                ],
                                                [
                                                        22.123484,
                                                        55.651123
                                                ],
                                                [
                                                        22.094354,
                                                        55.66027
                                                ],
                                                [
                                                        22.064135,
                                                        55.64874
                                                ],
                                                [
                                                        22.071757,
                                                        55.638599
                                                ],
                                                [
                                                        22.043763,
                                                        55.624763
                                                ],
                                                [
                                                        22.044224,
                                                        55.615012
                                                ],
                                                [
                                                        22.012751,
                                                        55.606123
                                                ],
                                                [
                                                        21.973281,
                                                        55.612215
                                                ],
                                                [
                                                        21.95402,
                                                        55.606558
                                                ],
                                                [
                                                        21.880136,
                                                        55.596952
                                                ],
                                                [
                                                        21.879301,
                                                        55.597153
                                                ],
                                                [
                                                        21.844051,
                                                        55.613568
                                                ],
                                                [
                                                        21.840805,
                                                        55.615731
                                                ],
                                                [
                                                        21.841119,
                                                        55.616902
                                                ],
                                                [
                                                        21.843922,
                                                        55.617583
                                                ],
                                                [
                                                        21.828762,
                                                        55.617917
                                                ],
                                                [
                                                        21.823106,
                                                        55.617726
                                                ],
                                                [
                                                        21.809874,
                                                        55.618326
                                                ],
                                                [
                                                        21.810392,
                                                        55.619221
                                                ],
                                                [
                                                        21.813448,
                                                        55.623854
                                                ],
                                                [
                                                        21.812498,
                                                        55.626468
                                                ],
                                                [
                                                        21.808853,
                                                        55.628838
                                                ],
                                                [
                                                        21.810488,
                                                        55.630874
                                                ],
                                                [
                                                        21.810268,
                                                        55.631442
                                                ],
                                                [
                                                        21.807724,
                                                        55.632908
                                                ],
                                                [
                                                        21.807406,
                                                        55.633709
                                                ],
                                                [
                                                        21.80854,
                                                        55.635881
                                                ],
                                                [
                                                        21.807386,
                                                        55.637483
                                                ],
                                                [
                                                        21.799442,
                                                        55.638537
                                                ],
                                                [
                                                        21.796189,
                                                        55.639193
                                                ],
                                                [
                                                        21.794578,
                                                        55.640308
                                                ],
                                                [
                                                        21.788873,
                                                        55.641661
                                                ],
                                                [
                                                        21.782286,
                                                        55.648035
                                                ],
                                                [
                                                        21.785374,
                                                        55.649191
                                                ],
                                                [
                                                        21.796909,
                                                        55.650915
                                                ],
                                                [
                                                        21.791219,
                                                        55.652538
                                                ],
                                                [
                                                        21.791272,
                                                        55.653479
                                                ],
                                                [
                                                        21.789434,
                                                        55.655023
                                                ],
                                                [
                                                        21.789241,
                                                        55.657246
                                                ],
                                                [
                                                        21.787968,
                                                        55.66051
                                                ],
                                                [
                                                        21.787602,
                                                        55.66087
                                                ],
                                                [
                                                        21.781249,
                                                        55.661828
                                                ],
                                                [
                                                        21.788453,
                                                        55.670728
                                                ],
                                                [
                                                        21.787876,
                                                        55.671464
                                                ],
                                                [
                                                        21.794061,
                                                        55.680599
                                                ],
                                                [
                                                        21.791381,
                                                        55.683122
                                                ],
                                                [
                                                        21.792916,
                                                        55.684055
                                                ],
                                                [
                                                        21.797115,
                                                        55.684894
                                                ],
                                                [
                                                        21.799489,
                                                        55.686464
                                                ],
                                                [
                                                        21.800613,
                                                        55.687572
                                                ],
                                                [
                                                        21.804078,
                                                        55.689526
                                                ],
                                                [
                                                        21.80388,
                                                        55.689904
                                                ],
                                                [
                                                        21.79766,
                                                        55.689721
                                                ],
                                                [
                                                        21.789445,
                                                        55.691149
                                                ],
                                                [
                                                        21.787879,
                                                        55.693572
                                                ],
                                                [
                                                        21.786124,
                                                        55.695336
                                                ],
                                                [
                                                        21.780478,
                                                        55.701757
                                                ],
                                                [
                                                        21.762659,
                                                        55.704131
                                                ],
                                                [
                                                        21.76391,
                                                        55.704554
                                                ],
                                                [
                                                        21.761926,
                                                        55.707289
                                                ],
                                                [
                                                        21.75837,
                                                        55.710593
                                                ],
                                                [
                                                        21.752988,
                                                        55.712144
                                                ],
                                                [
                                                        21.751379,
                                                        55.712352
                                                ],
                                                [
                                                        21.751476,
                                                        55.713399
                                                ],
                                                [
                                                        21.752941,
                                                        55.714672
                                                ],
                                                [
                                                        21.753085,
                                                        55.716352
                                                ],
                                                [
                                                        21.755242,
                                                        55.719227
                                                ],
                                                [
                                                        21.754383,
                                                        55.720777
                                                ],
                                                [
                                                        21.754274,
                                                        55.721946
                                                ],
                                                [
                                                        21.755981,
                                                        55.723368
                                                ],
                                                [
                                                        21.757932,
                                                        55.725868
                                                ],
                                                [
                                                        21.763867,
                                                        55.728198
                                                ],
                                                [
                                                        21.765802,
                                                        55.728571
                                                ],
                                                [
                                                        21.768708,
                                                        55.729687
                                                ],
                                                [
                                                        21.767593,
                                                        55.731577
                                                ],
                                                [
                                                        21.766006,
                                                        55.73262
                                                ],
                                                [
                                                        21.765578,
                                                        55.733435
                                                ],
                                                [
                                                        21.763669,
                                                        55.734209
                                                ],
                                                [
                                                        21.762082,
                                                        55.735385
                                                ],
                                                [
                                                        21.760544,
                                                        55.737068
                                                ],
                                                [
                                                        21.76104,
                                                        55.738161
                                                ],
                                                [
                                                        21.761432,
                                                        55.74174
                                                ],
                                                [
                                                        21.76264,
                                                        55.745156
                                                ],
                                                [
                                                        21.762303,
                                                        55.748549
                                                ],
                                                [
                                                        21.763378,
                                                        55.749627
                                                ],
                                                [
                                                        21.755782,
                                                        55.753308
                                                ],
                                                [
                                                        21.748624,
                                                        55.756328
                                                ],
                                                [
                                                        21.745325,
                                                        55.75754
                                                ],
                                                [
                                                        21.741862,
                                                        55.759046
                                                ],
                                                [
                                                        21.741334,
                                                        55.759012
                                                ],
                                                [
                                                        21.785693,
                                                        55.76194
                                                ],
                                                [
                                                        21.798149,
                                                        55.793901
                                                ],
                                                [
                                                        21.860397,
                                                        55.780104
                                                ],
                                                [
                                                        21.893034,
                                                        55.79478
                                                ],
                                                [
                                                        21.913643,
                                                        55.821856
                                                ],
                                                [
                                                        21.961461,
                                                        55.827416
                                                ],
                                                [
                                                        21.984691,
                                                        55.849869
                                                ],
                                                [
                                                        22.018315,
                                                        55.839179
                                                ],
                                                [
                                                        22.012587,
                                                        55.830632
                                                ],
                                                [
                                                        22.072247,
                                                        55.820408
                                                ],
                                                [
                                                        22.100238,
                                                        55.840216
                                                ],
                                                [
                                                        22.123131,
                                                        55.844862
                                                ]
                                        ]
                                ]
                        },
                        "properties": {
                                "longName": "Rietavo rajonas",
                                "name": "Rietavo r. sav.",
                                "id": "74",
                                "osmId": 365576,
                                "org_id": 38
                        },
                        "id": "74"
                },
                {
                        "type": "Feature",
                        "geometry": {
                                "type": "Polygon",
                                "coordinates": [
                                        [
                                                [
                                                        24.0843,
                                                        55.879773
                                                ],
                                                [
                                                        24.076133,
                                                        55.887887
                                                ],
                                                [
                                                        24.093781,
                                                        55.91217
                                                ],
                                                [
                                                        24.094376,
                                                        55.942703
                                                ],
                                                [
                                                        24.056365,
                                                        55.942344
                                                ],
                                                [
                                                        24.049506,
                                                        55.954044
                                                ],
                                                [
                                                        24.012537,
                                                        55.961445
                                                ],
                                                [
                                                        24.027761,
                                                        55.981398
                                                ],
                                                [
                                                        24.022713,
                                                        55.999011
                                                ],
                                                [
                                                        24.042984,
                                                        56.013077
                                                ],
                                                [
                                                        24.04042,
                                                        56.037793
                                                ],
                                                [
                                                        24.069265,
                                                        56.03166
                                                ],
                                                [
                                                        24.073756,
                                                        56.069075
                                                ],
                                                [
                                                        24.104145,
                                                        56.074086
                                                ],
                                                [
                                                        24.11607,
                                                        56.109147
                                                ],
                                                [
                                                        24.128499,
                                                        56.123622
                                                ],
                                                [
                                                        24.177267,
                                                        56.12691
                                                ],
                                                [
                                                        24.172685,
                                                        56.146248
                                                ],
                                                [
                                                        24.182323,
                                                        56.171237
                                                ],
                                                [
                                                        24.151145,
                                                        56.174843
                                                ],
                                                [
                                                        24.169078,
                                                        56.194993
                                                ],
                                                [
                                                        24.142467,
                                                        56.203398
                                                ],
                                                [
                                                        24.147623,
                                                        56.215833
                                                ],
                                                [
                                                        24.129591,
                                                        56.24452
                                                ],
                                                [
                                                        24.151503,
                                                        56.253297
                                                ],
                                                [
                                                        24.176793,
                                                        56.250885
                                                ],
                                                [
                                                        24.201046,
                                                        56.26706
                                                ],
                                                [
                                                        24.240395,
                                                        56.278032
                                                ],
                                                [
                                                        24.290133,
                                                        56.285602
                                                ],
                                                [
                                                        24.295441,
                                                        56.298457
                                                ],
                                                [
                                                        24.341775,
                                                        56.295131
                                                ],
                                                [
                                                        24.357744,
                                                        56.27232
                                                ],
                                                [
                                                        24.392146,
                                                        56.27842
                                                ],
                                                [
                                                        24.423172,
                                                        56.261058
                                                ],
                                                [
                                                        24.45415,
                                                        56.258158
                                                ],
                                                [
                                                        24.461745,
                                                        56.266334
                                                ],
                                                [
                                                        24.504028,
                                                        56.27621
                                                ],
                                                [
                                                        24.503149,
                                                        56.248514
                                                ],
                                                [
                                                        24.47234,
                                                        56.212826
                                                ],
                                                [
                                                        24.491254,
                                                        56.208429
                                                ],
                                                [
                                                        24.497313,
                                                        56.182902
                                                ],
                                                [
                                                        24.520734,
                                                        56.166945
                                                ],
                                                [
                                                        24.5412,
                                                        56.170236
                                                ],
                                                [
                                                        24.561472,
                                                        56.139395
                                                ],
                                                [
                                                        24.543756,
                                                        56.124672
                                                ],
                                                [
                                                        24.596753,
                                                        56.105205
                                                ],
                                                [
                                                        24.623718,
                                                        56.134867
                                                ],
                                                [
                                                        24.638687,
                                                        56.12749
                                                ],
                                                [
                                                        24.64913,
                                                        56.092813
                                                ],
                                                [
                                                        24.673133,
                                                        56.094031
                                                ],
                                                [
                                                        24.681627,
                                                        56.055147
                                                ],
                                                [
                                                        24.62879,
                                                        56.053449
                                                ],
                                                [
                                                        24.628478,
                                                        56.033208
                                                ],
                                                [
                                                        24.600891,
                                                        56.01239
                                                ],
                                                [
                                                        24.616764,
                                                        55.972975
                                                ],
                                                [
                                                        24.602892,
                                                        55.960152
                                                ],
                                                [
                                                        24.619064,
                                                        55.951775
                                                ],
                                                [
                                                        24.607447,
                                                        55.935535
                                                ],
                                                [
                                                        24.581053,
                                                        55.928338
                                                ],
                                                [
                                                        24.585994,
                                                        55.915963
                                                ],
                                                [
                                                        24.560027,
                                                        55.908135
                                                ],
                                                [
                                                        24.542984,
                                                        55.913307
                                                ],
                                                [
                                                        24.52811,
                                                        55.892475
                                                ],
                                                [
                                                        24.566884,
                                                        55.889478
                                                ],
                                                [
                                                        24.551858,
                                                        55.874262
                                                ],
                                                [
                                                        24.424141,
                                                        55.862917
                                                ],
                                                [
                                                        24.418897,
                                                        55.902595
                                                ],
                                                [
                                                        24.396459,
                                                        55.899967
                                                ],
                                                [
                                                        24.393787,
                                                        55.920004
                                                ],
                                                [
                                                        24.363837,
                                                        55.916161
                                                ],
                                                [
                                                        24.356727,
                                                        55.892531
                                                ],
                                                [
                                                        24.280961,
                                                        55.906397
                                                ],
                                                [
                                                        24.246035,
                                                        55.904413
                                                ],
                                                [
                                                        24.239399,
                                                        55.887212
                                                ],
                                                [
                                                        24.206889,
                                                        55.888609
                                                ],
                                                [
                                                        24.208852,
                                                        55.864945
                                                ],
                                                [
                                                        24.176952,
                                                        55.840268
                                                ],
                                                [
                                                        24.113386,
                                                        55.840536
                                                ],
                                                [
                                                        24.10492,
                                                        55.880769
                                                ],
                                                [
                                                        24.0843,
                                                        55.879773
                                                ]
                                        ]
                                ]
                        },
                        "properties": {
                                "longName": "Pasvalio rajonas",
                                "name": "Pasvalio r. sav.",
                                "id": "67",
                                "osmId": 365577,
                                "org_id": 33
                        },
                        "id": "67"
                },
                {
                        "type": "Feature",
                        "geometry": {
                                "type": "Polygon",
                                "coordinates": [
                                        [
                                                [
                                                        22.023962,
                                                        55.393316
                                                ],
                                                [
                                                        21.99844,
                                                        55.35436
                                                ],
                                                [
                                                        21.966787,
                                                        55.340312
                                                ],
                                                [
                                                        21.895994,
                                                        55.287983
                                                ],
                                                [
                                                        21.884223,
                                                        55.296523
                                                ],
                                                [
                                                        21.849544,
                                                        55.269916
                                                ],
                                                [
                                                        21.865517,
                                                        55.246544
                                                ],
                                                [
                                                        21.882806,
                                                        55.238513
                                                ],
                                                [
                                                        21.865826,
                                                        55.202868
                                                ],
                                                [
                                                        21.825777,
                                                        55.211483
                                                ],
                                                [
                                                        21.790627,
                                                        55.229968
                                                ],
                                                [
                                                        21.779757,
                                                        55.223347
                                                ],
                                                [
                                                        21.74848,
                                                        55.228808
                                                ],
                                                [
                                                        21.719417,
                                                        55.211459
                                                ],
                                                [
                                                        21.691405,
                                                        55.211675
                                                ],
                                                [
                                                        21.666013,
                                                        55.199428
                                                ],
                                                [
                                                        21.649863,
                                                        55.180533
                                                ],
                                                [
                                                        21.549235,
                                                        55.197787
                                                ],
                                                [
                                                        21.51393,
                                                        55.18543
                                                ],
                                                [
                                                        21.447669,
                                                        55.22383
                                                ],
                                                [
                                                        21.433592,
                                                        55.249083
                                                ],
                                                [
                                                        21.383565,
                                                        55.294582
                                                ],
                                                [
                                                        21.333272,
                                                        55.275729
                                                ],
                                                [
                                                        21.29386,
                                                        55.251627
                                                ],
                                                [
                                                        21.271322,
                                                        55.245224
                                                ],
                                                [
                                                        21.263579498587834,
                                                        55.27727340753477
                                                ],
                                                [
                                                        21.290507319654076,
                                                        55.29894639922695
                                                ],
                                                [
                                                        21.27467342618976,
                                                        55.32622825174446
                                                ],
                                                [
                                                        21.189516626106155,
                                                        55.340595807958486
                                                ],
                                                [
                                                        21.222467602205114,
                                                        55.379942269476906
                                                ],
                                                [
                                                        21.24802732544383,
                                                        55.41657235842721
                                                ],
                                                [
                                                        21.250345,
                                                        55.466396
                                                ],
                                                [
                                                        21.338775,
                                                        55.49025
                                                ],
                                                [
                                                        21.364444,
                                                        55.479536
                                                ],
                                                [
                                                        21.357104,
                                                        55.515913
                                                ],
                                                [
                                                        21.388248,
                                                        55.524545
                                                ],
                                                [
                                                        21.398987,
                                                        55.549192
                                                ],
                                                [
                                                        21.424616,
                                                        55.545451
                                                ],
                                                [
                                                        21.439989,
                                                        55.554996
                                                ],
                                                [
                                                        21.474826,
                                                        55.541726
                                                ],
                                                [
                                                        21.541898,
                                                        55.528235
                                                ],
                                                [
                                                        21.544726,
                                                        55.539372
                                                ],
                                                [
                                                        21.57598,
                                                        55.541588
                                                ],
                                                [
                                                        21.590054,
                                                        55.555051
                                                ],
                                                [
                                                        21.583391,
                                                        55.568816
                                                ],
                                                [
                                                        21.623711,
                                                        55.563468
                                                ],
                                                [
                                                        21.660633,
                                                        55.547193
                                                ],
                                                [
                                                        21.700649,
                                                        55.515696
                                                ],
                                                [
                                                        21.738796,
                                                        55.522692
                                                ],
                                                [
                                                        21.769628,
                                                        55.542398
                                                ],
                                                [
                                                        21.786476,
                                                        55.568249
                                                ],
                                                [
                                                        21.816865,
                                                        55.555775
                                                ],
                                                [
                                                        21.812179,
                                                        55.547613
                                                ],
                                                [
                                                        21.814608,
                                                        55.54697
                                                ],
                                                [
                                                        21.816978,
                                                        55.547508
                                                ],
                                                [
                                                        21.820615,
                                                        55.547565
                                                ],
                                                [
                                                        21.824452,
                                                        55.548329
                                                ],
                                                [
                                                        21.824124,
                                                        55.549545
                                                ],
                                                [
                                                        21.835531,
                                                        55.545694
                                                ],
                                                [
                                                        21.836246,
                                                        55.544098
                                                ],
                                                [
                                                        21.834924,
                                                        55.54221
                                                ],
                                                [
                                                        21.831336,
                                                        55.54033
                                                ],
                                                [
                                                        21.829381,
                                                        55.539042
                                                ],
                                                [
                                                        21.826718,
                                                        55.537672
                                                ],
                                                [
                                                        21.827948,
                                                        55.537307
                                                ],
                                                [
                                                        21.826433,
                                                        55.533821
                                                ],
                                                [
                                                        21.826219,
                                                        55.531096
                                                ],
                                                [
                                                        21.829343,
                                                        55.528611
                                                ],
                                                [
                                                        21.82605,
                                                        55.525453
                                                ],
                                                [
                                                        21.827326,
                                                        55.522718
                                                ],
                                                [
                                                        21.824479,
                                                        55.520362
                                                ],
                                                [
                                                        21.822829,
                                                        55.519804
                                                ],
                                                [
                                                        21.822554,
                                                        55.51885
                                                ],
                                                [
                                                        21.821551,
                                                        55.518252
                                                ],
                                                [
                                                        21.822498,
                                                        55.516318
                                                ],
                                                [
                                                        21.824321,
                                                        55.516471
                                                ],
                                                [
                                                        21.827045,
                                                        55.517674
                                                ],
                                                [
                                                        21.82969,
                                                        55.512452
                                                ],
                                                [
                                                        21.83345,
                                                        55.505263
                                                ],
                                                [
                                                        21.834976,
                                                        55.500908
                                                ],
                                                [
                                                        21.834317,
                                                        55.499411
                                                ],
                                                [
                                                        21.8365,
                                                        55.494872
                                                ],
                                                [
                                                        21.83884,
                                                        55.494683
                                                ],
                                                [
                                                        21.839676,
                                                        55.495587
                                                ],
                                                [
                                                        21.844283,
                                                        55.496447
                                                ],
                                                [
                                                        21.845623,
                                                        55.498013
                                                ],
                                                [
                                                        21.846511,
                                                        55.498344
                                                ],
                                                [
                                                        21.848074,
                                                        55.498056
                                                ],
                                                [
                                                        21.853476,
                                                        55.493554
                                                ],
                                                [
                                                        21.854047,
                                                        55.491927
                                                ],
                                                [
                                                        21.857119,
                                                        55.486293
                                                ],
                                                [
                                                        21.86686,
                                                        55.466198
                                                ],
                                                [
                                                        21.871962,
                                                        55.423007
                                                ],
                                                [
                                                        21.91983,
                                                        55.436246
                                                ],
                                                [
                                                        21.971236,
                                                        55.422839
                                                ],
                                                [
                                                        22.000567,
                                                        55.424326
                                                ],
                                                [
                                                        22.002959,
                                                        55.407279
                                                ],
                                                [
                                                        22.02163,
                                                        55.407036
                                                ],
                                                [
                                                        22.019794,
                                                        55.401684
                                                ],
                                                [
                                                        22.023962,
                                                        55.393316
                                                ]
                                        ]
                                ]
                        },
                        "properties": {
                                "longName": "\u0160ilut\u0117s rajonas",
                                "name": "\u0160ilut\u0117s r. sav.",
                                "id": "88",
                                "osmId": 365578,
                                "org_id": 46
                        },
                        "id": "88"
                },
                {
                        "type": "Feature",
                        "geometry": {
                                "type": "Polygon",
                                "coordinates": [
                                        [
                                                [
                                                        21.699821,
                                                        56.069965
                                                ],
                                                [
                                                        21.644968,
                                                        56.081933
                                                ],
                                                [
                                                        21.61885,
                                                        56.091319
                                                ],
                                                [
                                                        21.622152,
                                                        56.102425
                                                ],
                                                [
                                                        21.593594,
                                                        56.10798
                                                ],
                                                [
                                                        21.534539,
                                                        56.105251
                                                ],
                                                [
                                                        21.464758,
                                                        56.11983
                                                ],
                                                [
                                                        21.472285,
                                                        56.130691
                                                ],
                                                [
                                                        21.412373,
                                                        56.141174
                                                ],
                                                [
                                                        21.408,
                                                        56.134891
                                                ],
                                                [
                                                        21.322731,
                                                        56.15213
                                                ],
                                                [
                                                        21.307783,
                                                        56.130413
                                                ],
                                                [
                                                        21.265096,
                                                        56.138644
                                                ],
                                                [
                                                        21.237569,
                                                        56.136905
                                                ],
                                                [
                                                        21.227887,
                                                        56.146563
                                                ],
                                                [
                                                        21.225693,
                                                        56.15648
                                                ],
                                                [
                                                        21.278877,
                                                        56.174415
                                                ],
                                                [
                                                        21.28256,
                                                        56.184859
                                                ],
                                                [
                                                        21.329844,
                                                        56.218588
                                                ],
                                                [
                                                        21.378373,
                                                        56.227736
                                                ],
                                                [
                                                        21.417009,
                                                        56.241948
                                                ],
                                                [
                                                        21.452102,
                                                        56.24847
                                                ],
                                                [
                                                        21.467096,
                                                        56.270708
                                                ],
                                                [
                                                        21.50211,
                                                        56.295441
                                                ],
                                                [
                                                        21.533044,
                                                        56.293147
                                                ],
                                                [
                                                        21.556991,
                                                        56.304456
                                                ],
                                                [
                                                        21.563638,
                                                        56.316849
                                                ],
                                                [
                                                        21.611239,
                                                        56.32515
                                                ],
                                                [
                                                        21.659458,
                                                        56.318615
                                                ],
                                                [
                                                        21.673737,
                                                        56.311398
                                                ],
                                                [
                                                        21.725741,
                                                        56.314077
                                                ],
                                                [
                                                        21.740662,
                                                        56.329556
                                                ],
                                                [
                                                        21.788619,
                                                        56.344426
                                                ],
                                                [
                                                        21.808424,
                                                        56.360447
                                                ],
                                                [
                                                        21.835727,
                                                        56.371584
                                                ],
                                                [
                                                        21.872085,
                                                        56.36156
                                                ],
                                                [
                                                        21.944585,
                                                        56.374752
                                                ],
                                                [
                                                        21.97824,
                                                        56.385207
                                                ],
                                                [
                                                        21.970958,
                                                        56.34881
                                                ],
                                                [
                                                        21.940147,
                                                        56.350823
                                                ],
                                                [
                                                        21.931556,
                                                        56.318736
                                                ],
                                                [
                                                        21.980453,
                                                        56.315083
                                                ],
                                                [
                                                        21.968528,
                                                        56.268845
                                                ],
                                                [
                                                        21.99135,
                                                        56.248752
                                                ],
                                                [
                                                        22.001122,
                                                        56.223018
                                                ],
                                                [
                                                        22.019424,
                                                        56.212132
                                                ],
                                                [
                                                        22.01369,
                                                        56.196445
                                                ],
                                                [
                                                        21.963552,
                                                        56.200303
                                                ],
                                                [
                                                        21.957432,
                                                        56.175803
                                                ],
                                                [
                                                        21.941191,
                                                        56.15893
                                                ],
                                                [
                                                        21.934902,
                                                        56.133002
                                                ],
                                                [
                                                        21.915798,
                                                        56.113008
                                                ],
                                                [
                                                        21.898983,
                                                        56.119625
                                                ],
                                                [
                                                        21.845032,
                                                        56.124126
                                                ],
                                                [
                                                        21.827696,
                                                        56.13147
                                                ],
                                                [
                                                        21.826047,
                                                        56.09799
                                                ],
                                                [
                                                        21.77386,
                                                        56.108707
                                                ],
                                                [
                                                        21.746093,
                                                        56.1075
                                                ],
                                                [
                                                        21.722681,
                                                        56.073021
                                                ],
                                                [
                                                        21.699821,
                                                        56.069965
                                                ]
                                        ]
                                ]
                        },
                        "properties": {
                                "longName": "Skuodo rajonas",
                                "name": "Skuodo r. sav.",
                                "id": "75",
                                "osmId": 365579,
                                "org_id": 40
                        },
                        "id": "75"
                },
                {
                        "type": "Feature",
                        "geometry": {
                                "type": "Polygon",
                                "coordinates": [
                                        [
                                                [
                                                        21.172065,
                                                        55.635203
                                                ],
                                                [
                                                        21.241092,
                                                        55.649311
                                                ],
                                                [
                                                        21.165536,
                                                        55.760806
                                                ],
                                                [
                                                        21.118405,
                                                        55.780864
                                                ],
                                                [
                                                        21.075258,
                                                        55.77419
                                                ],
                                                [
                                                        21.067495,
                                                        55.794707
                                                ],
                                                [
                                                        21.058411,
                                                        55.854593
                                                ],
                                                [
                                                        21.08273,
                                                        55.862039
                                                ],
                                                [
                                                        21.081665,
                                                        55.863632
                                                ],
                                                [
                                                        21.092609,
                                                        55.861105
                                                ],
                                                [
                                                        21.093114,
                                                        55.861977
                                                ],
                                                [
                                                        21.091288,
                                                        55.864308
                                                ],
                                                [
                                                        21.090096,
                                                        55.867702
                                                ],
                                                [
                                                        21.090238,
                                                        55.870265
                                                ],
                                                [
                                                        21.090966,
                                                        55.872282
                                                ],
                                                [
                                                        21.100829,
                                                        55.891953
                                                ],
                                                [
                                                        21.115895,
                                                        55.880912
                                                ],
                                                [
                                                        21.160449,
                                                        55.864959
                                                ],
                                                [
                                                        21.19869,
                                                        55.865763
                                                ],
                                                [
                                                        21.203044,
                                                        55.866978
                                                ],
                                                [
                                                        21.21642,
                                                        55.857341
                                                ],
                                                [
                                                        21.22078,
                                                        55.860379
                                                ],
                                                [
                                                        21.226572,
                                                        55.825619
                                                ],
                                                [
                                                        21.243844,
                                                        55.821061
                                                ],
                                                [
                                                        21.284766,
                                                        55.83946
                                                ],
                                                [
                                                        21.313173,
                                                        55.822049
                                                ],
                                                [
                                                        21.354046,
                                                        55.813156
                                                ],
                                                [
                                                        21.368526,
                                                        55.815557
                                                ],
                                                [
                                                        21.41165,
                                                        55.806369
                                                ],
                                                [
                                                        21.42206,
                                                        55.822725
                                                ],
                                                [
                                                        21.448625,
                                                        55.817434
                                                ],
                                                [
                                                        21.45338,
                                                        55.802704
                                                ],
                                                [
                                                        21.4742,
                                                        55.786431
                                                ],
                                                [
                                                        21.496928,
                                                        55.787512
                                                ],
                                                [
                                                        21.511854,
                                                        55.809066
                                                ],
                                                [
                                                        21.554115,
                                                        55.798039
                                                ],
                                                [
                                                        21.60419,
                                                        55.807999
                                                ],
                                                [
                                                        21.60625,
                                                        55.804641
                                                ],
                                                [
                                                        21.601305,
                                                        55.79801
                                                ],
                                                [
                                                        21.60822,
                                                        55.795941
                                                ],
                                                [
                                                        21.61522,
                                                        55.789256
                                                ],
                                                [
                                                        21.615988,
                                                        55.790992
                                                ],
                                                [
                                                        21.61686,
                                                        55.79134
                                                ],
                                                [
                                                        21.621609,
                                                        55.788332
                                                ],
                                                [
                                                        21.618576,
                                                        55.786849
                                                ],
                                                [
                                                        21.620309,
                                                        55.785429
                                                ],
                                                [
                                                        21.622819,
                                                        55.785161
                                                ],
                                                [
                                                        21.628299,
                                                        55.786121
                                                ],
                                                [
                                                        21.628502,
                                                        55.780261
                                                ],
                                                [
                                                        21.628915,
                                                        55.777681
                                                ],
                                                [
                                                        21.625252,
                                                        55.777431
                                                ],
                                                [
                                                        21.625313,
                                                        55.774065
                                                ],
                                                [
                                                        21.62584,
                                                        55.773728
                                                ],
                                                [
                                                        21.627761,
                                                        55.773871
                                                ],
                                                [
                                                        21.630138,
                                                        55.77136
                                                ],
                                                [
                                                        21.633195,
                                                        55.771303
                                                ],
                                                [
                                                        21.635144,
                                                        55.772168
                                                ],
                                                [
                                                        21.635342,
                                                        55.773127
                                                ],
                                                [
                                                        21.636828,
                                                        55.772491
                                                ],
                                                [
                                                        21.638392,
                                                        55.772336
                                                ],
                                                [
                                                        21.639151,
                                                        55.76998
                                                ],
                                                [
                                                        21.627612,
                                                        55.768085
                                                ],
                                                [
                                                        21.628131,
                                                        55.76702
                                                ],
                                                [
                                                        21.626803,
                                                        55.764239
                                                ],
                                                [
                                                        21.62768,
                                                        55.76385
                                                ],
                                                [
                                                        21.628696,
                                                        55.762189
                                                ],
                                                [
                                                        21.628973,
                                                        55.76056
                                                ],
                                                [
                                                        21.626912,
                                                        55.757153
                                                ],
                                                [
                                                        21.62654,
                                                        55.755308
                                                ],
                                                [
                                                        21.625951,
                                                        55.754441
                                                ],
                                                [
                                                        21.626779,
                                                        55.753074
                                                ],
                                                [
                                                        21.628546,
                                                        55.75289
                                                ],
                                                [
                                                        21.628575,
                                                        55.75377
                                                ],
                                                [
                                                        21.630069,
                                                        55.753495
                                                ],
                                                [
                                                        21.631409,
                                                        55.753813
                                                ],
                                                [
                                                        21.633306,
                                                        55.752412
                                                ],
                                                [
                                                        21.633572,
                                                        55.751463
                                                ],
                                                [
                                                        21.636212,
                                                        55.752347
                                                ],
                                                [
                                                        21.637362,
                                                        55.752436
                                                ],
                                                [
                                                        21.641994,
                                                        55.75069
                                                ],
                                                [
                                                        21.642878,
                                                        55.750727
                                                ],
                                                [
                                                        21.642967,
                                                        55.751859
                                                ],
                                                [
                                                        21.644186,
                                                        55.752247
                                                ],
                                                [
                                                        21.646765,
                                                        55.750874
                                                ],
                                                [
                                                        21.645638,
                                                        55.750075
                                                ],
                                                [
                                                        21.647073,
                                                        55.749164
                                                ],
                                                [
                                                        21.648266,
                                                        55.74916
                                                ],
                                                [
                                                        21.651862,
                                                        55.74995
                                                ],
                                                [
                                                        21.653153,
                                                        55.75059
                                                ],
                                                [
                                                        21.654331,
                                                        55.750508
                                                ],
                                                [
                                                        21.654634,
                                                        55.751322
                                                ],
                                                [
                                                        21.656758,
                                                        55.751427
                                                ],
                                                [
                                                        21.65635,
                                                        55.752236
                                                ],
                                                [
                                                        21.657777,
                                                        55.753533
                                                ],
                                                [
                                                        21.659645,
                                                        55.753747
                                                ],
                                                [
                                                        21.661208,
                                                        55.754602
                                                ],
                                                [
                                                        21.662449,
                                                        55.758255
                                                ],
                                                [
                                                        21.664454,
                                                        55.760731
                                                ],
                                                [
                                                        21.666695,
                                                        55.761366
                                                ],
                                                [
                                                        21.671132,
                                                        55.759425
                                                ],
                                                [
                                                        21.69132,
                                                        55.754759
                                                ],
                                                [
                                                        21.695587,
                                                        55.753487
                                                ],
                                                [
                                                        21.69513,
                                                        55.752427
                                                ],
                                                [
                                                        21.696191,
                                                        55.751872
                                                ],
                                                [
                                                        21.698423,
                                                        55.751818
                                                ],
                                                [
                                                        21.700909,
                                                        55.752348
                                                ],
                                                [
                                                        21.713186,
                                                        55.748872
                                                ],
                                                [
                                                        21.71496,
                                                        55.750772
                                                ],
                                                [
                                                        21.716436,
                                                        55.751059
                                                ],
                                                [
                                                        21.716683,
                                                        55.751809
                                                ],
                                                [
                                                        21.721637,
                                                        55.754752
                                                ],
                                                [
                                                        21.725333,
                                                        55.753714
                                                ],
                                                [
                                                        21.726142,
                                                        55.750308
                                                ],
                                                [
                                                        21.728858,
                                                        55.749788
                                                ],
                                                [
                                                        21.731419,
                                                        55.750825
                                                ],
                                                [
                                                        21.733437,
                                                        55.750407
                                                ],
                                                [
                                                        21.734456,
                                                        55.752348
                                                ],
                                                [
                                                        21.735012,
                                                        55.755389
                                                ],
                                                [
                                                        21.739,
                                                        55.754649
                                                ],
                                                [
                                                        21.741334,
                                                        55.759012
                                                ],
                                                [
                                                        21.741862,
                                                        55.759046
                                                ],
                                                [
                                                        21.745325,
                                                        55.75754
                                                ],
                                                [
                                                        21.748624,
                                                        55.756328
                                                ],
                                                [
                                                        21.755782,
                                                        55.753308
                                                ],
                                                [
                                                        21.763378,
                                                        55.749627
                                                ],
                                                [
                                                        21.762303,
                                                        55.748549
                                                ],
                                                [
                                                        21.76264,
                                                        55.745156
                                                ],
                                                [
                                                        21.761432,
                                                        55.74174
                                                ],
                                                [
                                                        21.76104,
                                                        55.738161
                                                ],
                                                [
                                                        21.760544,
                                                        55.737068
                                                ],
                                                [
                                                        21.762082,
                                                        55.735385
                                                ],
                                                [
                                                        21.763669,
                                                        55.734209
                                                ],
                                                [
                                                        21.765578,
                                                        55.733435
                                                ],
                                                [
                                                        21.766006,
                                                        55.73262
                                                ],
                                                [
                                                        21.767593,
                                                        55.731577
                                                ],
                                                [
                                                        21.768708,
                                                        55.729687
                                                ],
                                                [
                                                        21.765802,
                                                        55.728571
                                                ],
                                                [
                                                        21.763867,
                                                        55.728198
                                                ],
                                                [
                                                        21.757932,
                                                        55.725868
                                                ],
                                                [
                                                        21.755981,
                                                        55.723368
                                                ],
                                                [
                                                        21.754274,
                                                        55.721946
                                                ],
                                                [
                                                        21.754383,
                                                        55.720777
                                                ],
                                                [
                                                        21.755242,
                                                        55.719227
                                                ],
                                                [
                                                        21.753085,
                                                        55.716352
                                                ],
                                                [
                                                        21.752941,
                                                        55.714672
                                                ],
                                                [
                                                        21.751476,
                                                        55.713399
                                                ],
                                                [
                                                        21.751379,
                                                        55.712352
                                                ],
                                                [
                                                        21.752988,
                                                        55.712144
                                                ],
                                                [
                                                        21.75837,
                                                        55.710593
                                                ],
                                                [
                                                        21.761926,
                                                        55.707289
                                                ],
                                                [
                                                        21.76391,
                                                        55.704554
                                                ],
                                                [
                                                        21.762659,
                                                        55.704131
                                                ],
                                                [
                                                        21.780478,
                                                        55.701757
                                                ],
                                                [
                                                        21.786124,
                                                        55.695336
                                                ],
                                                [
                                                        21.787879,
                                                        55.693572
                                                ],
                                                [
                                                        21.789445,
                                                        55.691149
                                                ],
                                                [
                                                        21.79766,
                                                        55.689721
                                                ],
                                                [
                                                        21.80388,
                                                        55.689904
                                                ],
                                                [
                                                        21.804078,
                                                        55.689526
                                                ],
                                                [
                                                        21.800613,
                                                        55.687572
                                                ],
                                                [
                                                        21.799489,
                                                        55.686464
                                                ],
                                                [
                                                        21.797115,
                                                        55.684894
                                                ],
                                                [
                                                        21.792916,
                                                        55.684055
                                                ],
                                                [
                                                        21.791381,
                                                        55.683122
                                                ],
                                                [
                                                        21.794061,
                                                        55.680599
                                                ],
                                                [
                                                        21.787876,
                                                        55.671464
                                                ],
                                                [
                                                        21.788453,
                                                        55.670728
                                                ],
                                                [
                                                        21.781249,
                                                        55.661828
                                                ],
                                                [
                                                        21.787602,
                                                        55.66087
                                                ],
                                                [
                                                        21.787968,
                                                        55.66051
                                                ],
                                                [
                                                        21.789241,
                                                        55.657246
                                                ],
                                                [
                                                        21.789434,
                                                        55.655023
                                                ],
                                                [
                                                        21.791272,
                                                        55.653479
                                                ],
                                                [
                                                        21.791219,
                                                        55.652538
                                                ],
                                                [
                                                        21.796909,
                                                        55.650915
                                                ],
                                                [
                                                        21.785374,
                                                        55.649191
                                                ],
                                                [
                                                        21.782286,
                                                        55.648035
                                                ],
                                                [
                                                        21.788873,
                                                        55.641661
                                                ],
                                                [
                                                        21.794578,
                                                        55.640308
                                                ],
                                                [
                                                        21.796189,
                                                        55.639193
                                                ],
                                                [
                                                        21.799442,
                                                        55.638537
                                                ],
                                                [
                                                        21.807386,
                                                        55.637483
                                                ],
                                                [
                                                        21.80854,
                                                        55.635881
                                                ],
                                                [
                                                        21.807406,
                                                        55.633709
                                                ],
                                                [
                                                        21.807724,
                                                        55.632908
                                                ],
                                                [
                                                        21.810268,
                                                        55.631442
                                                ],
                                                [
                                                        21.810488,
                                                        55.630874
                                                ],
                                                [
                                                        21.808853,
                                                        55.628838
                                                ],
                                                [
                                                        21.812498,
                                                        55.626468
                                                ],
                                                [
                                                        21.813448,
                                                        55.623854
                                                ],
                                                [
                                                        21.810392,
                                                        55.619221
                                                ],
                                                [
                                                        21.809874,
                                                        55.618326
                                                ],
                                                [
                                                        21.823106,
                                                        55.617726
                                                ],
                                                [
                                                        21.828762,
                                                        55.617917
                                                ],
                                                [
                                                        21.843922,
                                                        55.617583
                                                ],
                                                [
                                                        21.841119,
                                                        55.616902
                                                ],
                                                [
                                                        21.840805,
                                                        55.615731
                                                ],
                                                [
                                                        21.844051,
                                                        55.613568
                                                ],
                                                [
                                                        21.879301,
                                                        55.597153
                                                ],
                                                [
                                                        21.880136,
                                                        55.596952
                                                ],
                                                [
                                                        21.878597,
                                                        55.579553
                                                ],
                                                [
                                                        21.87184,
                                                        55.576422
                                                ],
                                                [
                                                        21.860673,
                                                        55.572732
                                                ],
                                                [
                                                        21.857639,
                                                        55.571295
                                                ],
                                                [
                                                        21.845985,
                                                        55.572187
                                                ],
                                                [
                                                        21.842576,
                                                        55.568784
                                                ],
                                                [
                                                        21.839082,
                                                        55.568579
                                                ],
                                                [
                                                        21.837354,
                                                        55.569006
                                                ],
                                                [
                                                        21.835436,
                                                        55.570392
                                                ],
                                                [
                                                        21.816865,
                                                        55.555775
                                                ],
                                                [
                                                        21.786476,
                                                        55.568249
                                                ],
                                                [
                                                        21.769628,
                                                        55.542398
                                                ],
                                                [
                                                        21.738796,
                                                        55.522692
                                                ],
                                                [
                                                        21.700649,
                                                        55.515696
                                                ],
                                                [
                                                        21.660633,
                                                        55.547193
                                                ],
                                                [
                                                        21.623711,
                                                        55.563468
                                                ],
                                                [
                                                        21.583391,
                                                        55.568816
                                                ],
                                                [
                                                        21.590054,
                                                        55.555051
                                                ],
                                                [
                                                        21.57598,
                                                        55.541588
                                                ],
                                                [
                                                        21.544726,
                                                        55.539372
                                                ],
                                                [
                                                        21.541898,
                                                        55.528235
                                                ],
                                                [
                                                        21.474826,
                                                        55.541726
                                                ],
                                                [
                                                        21.439989,
                                                        55.554996
                                                ],
                                                [
                                                        21.424616,
                                                        55.545451
                                                ],
                                                [
                                                        21.398987,
                                                        55.549192
                                                ],
                                                [
                                                        21.388248,
                                                        55.524545
                                                ],
                                                [
                                                        21.357104,
                                                        55.515913
                                                ],
                                                [
                                                        21.364444,
                                                        55.479536
                                                ],
                                                [
                                                        21.338775,
                                                        55.49025
                                                ],
                                                [
                                                        21.250345,
                                                        55.466396
                                                ],
                                                [
                                                        21.246159666914018,
                                                        55.4908417508798
                                                ],
                                                [
                                                        21.233337661448243,
                                                        55.51555817660531
                                                ],
                                                [
                                                        21.20994260919935,
                                                        55.53025380322647
                                                ],
                                                [
                                                        21.20058358034201,
                                                        55.567802289285524
                                                ],
                                                [
                                                        21.177144239890797,
                                                        55.590868592136474
                                                ],
                                                [
                                                        21.161895593311485,
                                                        55.629125924333216
                                                ],
                                                [
                                                        21.172065,
                                                        55.635203
                                                ]
                                        ]
                                ]
                        },
                        "properties": {
                                "longName": "Klaip\u0117dos rajonas",
                                "name": "Klaip\u0117dos r. sav.",
                                "id": "55",
                                "osmId": 365580,
                                "org_id": 20
                        },
                        "id": "55"
                },
                {
                        "type": "Feature",
                        "geometry": {
                                "type": "Polygon",
                                "coordinates": [
                                        [
                                                [
                                                        22.635163,
                                                        56.367191
                                                ],
                                                [
                                                        22.61472,
                                                        56.358558
                                                ],
                                                [
                                                        22.570332,
                                                        56.362425
                                                ],
                                                [
                                                        22.578553,
                                                        56.340737
                                                ],
                                                [
                                                        22.6,
                                                        56.333093
                                                ],
                                                [
                                                        22.581305,
                                                        56.304101
                                                ],
                                                [
                                                        22.579725,
                                                        56.289073
                                                ],
                                                [
                                                        22.592226,
                                                        56.275519
                                                ],
                                                [
                                                        22.597882,
                                                        56.253038
                                                ],
                                                [
                                                        22.638772,
                                                        56.249817
                                                ],
                                                [
                                                        22.643922,
                                                        56.221626
                                                ],
                                                [
                                                        22.616119,
                                                        56.196592
                                                ],
                                                [
                                                        22.621177,
                                                        56.172499
                                                ],
                                                [
                                                        22.587782,
                                                        56.170292
                                                ],
                                                [
                                                        22.536623,
                                                        56.151823
                                                ],
                                                [
                                                        22.567078,
                                                        56.141165
                                                ],
                                                [
                                                        22.581528,
                                                        56.120492
                                                ],
                                                [
                                                        22.580012,
                                                        56.094627
                                                ],
                                                [
                                                        22.564438,
                                                        56.101776
                                                ],
                                                [
                                                        22.510635,
                                                        56.104703
                                                ],
                                                [
                                                        22.506727,
                                                        56.088274
                                                ],
                                                [
                                                        22.474339,
                                                        56.097386
                                                ],
                                                [
                                                        22.446797,
                                                        56.111681
                                                ],
                                                [
                                                        22.434013,
                                                        56.12646
                                                ],
                                                [
                                                        22.437484,
                                                        56.139338
                                                ],
                                                [
                                                        22.399996,
                                                        56.146103
                                                ],
                                                [
                                                        22.359371,
                                                        56.162278
                                                ],
                                                [
                                                        22.339465,
                                                        56.163667
                                                ],
                                                [
                                                        22.276951,
                                                        56.154763
                                                ],
                                                [
                                                        22.251626,
                                                        56.147383
                                                ],
                                                [
                                                        22.237903,
                                                        56.106836
                                                ],
                                                [
                                                        22.166756,
                                                        56.112568
                                                ],
                                                [
                                                        22.164822,
                                                        56.099546
                                                ],
                                                [
                                                        22.127022,
                                                        56.108624
                                                ],
                                                [
                                                        22.144206,
                                                        56.130287
                                                ],
                                                [
                                                        22.110255,
                                                        56.127277
                                                ],
                                                [
                                                        22.113325,
                                                        56.113418
                                                ],
                                                [
                                                        22.073847,
                                                        56.0902
                                                ],
                                                [
                                                        22.094754,
                                                        56.113392
                                                ],
                                                [
                                                        22.052955,
                                                        56.120761
                                                ],
                                                [
                                                        22.029169,
                                                        56.130946
                                                ],
                                                [
                                                        22.035574,
                                                        56.142248
                                                ],
                                                [
                                                        21.990287,
                                                        56.148216
                                                ],
                                                [
                                                        21.983149,
                                                        56.155487
                                                ],
                                                [
                                                        21.941191,
                                                        56.15893
                                                ],
                                                [
                                                        21.957432,
                                                        56.175803
                                                ],
                                                [
                                                        21.963552,
                                                        56.200303
                                                ],
                                                [
                                                        22.01369,
                                                        56.196445
                                                ],
                                                [
                                                        22.019424,
                                                        56.212132
                                                ],
                                                [
                                                        22.001122,
                                                        56.223018
                                                ],
                                                [
                                                        21.99135,
                                                        56.248752
                                                ],
                                                [
                                                        21.968528,
                                                        56.268845
                                                ],
                                                [
                                                        21.980453,
                                                        56.315083
                                                ],
                                                [
                                                        21.931556,
                                                        56.318736
                                                ],
                                                [
                                                        21.940147,
                                                        56.350823
                                                ],
                                                [
                                                        21.970958,
                                                        56.34881
                                                ],
                                                [
                                                        21.97824,
                                                        56.385207
                                                ],
                                                [
                                                        21.994372,
                                                        56.413459
                                                ],
                                                [
                                                        22.04612,
                                                        56.417208
                                                ],
                                                [
                                                        22.071431,
                                                        56.425346
                                                ],
                                                [
                                                        22.125848,
                                                        56.432375
                                                ],
                                                [
                                                        22.165883,
                                                        56.419598
                                                ],
                                                [
                                                        22.207345,
                                                        56.424358
                                                ],
                                                [
                                                        22.240743,
                                                        56.40005
                                                ],
                                                [
                                                        22.311061,
                                                        56.409958
                                                ],
                                                [
                                                        22.345382,
                                                        56.394188
                                                ],
                                                [
                                                        22.423043,
                                                        56.410019
                                                ],
                                                [
                                                        22.447678,
                                                        56.402843
                                                ],
                                                [
                                                        22.479611,
                                                        56.402987
                                                ],
                                                [
                                                        22.510574,
                                                        56.392867
                                                ],
                                                [
                                                        22.557544,
                                                        56.387604
                                                ],
                                                [
                                                        22.580382,
                                                        56.390507
                                                ],
                                                [
                                                        22.616236,
                                                        56.382574
                                                ],
                                                [
                                                        22.635163,
                                                        56.367191
                                                ]
                                        ]
                                ]
                        },
                        "properties": {
                                "longName": "Ma\u017eeiki\u0173 rajonas",
                                "name": "Ma\u017eeiki\u0173 r. sav.",
                                "id": "61",
                                "osmId": 365581,
                                "org_id": 25
                        },
                        "id": "61"
                },
                {
                        "type": "Feature",
                        "geometry": {
                                "type": "Polygon",
                                "coordinates": [
                                        [
                                                [
                                                        22.694977,
                                                        55.908395
                                                ],
                                                [
                                                        22.677273,
                                                        55.922306
                                                ],
                                                [
                                                        22.682333,
                                                        55.939522
                                                ],
                                                [
                                                        22.658715,
                                                        55.951142
                                                ],
                                                [
                                                        22.605684,
                                                        55.951335
                                                ],
                                                [
                                                        22.607807,
                                                        55.96769
                                                ],
                                                [
                                                        22.584564,
                                                        55.978997
                                                ],
                                                [
                                                        22.613944,
                                                        55.988655
                                                ],
                                                [
                                                        22.630083,
                                                        56.016125
                                                ],
                                                [
                                                        22.621265,
                                                        56.042683
                                                ],
                                                [
                                                        22.678381,
                                                        56.053277
                                                ],
                                                [
                                                        22.700377,
                                                        56.046737
                                                ],
                                                [
                                                        22.707881,
                                                        56.064184
                                                ],
                                                [
                                                        22.739125,
                                                        56.06949
                                                ],
                                                [
                                                        22.751874,
                                                        56.077176
                                                ],
                                                [
                                                        22.796986,
                                                        56.086615
                                                ],
                                                [
                                                        22.825986,
                                                        56.087514
                                                ],
                                                [
                                                        22.839681,
                                                        56.105488
                                                ],
                                                [
                                                        22.87432,
                                                        56.116268
                                                ],
                                                [
                                                        22.921044,
                                                        56.121208
                                                ],
                                                [
                                                        22.963739,
                                                        56.14545
                                                ],
                                                [
                                                        22.950044,
                                                        56.154873
                                                ],
                                                [
                                                        22.9871,
                                                        56.171918
                                                ],
                                                [
                                                        22.973406,
                                                        56.189404
                                                ],
                                                [
                                                        23.004017,
                                                        56.19299
                                                ],
                                                [
                                                        23.038657,
                                                        56.187163
                                                ],
                                                [
                                                        23.066852,
                                                        56.202401
                                                ],
                                                [
                                                        23.09263,
                                                        56.19299
                                                ],
                                                [
                                                        23.128062,
                                                        56.203098
                                                ],
                                                [
                                                        23.163025,
                                                        56.214535
                                                ],
                                                [
                                                        23.19303,
                                                        56.204117
                                                ],
                                                [
                                                        23.200061,
                                                        56.179708
                                                ],
                                                [
                                                        23.232087,
                                                        56.169423
                                                ],
                                                [
                                                        23.256115,
                                                        56.187598
                                                ],
                                                [
                                                        23.273327,
                                                        56.185441
                                                ],
                                                [
                                                        23.313137,
                                                        56.166417
                                                ],
                                                [
                                                        23.285091,
                                                        56.14534
                                                ],
                                                [
                                                        23.350297,
                                                        56.144889
                                                ],
                                                [
                                                        23.36288,
                                                        56.129505
                                                ],
                                                [
                                                        23.409085,
                                                        56.108781
                                                ],
                                                [
                                                        23.441113,
                                                        56.104177
                                                ],
                                                [
                                                        23.439562,
                                                        56.092905
                                                ],
                                                [
                                                        23.48358,
                                                        56.086585
                                                ],
                                                [
                                                        23.54957,
                                                        56.063211
                                                ],
                                                [
                                                        23.573048,
                                                        56.053358
                                                ],
                                                [
                                                        23.547747,
                                                        56.031027
                                                ],
                                                [
                                                        23.590035,
                                                        56.018116
                                                ],
                                                [
                                                        23.54407,
                                                        55.983669
                                                ],
                                                [
                                                        23.554399,
                                                        55.966812
                                                ],
                                                [
                                                        23.572743,
                                                        55.959098
                                                ],
                                                [
                                                        23.571298,
                                                        55.92931
                                                ],
                                                [
                                                        23.552201,
                                                        55.913868
                                                ],
                                                [
                                                        23.534127,
                                                        55.919313
                                                ],
                                                [
                                                        23.50698,
                                                        55.892517
                                                ],
                                                [
                                                        23.492345,
                                                        55.885429
                                                ],
                                                [
                                                        23.454427,
                                                        55.882444
                                                ],
                                                [
                                                        23.408526,
                                                        55.841752
                                                ],
                                                [
                                                        23.389235,
                                                        55.847728
                                                ],
                                                [
                                                        23.3746,
                                                        55.836523
                                                ],
                                                [
                                                        23.388569,
                                                        55.814477
                                                ],
                                                [
                                                        23.363956,
                                                        55.797653
                                                ],
                                                [
                                                        23.326703,
                                                        55.813729
                                                ],
                                                [
                                                        23.306081,
                                                        55.778578
                                                ],
                                                [
                                                        23.234311,
                                                        55.733199
                                                ],
                                                [
                                                        23.171979,
                                                        55.760453
                                                ],
                                                [
                                                        23.107015,
                                                        55.763194
                                                ],
                                                [
                                                        23.046924,
                                                        55.783291
                                                ],
                                                [
                                                        23.012818,
                                                        55.825279
                                                ],
                                                [
                                                        22.968968,
                                                        55.823454
                                                ],
                                                [
                                                        22.967344,
                                                        55.837137
                                                ],
                                                [
                                                        22.939734,
                                                        55.849903
                                                ],
                                                [
                                                        22.960847,
                                                        55.864487
                                                ],
                                                [
                                                        22.925118,
                                                        55.872688
                                                ],
                                                [
                                                        22.915373,
                                                        55.851726
                                                ],
                                                [
                                                        22.85853,
                                                        55.868132
                                                ],
                                                [
                                                        22.808183,
                                                        55.875422
                                                ],
                                                [
                                                        22.806559,
                                                        55.888175
                                                ],
                                                [
                                                        22.753159,
                                                        55.885989
                                                ],
                                                [
                                                        22.741726,
                                                        55.905222
                                                ],
                                                [
                                                        22.694977,
                                                        55.908395
                                                ]
                                        ],
                                        [
                                                [
                                                        23.249394,
                                                        55.894823
                                                ],
                                                [
                                                        23.269089,
                                                        55.889222
                                                ],
                                                [
                                                        23.294684,
                                                        55.903656
                                                ],
                                                [
                                                        23.317535,
                                                        55.891046
                                                ],
                                                [
                                                        23.265236,
                                                        55.867458
                                                ],
                                                [
                                                        23.268691,
                                                        55.860531
                                                ],
                                                [
                                                        23.327719,
                                                        55.841065
                                                ],
                                                [
                                                        23.347095,
                                                        55.871391
                                                ],
                                                [
                                                        23.370411,
                                                        55.882575
                                                ],
                                                [
                                                        23.385562,
                                                        55.872509
                                                ],
                                                [
                                                        23.416519,
                                                        55.874396
                                                ],
                                                [
                                                        23.429009,
                                                        55.886184
                                                ],
                                                [
                                                        23.4185,
                                                        55.898112
                                                ],
                                                [
                                                        23.349996,
                                                        55.932573
                                                ],
                                                [
                                                        23.345987,
                                                        55.962785
                                                ],
                                                [
                                                        23.312919,
                                                        55.969937
                                                ],
                                                [
                                                        23.280235,
                                                        55.960765
                                                ],
                                                [
                                                        23.284557,
                                                        55.928067
                                                ],
                                                [
                                                        23.228379,
                                                        55.907432
                                                ],
                                                [
                                                        23.249394,
                                                        55.894823
                                                ]
                                        ]
                                ]
                        },
                        "properties": {
                                "longName": "\u0160iauli\u0173 rajonas",
                                "name": "\u0160iauli\u0173 r. sav.",
                                "id": "91",
                                "osmId": 365602,
                                "org_id": 44
                        },
                        "id": "91"
                },
                {
                        "type": "Feature",
                        "geometry": {
                                "type": "Polygon",
                                "coordinates": [
                                        [
                                                [
                                                        22.635163,
                                                        56.367191
                                                ],
                                                [
                                                        22.697458,
                                                        56.353212
                                                ],
                                                [
                                                        22.729094,
                                                        56.372487
                                                ],
                                                [
                                                        22.760713,
                                                        56.367276
                                                ],
                                                [
                                                        22.840366,
                                                        56.365683
                                                ],
                                                [
                                                        22.919174,
                                                        56.379018
                                                ],
                                                [
                                                        22.941501,
                                                        56.41485
                                                ],
                                                [
                                                        23.00225,
                                                        56.406424
                                                ],
                                                [
                                                        23.018895,
                                                        56.370616
                                                ],
                                                [
                                                        23.005102,
                                                        56.36846
                                                ],
                                                [
                                                        23.026941,
                                                        56.331154
                                                ],
                                                [
                                                        23.045232,
                                                        56.320038
                                                ],
                                                [
                                                        23.070297,
                                                        56.324357
                                                ],
                                                [
                                                        23.09325,
                                                        56.304638
                                                ],
                                                [
                                                        23.088279,
                                                        56.285182
                                                ],
                                                [
                                                        23.10013,
                                                        56.264237
                                                ],
                                                [
                                                        23.076433,
                                                        56.261716
                                                ],
                                                [
                                                        23.078758,
                                                        56.242692
                                                ],
                                                [
                                                        23.108358,
                                                        56.240202
                                                ],
                                                [
                                                        23.128062,
                                                        56.203098
                                                ],
                                                [
                                                        23.09263,
                                                        56.19299
                                                ],
                                                [
                                                        23.066852,
                                                        56.202401
                                                ],
                                                [
                                                        23.038657,
                                                        56.187163
                                                ],
                                                [
                                                        23.004017,
                                                        56.19299
                                                ],
                                                [
                                                        22.973406,
                                                        56.189404
                                                ],
                                                [
                                                        22.9871,
                                                        56.171918
                                                ],
                                                [
                                                        22.950044,
                                                        56.154873
                                                ],
                                                [
                                                        22.963739,
                                                        56.14545
                                                ],
                                                [
                                                        22.921044,
                                                        56.121208
                                                ],
                                                [
                                                        22.87432,
                                                        56.116268
                                                ],
                                                [
                                                        22.839681,
                                                        56.105488
                                                ],
                                                [
                                                        22.825986,
                                                        56.087514
                                                ],
                                                [
                                                        22.796986,
                                                        56.086615
                                                ],
                                                [
                                                        22.751874,
                                                        56.077176
                                                ],
                                                [
                                                        22.739125,
                                                        56.06949
                                                ],
                                                [
                                                        22.715434,
                                                        56.08371
                                                ],
                                                [
                                                        22.716755,
                                                        56.109112
                                                ],
                                                [
                                                        22.702977,
                                                        56.117227
                                                ],
                                                [
                                                        22.654364,
                                                        56.10574
                                                ],
                                                [
                                                        22.612683,
                                                        56.085912
                                                ],
                                                [
                                                        22.580012,
                                                        56.094627
                                                ],
                                                [
                                                        22.581528,
                                                        56.120492
                                                ],
                                                [
                                                        22.567078,
                                                        56.141165
                                                ],
                                                [
                                                        22.536623,
                                                        56.151823
                                                ],
                                                [
                                                        22.587782,
                                                        56.170292
                                                ],
                                                [
                                                        22.621177,
                                                        56.172499
                                                ],
                                                [
                                                        22.616119,
                                                        56.196592
                                                ],
                                                [
                                                        22.643922,
                                                        56.221626
                                                ],
                                                [
                                                        22.638772,
                                                        56.249817
                                                ],
                                                [
                                                        22.597882,
                                                        56.253038
                                                ],
                                                [
                                                        22.592226,
                                                        56.275519
                                                ],
                                                [
                                                        22.579725,
                                                        56.289073
                                                ],
                                                [
                                                        22.581305,
                                                        56.304101
                                                ],
                                                [
                                                        22.6,
                                                        56.333093
                                                ],
                                                [
                                                        22.578553,
                                                        56.340737
                                                ],
                                                [
                                                        22.570332,
                                                        56.362425
                                                ],
                                                [
                                                        22.61472,
                                                        56.358558
                                                ],
                                                [
                                                        22.635163,
                                                        56.367191
                                                ]
                                        ]
                                ]
                        },
                        "properties": {
                                "longName": "Akmen\u0117s rajonas",
                                "name": "Akmen\u0117s r. sav.",
                                "id": "32",
                                "osmId": 365607,
                                "org_id": 0
                        },
                        "id": "32"
                },
                {
                        "type": "Feature",
                        "geometry": {
                                "type": "Polygon",
                                "coordinates": [
                                        [
                                                [
                                                        22.694977,
                                                        55.908395
                                                ],
                                                [
                                                        22.741726,
                                                        55.905222
                                                ],
                                                [
                                                        22.753159,
                                                        55.885989
                                                ],
                                                [
                                                        22.806559,
                                                        55.888175
                                                ],
                                                [
                                                        22.808183,
                                                        55.875422
                                                ],
                                                [
                                                        22.85853,
                                                        55.868132
                                                ],
                                                [
                                                        22.915373,
                                                        55.851726
                                                ],
                                                [
                                                        22.925118,
                                                        55.872688
                                                ],
                                                [
                                                        22.960847,
                                                        55.864487
                                                ],
                                                [
                                                        22.939734,
                                                        55.849903
                                                ],
                                                [
                                                        22.967344,
                                                        55.837137
                                                ],
                                                [
                                                        22.968968,
                                                        55.823454
                                                ],
                                                [
                                                        23.012818,
                                                        55.825279
                                                ],
                                                [
                                                        23.046924,
                                                        55.783291
                                                ],
                                                [
                                                        23.107015,
                                                        55.763194
                                                ],
                                                [
                                                        23.171979,
                                                        55.760453
                                                ],
                                                [
                                                        23.234311,
                                                        55.733199
                                                ],
                                                [
                                                        23.208383,
                                                        55.702958
                                                ],
                                                [
                                                        23.23177,
                                                        55.696368
                                                ],
                                                [
                                                        23.242164,
                                                        55.67879
                                                ],
                                                [
                                                        23.288938,
                                                        55.680988
                                                ],
                                                [
                                                        23.30323,
                                                        55.664869
                                                ],
                                                [
                                                        23.313624,
                                                        55.633345
                                                ],
                                                [
                                                        23.330515,
                                                        55.634812
                                                ],
                                                [
                                                        23.340909,
                                                        55.612804
                                                ],
                                                [
                                                        23.32142,
                                                        55.610602
                                                ],
                                                [
                                                        23.314923,
                                                        55.576096
                                                ],
                                                [
                                                        23.326617,
                                                        55.563608
                                                ],
                                                [
                                                        23.3565,
                                                        55.564343
                                                ],
                                                [
                                                        23.361697,
                                                        55.548911
                                                ],
                                                [
                                                        23.328696,
                                                        55.545573
                                                ],
                                                [
                                                        23.256785,
                                                        55.525226
                                                ],
                                                [
                                                        23.23641,
                                                        55.533366
                                                ],
                                                [
                                                        23.228021,
                                                        55.569976
                                                ],
                                                [
                                                        23.190866,
                                                        55.555065
                                                ],
                                                [
                                                        23.127345,
                                                        55.551675
                                                ],
                                                [
                                                        23.077007,
                                                        55.534723
                                                ],
                                                [
                                                        23.079404,
                                                        55.504868
                                                ],
                                                [
                                                        23.038654,
                                                        55.504189
                                                ],
                                                [
                                                        23.000301,
                                                        55.489933
                                                ],
                                                [
                                                        22.948765,
                                                        55.485858
                                                ],
                                                [
                                                        22.898427,
                                                        55.462762
                                                ],
                                                [
                                                        22.832508,
                                                        55.474312
                                                ],
                                                [
                                                        22.848089,
                                                        55.486537
                                                ],
                                                [
                                                        22.852883,
                                                        55.503511
                                                ],
                                                [
                                                        22.773781,
                                                        55.502153
                                                ],
                                                [
                                                        22.757001,
                                                        55.51437
                                                ],
                                                [
                                                        22.718649,
                                                        55.486537
                                                ],
                                                [
                                                        22.695877,
                                                        55.487895
                                                ],
                                                [
                                                        22.675476,
                                                        55.471335
                                                ],
                                                [
                                                        22.626248,
                                                        55.476719
                                                ],
                                                [
                                                        22.622629,
                                                        55.485802
                                                ],
                                                [
                                                        22.650083,
                                                        55.496164
                                                ],
                                                [
                                                        22.577275,
                                                        55.547681
                                                ],
                                                [
                                                        22.5864,
                                                        55.566197
                                                ],
                                                [
                                                        22.549181,
                                                        55.563028
                                                ],
                                                [
                                                        22.537672,
                                                        55.584881
                                                ],
                                                [
                                                        22.508907,
                                                        55.589623
                                                ],
                                                [
                                                        22.518256,
                                                        55.626018
                                                ],
                                                [
                                                        22.489731,
                                                        55.635652
                                                ],
                                                [
                                                        22.466209,
                                                        55.67323
                                                ],
                                                [
                                                        22.481931,
                                                        55.690836
                                                ],
                                                [
                                                        22.516431,
                                                        55.689815
                                                ],
                                                [
                                                        22.530814,
                                                        55.709656
                                                ],
                                                [
                                                        22.516142,
                                                        55.731076
                                                ],
                                                [
                                                        22.525096,
                                                        55.752954
                                                ],
                                                [
                                                        22.486805,
                                                        55.788198
                                                ],
                                                [
                                                        22.583841,
                                                        55.811837
                                                ],
                                                [
                                                        22.578518,
                                                        55.863067
                                                ],
                                                [
                                                        22.632709,
                                                        55.858625
                                                ],
                                                [
                                                        22.663831,
                                                        55.879178
                                                ],
                                                [
                                                        22.653573,
                                                        55.901827
                                                ],
                                                [
                                                        22.688612,
                                                        55.893095
                                                ],
                                                [
                                                        22.694977,
                                                        55.908395
                                                ]
                                        ]
                                ]
                        },
                        "properties": {
                                "longName": "Kelm\u0117s rajonas",
                                "name": "Kelm\u0117s r. sav.",
                                "id": "54",
                                "osmId": 365608,
                                "org_id": 18
                        },
                        "id": "54"
                },
                {
                        "type": "Feature",
                        "geometry": {
                                "type": "Polygon",
                                "coordinates": [
                                        [
                                                [
                                                        23.971954,
                                                        54.492272
                                                ],
                                                [
                                                        23.968768,
                                                        54.485552
                                                ],
                                                [
                                                        23.906778,
                                                        54.483546
                                                ],
                                                [
                                                        23.910608,
                                                        54.464758
                                                ],
                                                [
                                                        23.838715,
                                                        54.470317
                                                ],
                                                [
                                                        23.796522,
                                                        54.469018
                                                ],
                                                [
                                                        23.778303,
                                                        54.459304
                                                ],
                                                [
                                                        23.758059,
                                                        54.46844
                                                ],
                                                [
                                                        23.761018,
                                                        54.478376
                                                ],
                                                [
                                                        23.786207,
                                                        54.489884
                                                ],
                                                [
                                                        23.796182,
                                                        54.502348
                                                ],
                                                [
                                                        23.766811,
                                                        54.522798
                                                ],
                                                [
                                                        23.777967,
                                                        54.535965
                                                ],
                                                [
                                                        23.760801,
                                                        54.547816
                                                ],
                                                [
                                                        23.716684,
                                                        54.542439
                                                ],
                                                [
                                                        23.68527,
                                                        54.588916
                                                ],
                                                [
                                                        23.700204,
                                                        54.592795
                                                ],
                                                [
                                                        23.675485,
                                                        54.616161
                                                ],
                                                [
                                                        23.640295,
                                                        54.615167
                                                ],
                                                [
                                                        23.626047,
                                                        54.628585
                                                ],
                                                [
                                                        23.673768,
                                                        54.639116
                                                ],
                                                [
                                                        23.652968,
                                                        54.646346
                                                ],
                                                [
                                                        23.698115,
                                                        54.671666
                                                ],
                                                [
                                                        23.692965,
                                                        54.68437
                                                ],
                                                [
                                                        23.646788,
                                                        54.714229
                                                ],
                                                [
                                                        23.656744,
                                                        54.717104
                                                ],
                                                [
                                                        23.633913,
                                                        54.744461
                                                ],
                                                [
                                                        23.645071,
                                                        54.765165
                                                ],
                                                [
                                                        23.61915,
                                                        54.772097
                                                ],
                                                [
                                                        23.632712,
                                                        54.785364
                                                ],
                                                [
                                                        23.619494,
                                                        54.795756
                                                ],
                                                [
                                                        23.652072,
                                                        54.804568
                                                ],
                                                [
                                                        23.674511,
                                                        54.810266
                                                ],
                                                [
                                                        23.762573,
                                                        54.802054
                                                ],
                                                [
                                                        23.778709,
                                                        54.765428
                                                ],
                                                [
                                                        23.805488,
                                                        54.759089
                                                ],
                                                [
                                                        23.812011,
                                                        54.742445
                                                ],
                                                [
                                                        23.839305,
                                                        54.73749
                                                ],
                                                [
                                                        23.899559,
                                                        54.746508
                                                ],
                                                [
                                                        23.933897,
                                                        54.755468
                                                ],
                                                [
                                                        23.993114,
                                                        54.757999
                                                ],
                                                [
                                                        24.023416,
                                                        54.776761
                                                ],
                                                [
                                                        24.040592,
                                                        54.772244
                                                ],
                                                [
                                                        24.078773,
                                                        54.748786
                                                ],
                                                [
                                                        24.108985,
                                                        54.752749
                                                ],
                                                [
                                                        24.124743,
                                                        54.743159
                                                ],
                                                [
                                                        24.108806,
                                                        54.733562
                                                ],
                                                [
                                                        24.082027,
                                                        54.700246
                                                ],
                                                [
                                                        24.0937,
                                                        54.681394
                                                ],
                                                [
                                                        24.140243,
                                                        54.677276
                                                ],
                                                [
                                                        24.164275,
                                                        54.69603
                                                ],
                                                [
                                                        24.235858,
                                                        54.677177
                                                ],
                                                [
                                                        24.316882,
                                                        54.667648
                                                ],
                                                [
                                                        24.335593,
                                                        54.672611
                                                ],
                                                [
                                                        24.381942,
                                                        54.662783
                                                ],
                                                [
                                                        24.38795,
                                                        54.646198
                                                ],
                                                [
                                                        24.442023,
                                                        54.626924
                                                ],
                                                [
                                                        24.457257,
                                                        54.631247
                                                ],
                                                [
                                                        24.473466,
                                                        54.61781
                                                ],
                                                [
                                                        24.456435,
                                                        54.595094
                                                ],
                                                [
                                                        24.423232,
                                                        54.587892
                                                ],
                                                [
                                                        24.414168,
                                                        54.533019
                                                ],
                                                [
                                                        24.398573,
                                                        54.522796
                                                ],
                                                [
                                                        24.342715,
                                                        54.526659
                                                ],
                                                [
                                                        24.317283,
                                                        54.520936
                                                ],
                                                [
                                                        24.27328,
                                                        54.528979
                                                ],
                                                [
                                                        24.263775,
                                                        54.555766
                                                ],
                                                [
                                                        24.205208,
                                                        54.553354
                                                ],
                                                [
                                                        24.197405,
                                                        54.536526
                                                ],
                                                [
                                                        24.170093,
                                                        54.536058
                                                ],
                                                [
                                                        24.140801,
                                                        54.553244
                                                ],
                                                [
                                                        24.152045,
                                                        54.563235
                                                ],
                                                [
                                                        24.138747,
                                                        54.577869
                                                ],
                                                [
                                                        24.103785,
                                                        54.587218
                                                ],
                                                [
                                                        24.085552,
                                                        54.607361
                                                ],
                                                [
                                                        24.056613,
                                                        54.621693
                                                ],
                                                [
                                                        24.018676,
                                                        54.624277
                                                ],
                                                [
                                                        23.986541,
                                                        54.647316
                                                ],
                                                [
                                                        23.964595,
                                                        54.643766
                                                ],
                                                [
                                                        23.957744,
                                                        54.623794
                                                ],
                                                [
                                                        23.975275,
                                                        54.607725
                                                ],
                                                [
                                                        24.008092,
                                                        54.602744
                                                ],
                                                [
                                                        24.010292,
                                                        54.586336
                                                ],
                                                [
                                                        23.986565,
                                                        54.587889
                                                ],
                                                [
                                                        23.97594,
                                                        54.571485
                                                ],
                                                [
                                                        23.891532,
                                                        54.541863
                                                ],
                                                [
                                                        23.886362,
                                                        54.531982
                                                ],
                                                [
                                                        23.927532,
                                                        54.515323
                                                ],
                                                [
                                                        23.971954,
                                                        54.492272
                                                ]
                                        ]
                                ]
                        },
                        "properties": {
                                "longName": "Prien\u0173 rajonas",
                                "name": "Prien\u0173 r. sav.",
                                "id": "69",
                                "osmId": 365609,
                                "org_id": 35
                        },
                        "id": "69"
                },
                {
                        "type": "Feature",
                        "geometry": {
                                "type": "Polygon",
                                "coordinates": [
                                        [
                                                [
                                                        21.699821,
                                                        56.069965
                                                ],
                                                [
                                                        21.722681,
                                                        56.073021
                                                ],
                                                [
                                                        21.746093,
                                                        56.1075
                                                ],
                                                [
                                                        21.77386,
                                                        56.108707
                                                ],
                                                [
                                                        21.826047,
                                                        56.09799
                                                ],
                                                [
                                                        21.827696,
                                                        56.13147
                                                ],
                                                [
                                                        21.845032,
                                                        56.124126
                                                ],
                                                [
                                                        21.898983,
                                                        56.119625
                                                ],
                                                [
                                                        21.915798,
                                                        56.113008
                                                ],
                                                [
                                                        21.934902,
                                                        56.133002
                                                ],
                                                [
                                                        21.941191,
                                                        56.15893
                                                ],
                                                [
                                                        21.983149,
                                                        56.155487
                                                ],
                                                [
                                                        21.990287,
                                                        56.148216
                                                ],
                                                [
                                                        22.035574,
                                                        56.142248
                                                ],
                                                [
                                                        22.029169,
                                                        56.130946
                                                ],
                                                [
                                                        22.052955,
                                                        56.120761
                                                ],
                                                [
                                                        22.094754,
                                                        56.113392
                                                ],
                                                [
                                                        22.073847,
                                                        56.0902
                                                ],
                                                [
                                                        22.072295,
                                                        56.068586
                                                ],
                                                [
                                                        22.083367,
                                                        56.055951
                                                ],
                                                [
                                                        22.076169,
                                                        56.039567
                                                ],
                                                [
                                                        22.109111,
                                                        56.036278
                                                ],
                                                [
                                                        22.098457,
                                                        56.0098
                                                ],
                                                [
                                                        22.065278,
                                                        55.996791
                                                ],
                                                [
                                                        22.08337,
                                                        55.966117
                                                ],
                                                [
                                                        22.076573,
                                                        55.950288
                                                ],
                                                [
                                                        22.12805,
                                                        55.936285
                                                ],
                                                [
                                                        22.132033,
                                                        55.904129
                                                ],
                                                [
                                                        22.166418,
                                                        55.893401
                                                ],
                                                [
                                                        22.162879,
                                                        55.873271
                                                ],
                                                [
                                                        22.126993,
                                                        55.866541
                                                ],
                                                [
                                                        22.123131,
                                                        55.844862
                                                ],
                                                [
                                                        22.100238,
                                                        55.840216
                                                ],
                                                [
                                                        22.072247,
                                                        55.820408
                                                ],
                                                [
                                                        22.012587,
                                                        55.830632
                                                ],
                                                [
                                                        22.018315,
                                                        55.839179
                                                ],
                                                [
                                                        21.984691,
                                                        55.849869
                                                ],
                                                [
                                                        21.961461,
                                                        55.827416
                                                ],
                                                [
                                                        21.913643,
                                                        55.821856
                                                ],
                                                [
                                                        21.893034,
                                                        55.79478
                                                ],
                                                [
                                                        21.860397,
                                                        55.780104
                                                ],
                                                [
                                                        21.798149,
                                                        55.793901
                                                ],
                                                [
                                                        21.785693,
                                                        55.76194
                                                ],
                                                [
                                                        21.741334,
                                                        55.759012
                                                ],
                                                [
                                                        21.739,
                                                        55.754649
                                                ],
                                                [
                                                        21.735012,
                                                        55.755389
                                                ],
                                                [
                                                        21.734456,
                                                        55.752348
                                                ],
                                                [
                                                        21.733437,
                                                        55.750407
                                                ],
                                                [
                                                        21.731419,
                                                        55.750825
                                                ],
                                                [
                                                        21.728858,
                                                        55.749788
                                                ],
                                                [
                                                        21.726142,
                                                        55.750308
                                                ],
                                                [
                                                        21.725333,
                                                        55.753714
                                                ],
                                                [
                                                        21.721637,
                                                        55.754752
                                                ],
                                                [
                                                        21.716683,
                                                        55.751809
                                                ],
                                                [
                                                        21.716436,
                                                        55.751059
                                                ],
                                                [
                                                        21.71496,
                                                        55.750772
                                                ],
                                                [
                                                        21.713186,
                                                        55.748872
                                                ],
                                                [
                                                        21.700909,
                                                        55.752348
                                                ],
                                                [
                                                        21.698423,
                                                        55.751818
                                                ],
                                                [
                                                        21.696191,
                                                        55.751872
                                                ],
                                                [
                                                        21.69513,
                                                        55.752427
                                                ],
                                                [
                                                        21.695587,
                                                        55.753487
                                                ],
                                                [
                                                        21.69132,
                                                        55.754759
                                                ],
                                                [
                                                        21.671132,
                                                        55.759425
                                                ],
                                                [
                                                        21.666695,
                                                        55.761366
                                                ],
                                                [
                                                        21.664454,
                                                        55.760731
                                                ],
                                                [
                                                        21.662449,
                                                        55.758255
                                                ],
                                                [
                                                        21.661208,
                                                        55.754602
                                                ],
                                                [
                                                        21.659645,
                                                        55.753747
                                                ],
                                                [
                                                        21.657777,
                                                        55.753533
                                                ],
                                                [
                                                        21.65635,
                                                        55.752236
                                                ],
                                                [
                                                        21.656758,
                                                        55.751427
                                                ],
                                                [
                                                        21.654634,
                                                        55.751322
                                                ],
                                                [
                                                        21.654331,
                                                        55.750508
                                                ],
                                                [
                                                        21.653153,
                                                        55.75059
                                                ],
                                                [
                                                        21.651862,
                                                        55.74995
                                                ],
                                                [
                                                        21.648266,
                                                        55.74916
                                                ],
                                                [
                                                        21.647073,
                                                        55.749164
                                                ],
                                                [
                                                        21.645638,
                                                        55.750075
                                                ],
                                                [
                                                        21.646765,
                                                        55.750874
                                                ],
                                                [
                                                        21.644186,
                                                        55.752247
                                                ],
                                                [
                                                        21.642967,
                                                        55.751859
                                                ],
                                                [
                                                        21.642878,
                                                        55.750727
                                                ],
                                                [
                                                        21.641994,
                                                        55.75069
                                                ],
                                                [
                                                        21.637362,
                                                        55.752436
                                                ],
                                                [
                                                        21.636212,
                                                        55.752347
                                                ],
                                                [
                                                        21.633572,
                                                        55.751463
                                                ],
                                                [
                                                        21.633306,
                                                        55.752412
                                                ],
                                                [
                                                        21.631409,
                                                        55.753813
                                                ],
                                                [
                                                        21.630069,
                                                        55.753495
                                                ],
                                                [
                                                        21.628575,
                                                        55.75377
                                                ],
                                                [
                                                        21.628546,
                                                        55.75289
                                                ],
                                                [
                                                        21.626779,
                                                        55.753074
                                                ],
                                                [
                                                        21.625951,
                                                        55.754441
                                                ],
                                                [
                                                        21.62654,
                                                        55.755308
                                                ],
                                                [
                                                        21.626912,
                                                        55.757153
                                                ],
                                                [
                                                        21.628973,
                                                        55.76056
                                                ],
                                                [
                                                        21.628696,
                                                        55.762189
                                                ],
                                                [
                                                        21.62768,
                                                        55.76385
                                                ],
                                                [
                                                        21.626803,
                                                        55.764239
                                                ],
                                                [
                                                        21.628131,
                                                        55.76702
                                                ],
                                                [
                                                        21.627612,
                                                        55.768085
                                                ],
                                                [
                                                        21.639151,
                                                        55.76998
                                                ],
                                                [
                                                        21.638392,
                                                        55.772336
                                                ],
                                                [
                                                        21.636828,
                                                        55.772491
                                                ],
                                                [
                                                        21.635342,
                                                        55.773127
                                                ],
                                                [
                                                        21.635144,
                                                        55.772168
                                                ],
                                                [
                                                        21.633195,
                                                        55.771303
                                                ],
                                                [
                                                        21.630138,
                                                        55.77136
                                                ],
                                                [
                                                        21.627761,
                                                        55.773871
                                                ],
                                                [
                                                        21.62584,
                                                        55.773728
                                                ],
                                                [
                                                        21.625313,
                                                        55.774065
                                                ],
                                                [
                                                        21.625252,
                                                        55.777431
                                                ],
                                                [
                                                        21.628915,
                                                        55.777681
                                                ],
                                                [
                                                        21.628502,
                                                        55.780261
                                                ],
                                                [
                                                        21.628299,
                                                        55.786121
                                                ],
                                                [
                                                        21.622819,
                                                        55.785161
                                                ],
                                                [
                                                        21.620309,
                                                        55.785429
                                                ],
                                                [
                                                        21.618576,
                                                        55.786849
                                                ],
                                                [
                                                        21.621609,
                                                        55.788332
                                                ],
                                                [
                                                        21.61686,
                                                        55.79134
                                                ],
                                                [
                                                        21.615988,
                                                        55.790992
                                                ],
                                                [
                                                        21.61522,
                                                        55.789256
                                                ],
                                                [
                                                        21.60822,
                                                        55.795941
                                                ],
                                                [
                                                        21.601305,
                                                        55.79801
                                                ],
                                                [
                                                        21.60625,
                                                        55.804641
                                                ],
                                                [
                                                        21.60419,
                                                        55.807999
                                                ],
                                                [
                                                        21.554115,
                                                        55.798039
                                                ],
                                                [
                                                        21.511854,
                                                        55.809066
                                                ],
                                                [
                                                        21.525699,
                                                        55.831996
                                                ],
                                                [
                                                        21.554219,
                                                        55.847223
                                                ],
                                                [
                                                        21.558753,
                                                        55.86226
                                                ],
                                                [
                                                        21.590652,
                                                        55.85953
                                                ],
                                                [
                                                        21.586185,
                                                        55.876038
                                                ],
                                                [
                                                        21.618057,
                                                        55.896868
                                                ],
                                                [
                                                        21.579714,
                                                        55.907076
                                                ],
                                                [
                                                        21.593282,
                                                        55.91687
                                                ],
                                                [
                                                        21.592783,
                                                        55.938604
                                                ],
                                                [
                                                        21.582119,
                                                        55.944403
                                                ],
                                                [
                                                        21.600511,
                                                        55.973963
                                                ],
                                                [
                                                        21.572279,
                                                        55.980246
                                                ],
                                                [
                                                        21.58624,
                                                        56.001512
                                                ],
                                                [
                                                        21.625393,
                                                        55.996326
                                                ],
                                                [
                                                        21.638582,
                                                        56.003039
                                                ],
                                                [
                                                        21.666041,
                                                        56.03923
                                                ],
                                                [
                                                        21.677993,
                                                        56.038741
                                                ],
                                                [
                                                        21.699821,
                                                        56.069965
                                                ]
                                        ]
                                ]
                        },
                        "properties": {
                                "longName": "Plung\u0117s rajonas",
                                "name": "Plung\u0117s r. sav.",
                                "id": "68",
                                "osmId": 365613,
                                "org_id": 34
                        },
                        "id": "68"
                },
                {
                        "type": "Feature",
                        "geometry": {
                                "type": "Polygon",
                                "coordinates": [
                                        [
                                                [
                                                        24.137506,
                                                        54.936073
                                                ],
                                                [
                                                        24.114497,
                                                        54.950642
                                                ],
                                                [
                                                        24.125962,
                                                        54.979004
                                                ],
                                                [
                                                        24.08446,
                                                        54.97784
                                                ],
                                                [
                                                        24.109298,
                                                        55.017974
                                                ],
                                                [
                                                        24.067744,
                                                        55.028353
                                                ],
                                                [
                                                        24.064137,
                                                        55.036706
                                                ],
                                                [
                                                        24.096994,
                                                        55.059563
                                                ],
                                                [
                                                        24.061288,
                                                        55.071752
                                                ],
                                                [
                                                        24.081422,
                                                        55.087389
                                                ],
                                                [
                                                        24.088934,
                                                        55.107707
                                                ],
                                                [
                                                        24.06061,
                                                        55.118704
                                                ],
                                                [
                                                        24.027206,
                                                        55.107763
                                                ],
                                                [
                                                        24.016772,
                                                        55.116313
                                                ],
                                                [
                                                        24.030912,
                                                        55.146574
                                                ],
                                                [
                                                        24.056454,
                                                        55.154351
                                                ],
                                                [
                                                        24.050102,
                                                        55.174845
                                                ],
                                                [
                                                        24.110499,
                                                        55.20151
                                                ],
                                                [
                                                        24.139592,
                                                        55.202083
                                                ],
                                                [
                                                        24.152682,
                                                        55.213323
                                                ],
                                                [
                                                        24.155503,
                                                        55.236067
                                                ],
                                                [
                                                        24.176671,
                                                        55.242816
                                                ],
                                                [
                                                        24.188515,
                                                        55.257297
                                                ],
                                                [
                                                        24.242183,
                                                        55.270995
                                                ],
                                                [
                                                        24.317027,
                                                        55.2696
                                                ],
                                                [
                                                        24.344836,
                                                        55.28967
                                                ],
                                                [
                                                        24.392062,
                                                        55.294771
                                                ],
                                                [
                                                        24.413674,
                                                        55.288693
                                                ],
                                                [
                                                        24.425095,
                                                        55.259478
                                                ],
                                                [
                                                        24.409504,
                                                        55.234288
                                                ],
                                                [
                                                        24.445706,
                                                        55.233084
                                                ],
                                                [
                                                        24.505598,
                                                        55.222601
                                                ],
                                                [
                                                        24.480214,
                                                        55.200008
                                                ],
                                                [
                                                        24.500313,
                                                        55.160735
                                                ],
                                                [
                                                        24.519795,
                                                        55.154052
                                                ],
                                                [
                                                        24.521392,
                                                        55.140124
                                                ],
                                                [
                                                        24.546629,
                                                        55.123317
                                                ],
                                                [
                                                        24.557965,
                                                        55.106731
                                                ],
                                                [
                                                        24.584745,
                                                        55.105651
                                                ],
                                                [
                                                        24.589553,
                                                        55.086972
                                                ],
                                                [
                                                        24.628518,
                                                        55.062321
                                                ],
                                                [
                                                        24.635556,
                                                        55.04354
                                                ],
                                                [
                                                        24.621487,
                                                        55.030585
                                                ],
                                                [
                                                        24.585094,
                                                        55.028365
                                                ],
                                                [
                                                        24.58802,
                                                        55.012883
                                                ],
                                                [
                                                        24.559458,
                                                        55.00449
                                                ],
                                                [
                                                        24.551775,
                                                        54.99068
                                                ],
                                                [
                                                        24.526134,
                                                        55.012362
                                                ],
                                                [
                                                        24.503825,
                                                        55.011018
                                                ],
                                                [
                                                        24.448177,
                                                        55.017587
                                                ],
                                                [
                                                        24.429637,
                                                        55.003708
                                                ],
                                                [
                                                        24.442168,
                                                        54.987854
                                                ],
                                                [
                                                        24.404187,
                                                        54.972558
                                                ],
                                                [
                                                        24.245445,
                                                        54.958
                                                ],
                                                [
                                                        24.214253,
                                                        54.946729
                                                ],
                                                [
                                                        24.205541,
                                                        54.955725
                                                ],
                                                [
                                                        24.137506,
                                                        54.936073
                                                ]
                                        ]
                                ]
                        },
                        "properties": {
                                "longName": "Jonavos rajonas",
                                "name": "Jonavos r. sav.",
                                "id": "46",
                                "osmId": 365616,
                                "org_id": 9
                        },
                        "id": "46"
                },
                {
                        "type": "Feature",
                        "geometry": {
                                "type": "Polygon",
                                "coordinates": [
                                        [
                                                [
                                                        23.328696,
                                                        55.545573
                                                ],
                                                [
                                                        23.391103,
                                                        55.520702
                                                ],
                                                [
                                                        23.411394,
                                                        55.504868
                                                ],
                                                [
                                                        23.474916,
                                                        55.483142
                                                ],
                                                [
                                                        23.483306,
                                                        55.498759
                                                ],
                                                [
                                                        23.476115,
                                                        55.510298
                                                ],
                                                [
                                                        23.522857,
                                                        55.517084
                                                ],
                                                [
                                                        23.569599,
                                                        55.502832
                                                ],
                                                [
                                                        23.557614,
                                                        55.4845
                                                ],
                                                [
                                                        23.567202,
                                                        55.466839
                                                ],
                                                [
                                                        23.595623,
                                                        55.468734
                                                ],
                                                [
                                                        23.574275,
                                                        55.435476
                                                ],
                                                [
                                                        23.545725,
                                                        55.42925
                                                ],
                                                [
                                                        23.555166,
                                                        55.395729
                                                ],
                                                [
                                                        23.581602,
                                                        55.396801
                                                ],
                                                [
                                                        23.60022,
                                                        55.365606
                                                ],
                                                [
                                                        23.628122,
                                                        55.341489
                                                ],
                                                [
                                                        23.622368,
                                                        55.307437
                                                ],
                                                [
                                                        23.587656,
                                                        55.280395
                                                ],
                                                [
                                                        23.569128,
                                                        55.247234
                                                ],
                                                [
                                                        23.593724,
                                                        55.249274
                                                ],
                                                [
                                                        23.59858,
                                                        55.225259
                                                ],
                                                [
                                                        23.570541,
                                                        55.214804
                                                ],
                                                [
                                                        23.582489,
                                                        55.198896
                                                ],
                                                [
                                                        23.562122,
                                                        55.176338
                                                ],
                                                [
                                                        23.526732,
                                                        55.179305
                                                ],
                                                [
                                                        23.533586,
                                                        55.200866
                                                ],
                                                [
                                                        23.504844,
                                                        55.19316
                                                ],
                                                [
                                                        23.440685,
                                                        55.208334
                                                ],
                                                [
                                                        23.402632,
                                                        55.201014
                                                ],
                                                [
                                                        23.38765,
                                                        55.211273
                                                ],
                                                [
                                                        23.365178,
                                                        55.203579
                                                ],
                                                [
                                                        23.357687,
                                                        55.234345
                                                ],
                                                [
                                                        23.294765,
                                                        55.233491
                                                ],
                                                [
                                                        23.294765,
                                                        55.224092
                                                ],
                                                [
                                                        23.240831,
                                                        55.230928
                                                ],
                                                [
                                                        23.210868,
                                                        55.221529
                                                ],
                                                [
                                                        23.179407,
                                                        55.225801
                                                ],
                                                [
                                                        23.183901,
                                                        55.264233
                                                ],
                                                [
                                                        23.150942,
                                                        55.265087
                                                ],
                                                [
                                                        23.107496,
                                                        55.249719
                                                ],
                                                [
                                                        23.073038,
                                                        55.26338
                                                ],
                                                [
                                                        23.065547,
                                                        55.248011
                                                ],
                                                [
                                                        22.993636,
                                                        55.249719
                                                ],
                                                [
                                                        23.028094,
                                                        55.273622
                                                ],
                                                [
                                                        22.975658,
                                                        55.283009
                                                ],
                                                [
                                                        22.984647,
                                                        55.312008
                                                ],
                                                [
                                                        22.930714,
                                                        55.312008
                                                ],
                                                [
                                                        22.911238,
                                                        55.307745
                                                ],
                                                [
                                                        22.870788,
                                                        55.283009
                                                ],
                                                [
                                                        22.867791,
                                                        55.305187
                                                ],
                                                [
                                                        22.815356,
                                                        55.3265
                                                ],
                                                [
                                                        22.815356,
                                                        55.366538
                                                ],
                                                [
                                                        22.803371,
                                                        55.378456
                                                ],
                                                [
                                                        22.762921,
                                                        55.375902
                                                ],
                                                [
                                                        22.735954,
                                                        55.386967
                                                ],
                                                [
                                                        22.750935,
                                                        55.409937
                                                ],
                                                [
                                                        22.747939,
                                                        55.421842
                                                ],
                                                [
                                                        22.702995,
                                                        55.412489
                                                ],
                                                [
                                                        22.695504,
                                                        55.447342
                                                ],
                                                [
                                                        22.676028,
                                                        55.454139
                                                ],
                                                [
                                                        22.675476,
                                                        55.471335
                                                ],
                                                [
                                                        22.695877,
                                                        55.487895
                                                ],
                                                [
                                                        22.718649,
                                                        55.486537
                                                ],
                                                [
                                                        22.757001,
                                                        55.51437
                                                ],
                                                [
                                                        22.773781,
                                                        55.502153
                                                ],
                                                [
                                                        22.852883,
                                                        55.503511
                                                ],
                                                [
                                                        22.848089,
                                                        55.486537
                                                ],
                                                [
                                                        22.832508,
                                                        55.474312
                                                ],
                                                [
                                                        22.898427,
                                                        55.462762
                                                ],
                                                [
                                                        22.948765,
                                                        55.485858
                                                ],
                                                [
                                                        23.000301,
                                                        55.489933
                                                ],
                                                [
                                                        23.038654,
                                                        55.504189
                                                ],
                                                [
                                                        23.079404,
                                                        55.504868
                                                ],
                                                [
                                                        23.077007,
                                                        55.534723
                                                ],
                                                [
                                                        23.127345,
                                                        55.551675
                                                ],
                                                [
                                                        23.190866,
                                                        55.555065
                                                ],
                                                [
                                                        23.228021,
                                                        55.569976
                                                ],
                                                [
                                                        23.23641,
                                                        55.533366
                                                ],
                                                [
                                                        23.256785,
                                                        55.525226
                                                ],
                                                [
                                                        23.328696,
                                                        55.545573
                                                ]
                                        ]
                                ]
                        },
                        "properties": {
                                "longName": "Raseini\u0173 rajonas",
                                "name": "Raseini\u0173 r. sav.",
                                "id": "72",
                                "osmId": 365622,
                                "org_id": 37
                        },
                        "id": "72"
                },
                {
                        "type": "Feature",
                        "geometry": {
                                "type": "Polygon",
                                "coordinates": [
                                        [
                                                [
                                                        22.297262,
                                                        55.141748
                                                ],
                                                [
                                                        22.289022,
                                                        55.149106
                                                ],
                                                [
                                                        22.246622,
                                                        55.147929
                                                ],
                                                [
                                                        22.215894,
                                                        55.154991
                                                ],
                                                [
                                                        22.192377,
                                                        55.152834
                                                ],
                                                [
                                                        22.169203,
                                                        55.173132
                                                ],
                                                [
                                                        22.126116,
                                                        55.166857
                                                ],
                                                [
                                                        22.083082,
                                                        55.151772
                                                ],
                                                [
                                                        22.058627,
                                                        55.152339
                                                ],
                                                [
                                                        22.068305,
                                                        55.169692
                                                ],
                                                [
                                                        22.043414,
                                                        55.197285
                                                ],
                                                [
                                                        22.034067,
                                                        55.220866
                                                ],
                                                [
                                                        22.040215,
                                                        55.234641
                                                ],
                                                [
                                                        22.003649,
                                                        55.247019
                                                ],
                                                [
                                                        21.906046,
                                                        55.268015
                                                ],
                                                [
                                                        21.878923,
                                                        55.279652
                                                ],
                                                [
                                                        21.895994,
                                                        55.287983
                                                ],
                                                [
                                                        21.966787,
                                                        55.340312
                                                ],
                                                [
                                                        21.99844,
                                                        55.35436
                                                ],
                                                [
                                                        22.023962,
                                                        55.393316
                                                ],
                                                [
                                                        22.056256,
                                                        55.397297
                                                ],
                                                [
                                                        22.079343,
                                                        55.371644
                                                ],
                                                [
                                                        22.109373,
                                                        55.363705
                                                ],
                                                [
                                                        22.173787,
                                                        55.369582
                                                ],
                                                [
                                                        22.227735,
                                                        55.394646
                                                ],
                                                [
                                                        22.260707,
                                                        55.380632
                                                ],
                                                [
                                                        22.317828,
                                                        55.407283
                                                ],
                                                [
                                                        22.270012,
                                                        55.440425
                                                ],
                                                [
                                                        22.290882,
                                                        55.451015
                                                ],
                                                [
                                                        22.339579,
                                                        55.459775
                                                ],
                                                [
                                                        22.389502,
                                                        55.425146
                                                ],
                                                [
                                                        22.427079,
                                                        55.425146
                                                ],
                                                [
                                                        22.457812,
                                                        55.436676
                                                ],
                                                [
                                                        22.480982,
                                                        55.430585
                                                ],
                                                [
                                                        22.569233,
                                                        55.45821
                                                ],
                                                [
                                                        22.589349,
                                                        55.443168
                                                ],
                                                [
                                                        22.61303,
                                                        55.456389
                                                ],
                                                [
                                                        22.626248,
                                                        55.476719
                                                ],
                                                [
                                                        22.675476,
                                                        55.471335
                                                ],
                                                [
                                                        22.676028,
                                                        55.454139
                                                ],
                                                [
                                                        22.695504,
                                                        55.447342
                                                ],
                                                [
                                                        22.702995,
                                                        55.412489
                                                ],
                                                [
                                                        22.747939,
                                                        55.421842
                                                ],
                                                [
                                                        22.750935,
                                                        55.409937
                                                ],
                                                [
                                                        22.735954,
                                                        55.386967
                                                ],
                                                [
                                                        22.632012,
                                                        55.369375
                                                ],
                                                [
                                                        22.637417,
                                                        55.347943
                                                ],
                                                [
                                                        22.620886,
                                                        55.344469
                                                ],
                                                [
                                                        22.638687,
                                                        55.31314
                                                ],
                                                [
                                                        22.561611,
                                                        55.311186
                                                ],
                                                [
                                                        22.542515,
                                                        55.313362
                                                ],
                                                [
                                                        22.53302,
                                                        55.284133
                                                ],
                                                [
                                                        22.546894,
                                                        55.264307
                                                ],
                                                [
                                                        22.577545,
                                                        55.259565
                                                ],
                                                [
                                                        22.582428,
                                                        55.241101
                                                ],
                                                [
                                                        22.562932,
                                                        55.233984
                                                ],
                                                [
                                                        22.577055,
                                                        55.165285
                                                ],
                                                [
                                                        22.589054,
                                                        55.155734
                                                ],
                                                [
                                                        22.580888,
                                                        55.134661
                                                ],
                                                [
                                                        22.54728,
                                                        55.140643
                                                ],
                                                [
                                                        22.433444,
                                                        55.122861
                                                ],
                                                [
                                                        22.427349,
                                                        55.134632
                                                ],
                                                [
                                                        22.399616,
                                                        55.138167
                                                ],
                                                [
                                                        22.362542,
                                                        55.132869
                                                ],
                                                [
                                                        22.355296,
                                                        55.145391
                                                ],
                                                [
                                                        22.297262,
                                                        55.141748
                                                ]
                                        ]
                                ]
                        },
                        "properties": {
                                "longName": "Taurag\u0117s rajonas",
                                "name": "Taurag\u0117s r. sav.",
                                "id": "77",
                                "osmId": 365623,
                                "org_id": 49
                        },
                        "id": "77"
                },
                {
                        "type": "Feature",
                        "geometry": {
                                "type": "Polygon",
                                "coordinates": [
                                        [
                                                [
                                                        24.470446,
                                                        54.641447
                                                ],
                                                [
                                                        24.457257,
                                                        54.631247
                                                ],
                                                [
                                                        24.442023,
                                                        54.626924
                                                ],
                                                [
                                                        24.38795,
                                                        54.646198
                                                ],
                                                [
                                                        24.381942,
                                                        54.662783
                                                ],
                                                [
                                                        24.335593,
                                                        54.672611
                                                ],
                                                [
                                                        24.316882,
                                                        54.667648
                                                ],
                                                [
                                                        24.235858,
                                                        54.677177
                                                ],
                                                [
                                                        24.164275,
                                                        54.69603
                                                ],
                                                [
                                                        24.140243,
                                                        54.677276
                                                ],
                                                [
                                                        24.0937,
                                                        54.681394
                                                ],
                                                [
                                                        24.082027,
                                                        54.700246
                                                ],
                                                [
                                                        24.108806,
                                                        54.733562
                                                ],
                                                [
                                                        24.124743,
                                                        54.743159
                                                ],
                                                [
                                                        24.148975,
                                                        54.774574
                                                ],
                                                [
                                                        24.133869,
                                                        54.808422
                                                ],
                                                [
                                                        24.167171,
                                                        54.815347
                                                ],
                                                [
                                                        24.209594,
                                                        54.801361
                                                ],
                                                [
                                                        24.241711,
                                                        54.808127
                                                ],
                                                [
                                                        24.247168,
                                                        54.818802
                                                ],
                                                [
                                                        24.208583,
                                                        54.83606
                                                ],
                                                [
                                                        24.18634,
                                                        54.858785
                                                ],
                                                [
                                                        24.136561,
                                                        54.873195
                                                ],
                                                [
                                                        24.122596,
                                                        54.892803
                                                ],
                                                [
                                                        24.102345,
                                                        54.896321
                                                ],
                                                [
                                                        24.099,
                                                        54.911831
                                                ],
                                                [
                                                        24.100556,
                                                        54.912693
                                                ],
                                                [
                                                        24.130557,
                                                        54.923486
                                                ],
                                                [
                                                        24.137506,
                                                        54.936073
                                                ],
                                                [
                                                        24.205541,
                                                        54.955725
                                                ],
                                                [
                                                        24.214253,
                                                        54.946729
                                                ],
                                                [
                                                        24.245445,
                                                        54.958
                                                ],
                                                [
                                                        24.404187,
                                                        54.972558
                                                ],
                                                [
                                                        24.442168,
                                                        54.987854
                                                ],
                                                [
                                                        24.429637,
                                                        55.003708
                                                ],
                                                [
                                                        24.448177,
                                                        55.017587
                                                ],
                                                [
                                                        24.503825,
                                                        55.011018
                                                ],
                                                [
                                                        24.526134,
                                                        55.012362
                                                ],
                                                [
                                                        24.551775,
                                                        54.99068
                                                ],
                                                [
                                                        24.581218,
                                                        54.973102
                                                ],
                                                [
                                                        24.6192,
                                                        54.974448
                                                ],
                                                [
                                                        24.649928,
                                                        54.951605
                                                ],
                                                [
                                                        24.6837,
                                                        54.942941
                                                ],
                                                [
                                                        24.689536,
                                                        54.927754
                                                ],
                                                [
                                                        24.74876,
                                                        54.9316
                                                ],
                                                [
                                                        24.766294,
                                                        54.918243
                                                ],
                                                [
                                                        24.811592,
                                                        54.903024
                                                ],
                                                [
                                                        24.810257,
                                                        54.890007
                                                ],
                                                [
                                                        24.758589,
                                                        54.876246
                                                ],
                                                [
                                                        24.777643,
                                                        54.825449
                                                ],
                                                [
                                                        24.746744,
                                                        54.815559
                                                ],
                                                [
                                                        24.65578,
                                                        54.824354
                                                ],
                                                [
                                                        24.622057,
                                                        54.829925
                                                ],
                                                [
                                                        24.592005,
                                                        54.810352
                                                ],
                                                [
                                                        24.563835,
                                                        54.81216
                                                ],
                                                [
                                                        24.545222,
                                                        54.797865
                                                ],
                                                [
                                                        24.580845,
                                                        54.795173
                                                ],
                                                [
                                                        24.57711,
                                                        54.779196
                                                ],
                                                [
                                                        24.539549,
                                                        54.734269
                                                ],
                                                [
                                                        24.503518,
                                                        54.729079
                                                ],
                                                [
                                                        24.500732,
                                                        54.716174
                                                ],
                                                [
                                                        24.463804,
                                                        54.683432
                                                ],
                                                [
                                                        24.470446,
                                                        54.641447
                                                ]
                                        ]
                                ]
                        },
                        "properties": {
                                "longName": "Kai\u0161iadori\u0173 rajonas",
                                "name": "Kai\u0161iadori\u0173 r. sav.",
                                "id": "49",
                                "osmId": 365632,
                                "org_id": 12
                        },
                        "id": "49"
                },
                {
                        "type": "Feature",
                        "geometry": {
                                "type": "Polygon",
                                "coordinates": [
                                        [
                                                [
                                                        21.848074,
                                                        55.498056
                                                ],
                                                [
                                                        21.846511,
                                                        55.498344
                                                ],
                                                [
                                                        21.845623,
                                                        55.498013
                                                ],
                                                [
                                                        21.844283,
                                                        55.496447
                                                ],
                                                [
                                                        21.839676,
                                                        55.495587
                                                ],
                                                [
                                                        21.83884,
                                                        55.494683
                                                ],
                                                [
                                                        21.8365,
                                                        55.494872
                                                ],
                                                [
                                                        21.834317,
                                                        55.499411
                                                ],
                                                [
                                                        21.834976,
                                                        55.500908
                                                ],
                                                [
                                                        21.83345,
                                                        55.505263
                                                ],
                                                [
                                                        21.82969,
                                                        55.512452
                                                ],
                                                [
                                                        21.827045,
                                                        55.517674
                                                ],
                                                [
                                                        21.824321,
                                                        55.516471
                                                ],
                                                [
                                                        21.822498,
                                                        55.516318
                                                ],
                                                [
                                                        21.821551,
                                                        55.518252
                                                ],
                                                [
                                                        21.822554,
                                                        55.51885
                                                ],
                                                [
                                                        21.822829,
                                                        55.519804
                                                ],
                                                [
                                                        21.824479,
                                                        55.520362
                                                ],
                                                [
                                                        21.827326,
                                                        55.522718
                                                ],
                                                [
                                                        21.82605,
                                                        55.525453
                                                ],
                                                [
                                                        21.829343,
                                                        55.528611
                                                ],
                                                [
                                                        21.826219,
                                                        55.531096
                                                ],
                                                [
                                                        21.826433,
                                                        55.533821
                                                ],
                                                [
                                                        21.827948,
                                                        55.537307
                                                ],
                                                [
                                                        21.826718,
                                                        55.537672
                                                ],
                                                [
                                                        21.829381,
                                                        55.539042
                                                ],
                                                [
                                                        21.831336,
                                                        55.54033
                                                ],
                                                [
                                                        21.834924,
                                                        55.54221
                                                ],
                                                [
                                                        21.836246,
                                                        55.544098
                                                ],
                                                [
                                                        21.835531,
                                                        55.545694
                                                ],
                                                [
                                                        21.824124,
                                                        55.549545
                                                ],
                                                [
                                                        21.824452,
                                                        55.548329
                                                ],
                                                [
                                                        21.820615,
                                                        55.547565
                                                ],
                                                [
                                                        21.816978,
                                                        55.547508
                                                ],
                                                [
                                                        21.814608,
                                                        55.54697
                                                ],
                                                [
                                                        21.812179,
                                                        55.547613
                                                ],
                                                [
                                                        21.816865,
                                                        55.555775
                                                ],
                                                [
                                                        21.835436,
                                                        55.570392
                                                ],
                                                [
                                                        21.837354,
                                                        55.569006
                                                ],
                                                [
                                                        21.839082,
                                                        55.568579
                                                ],
                                                [
                                                        21.842576,
                                                        55.568784
                                                ],
                                                [
                                                        21.845985,
                                                        55.572187
                                                ],
                                                [
                                                        21.857639,
                                                        55.571295
                                                ],
                                                [
                                                        21.860673,
                                                        55.572732
                                                ],
                                                [
                                                        21.87184,
                                                        55.576422
                                                ],
                                                [
                                                        21.878597,
                                                        55.579553
                                                ],
                                                [
                                                        21.880136,
                                                        55.596952
                                                ],
                                                [
                                                        21.95402,
                                                        55.606558
                                                ],
                                                [
                                                        21.973281,
                                                        55.612215
                                                ],
                                                [
                                                        22.012751,
                                                        55.606123
                                                ],
                                                [
                                                        22.044224,
                                                        55.615012
                                                ],
                                                [
                                                        22.043763,
                                                        55.624763
                                                ],
                                                [
                                                        22.071757,
                                                        55.638599
                                                ],
                                                [
                                                        22.064135,
                                                        55.64874
                                                ],
                                                [
                                                        22.094354,
                                                        55.66027
                                                ],
                                                [
                                                        22.123484,
                                                        55.651123
                                                ],
                                                [
                                                        22.153823,
                                                        55.671238
                                                ],
                                                [
                                                        22.251829,
                                                        55.684183
                                                ],
                                                [
                                                        22.26017,
                                                        55.688794
                                                ],
                                                [
                                                        22.301152,
                                                        55.667099
                                                ],
                                                [
                                                        22.311644,
                                                        55.676844
                                                ],
                                                [
                                                        22.353801,
                                                        55.6708
                                                ],
                                                [
                                                        22.364759,
                                                        55.66024
                                                ],
                                                [
                                                        22.420555,
                                                        55.669615
                                                ],
                                                [
                                                        22.446737,
                                                        55.66433
                                                ],
                                                [
                                                        22.466209,
                                                        55.67323
                                                ],
                                                [
                                                        22.489731,
                                                        55.635652
                                                ],
                                                [
                                                        22.518256,
                                                        55.626018
                                                ],
                                                [
                                                        22.508907,
                                                        55.589623
                                                ],
                                                [
                                                        22.537672,
                                                        55.584881
                                                ],
                                                [
                                                        22.549181,
                                                        55.563028
                                                ],
                                                [
                                                        22.5864,
                                                        55.566197
                                                ],
                                                [
                                                        22.577275,
                                                        55.547681
                                                ],
                                                [
                                                        22.650083,
                                                        55.496164
                                                ],
                                                [
                                                        22.622629,
                                                        55.485802
                                                ],
                                                [
                                                        22.626248,
                                                        55.476719
                                                ],
                                                [
                                                        22.61303,
                                                        55.456389
                                                ],
                                                [
                                                        22.589349,
                                                        55.443168
                                                ],
                                                [
                                                        22.569233,
                                                        55.45821
                                                ],
                                                [
                                                        22.480982,
                                                        55.430585
                                                ],
                                                [
                                                        22.457812,
                                                        55.436676
                                                ],
                                                [
                                                        22.427079,
                                                        55.425146
                                                ],
                                                [
                                                        22.389502,
                                                        55.425146
                                                ],
                                                [
                                                        22.339579,
                                                        55.459775
                                                ],
                                                [
                                                        22.290882,
                                                        55.451015
                                                ],
                                                [
                                                        22.270012,
                                                        55.440425
                                                ],
                                                [
                                                        22.317828,
                                                        55.407283
                                                ],
                                                [
                                                        22.260707,
                                                        55.380632
                                                ],
                                                [
                                                        22.227735,
                                                        55.394646
                                                ],
                                                [
                                                        22.173787,
                                                        55.369582
                                                ],
                                                [
                                                        22.109373,
                                                        55.363705
                                                ],
                                                [
                                                        22.079343,
                                                        55.371644
                                                ],
                                                [
                                                        22.056256,
                                                        55.397297
                                                ],
                                                [
                                                        22.023962,
                                                        55.393316
                                                ],
                                                [
                                                        22.019794,
                                                        55.401684
                                                ],
                                                [
                                                        22.02163,
                                                        55.407036
                                                ],
                                                [
                                                        22.002959,
                                                        55.407279
                                                ],
                                                [
                                                        22.000567,
                                                        55.424326
                                                ],
                                                [
                                                        21.971236,
                                                        55.422839
                                                ],
                                                [
                                                        21.91983,
                                                        55.436246
                                                ],
                                                [
                                                        21.871962,
                                                        55.423007
                                                ],
                                                [
                                                        21.86686,
                                                        55.466198
                                                ],
                                                [
                                                        21.857119,
                                                        55.486293
                                                ],
                                                [
                                                        21.854047,
                                                        55.491927
                                                ],
                                                [
                                                        21.853476,
                                                        55.493554
                                                ],
                                                [
                                                        21.848074,
                                                        55.498056
                                                ]
                                        ]
                                ]
                        },
                        "properties": {
                                "longName": "\u0160ilal\u0117s rajonas",
                                "name": "\u0160ilal\u0117s r. sav.",
                                "id": "87",
                                "osmId": 365633,
                                "org_id": 45
                        },
                        "id": "87"
                },
                {
                        "type": "Feature",
                        "geometry": {
                                "type": "Polygon",
                                "coordinates": [
                                        [
                                                [
                                                        24.392062,
                                                        55.294771
                                                ],
                                                [
                                                        24.344836,
                                                        55.28967
                                                ],
                                                [
                                                        24.317027,
                                                        55.2696
                                                ],
                                                [
                                                        24.242183,
                                                        55.270995
                                                ],
                                                [
                                                        24.188515,
                                                        55.257297
                                                ],
                                                [
                                                        24.176671,
                                                        55.242816
                                                ],
                                                [
                                                        24.155503,
                                                        55.236067
                                                ],
                                                [
                                                        24.152682,
                                                        55.213323
                                                ],
                                                [
                                                        24.139592,
                                                        55.202083
                                                ],
                                                [
                                                        24.110499,
                                                        55.20151
                                                ],
                                                [
                                                        24.050102,
                                                        55.174845
                                                ],
                                                [
                                                        24.056454,
                                                        55.154351
                                                ],
                                                [
                                                        24.030912,
                                                        55.146574
                                                ],
                                                [
                                                        24.016772,
                                                        55.116313
                                                ],
                                                [
                                                        23.994115,
                                                        55.128938
                                                ],
                                                [
                                                        23.943039,
                                                        55.140612
                                                ],
                                                [
                                                        23.883441,
                                                        55.16298
                                                ],
                                                [
                                                        23.863304,
                                                        55.185232
                                                ],
                                                [
                                                        23.81869,
                                                        55.167063
                                                ],
                                                [
                                                        23.810262,
                                                        55.158479
                                                ],
                                                [
                                                        23.612054,
                                                        55.156017
                                                ],
                                                [
                                                        23.587106,
                                                        55.148661
                                                ],
                                                [
                                                        23.561233,
                                                        55.157586
                                                ],
                                                [
                                                        23.562122,
                                                        55.176338
                                                ],
                                                [
                                                        23.582489,
                                                        55.198896
                                                ],
                                                [
                                                        23.570541,
                                                        55.214804
                                                ],
                                                [
                                                        23.59858,
                                                        55.225259
                                                ],
                                                [
                                                        23.593724,
                                                        55.249274
                                                ],
                                                [
                                                        23.569128,
                                                        55.247234
                                                ],
                                                [
                                                        23.587656,
                                                        55.280395
                                                ],
                                                [
                                                        23.622368,
                                                        55.307437
                                                ],
                                                [
                                                        23.628122,
                                                        55.341489
                                                ],
                                                [
                                                        23.60022,
                                                        55.365606
                                                ],
                                                [
                                                        23.581602,
                                                        55.396801
                                                ],
                                                [
                                                        23.555166,
                                                        55.395729
                                                ],
                                                [
                                                        23.545725,
                                                        55.42925
                                                ],
                                                [
                                                        23.574275,
                                                        55.435476
                                                ],
                                                [
                                                        23.595623,
                                                        55.468734
                                                ],
                                                [
                                                        23.651099,
                                                        55.464801
                                                ],
                                                [
                                                        23.653496,
                                                        55.481783
                                                ],
                                                [
                                                        23.681062,
                                                        55.49808
                                                ],
                                                [
                                                        23.727804,
                                                        55.502832
                                                ],
                                                [
                                                        23.726606,
                                                        55.513013
                                                ],
                                                [
                                                        23.852878,
                                                        55.54749
                                                ],
                                                [
                                                        23.879556,
                                                        55.557817
                                                ],
                                                [
                                                        23.914098,
                                                        55.563917
                                                ],
                                                [
                                                        23.911252,
                                                        55.540488
                                                ],
                                                [
                                                        23.940153,
                                                        55.510435
                                                ],
                                                [
                                                        23.957149,
                                                        55.503912
                                                ],
                                                [
                                                        24.002746,
                                                        55.514597
                                                ],
                                                [
                                                        24.039669,
                                                        55.479732
                                                ],
                                                [
                                                        24.0543,
                                                        55.475589
                                                ],
                                                [
                                                        24.038461,
                                                        55.443403
                                                ],
                                                [
                                                        24.063945,
                                                        55.438721
                                                ],
                                                [
                                                        24.11944,
                                                        55.450488
                                                ],
                                                [
                                                        24.120126,
                                                        55.438591
                                                ],
                                                [
                                                        24.1496,
                                                        55.437658
                                                ],
                                                [
                                                        24.163994,
                                                        55.451304
                                                ],
                                                [
                                                        24.200803,
                                                        55.450643
                                                ],
                                                [
                                                        24.201008,
                                                        55.475359
                                                ],
                                                [
                                                        24.242958,
                                                        55.466345
                                                ],
                                                [
                                                        24.242821,
                                                        55.453248
                                                ],
                                                [
                                                        24.301495,
                                                        55.438669
                                                ],
                                                [
                                                        24.318288,
                                                        55.445706
                                                ],
                                                [
                                                        24.384434,
                                                        55.435325
                                                ],
                                                [
                                                        24.384776,
                                                        55.413969
                                                ],
                                                [
                                                        24.399788,
                                                        55.392718
                                                ],
                                                [
                                                        24.43047,
                                                        55.390909
                                                ],
                                                [
                                                        24.434318,
                                                        55.386328
                                                ],
                                                [
                                                        24.38504,
                                                        55.329062
                                                ],
                                                [
                                                        24.392062,
                                                        55.294771
                                                ]
                                        ]
                                ]
                        },
                        "properties": {
                                "longName": "K\u0117daini\u0173 rajonas",
                                "name": "K\u0117daini\u0173 r. sav.",
                                "id": "53",
                                "osmId": 365634,
                                "org_id": 17
                        },
                        "id": "53"
                },
                {
                        "type": "Feature",
                        "geometry": {
                                "type": "Polygon",
                                "coordinates": [
                                        [
                                                [
                                                        22.297262,
                                                        55.141748
                                                ],
                                                [
                                                        22.355296,
                                                        55.145391
                                                ],
                                                [
                                                        22.362542,
                                                        55.132869
                                                ],
                                                [
                                                        22.399616,
                                                        55.138167
                                                ],
                                                [
                                                        22.427349,
                                                        55.134632
                                                ],
                                                [
                                                        22.433444,
                                                        55.122861
                                                ],
                                                [
                                                        22.54728,
                                                        55.140643
                                                ],
                                                [
                                                        22.580888,
                                                        55.134661
                                                ],
                                                [
                                                        22.589054,
                                                        55.155734
                                                ],
                                                [
                                                        22.577055,
                                                        55.165285
                                                ],
                                                [
                                                        22.562932,
                                                        55.233984
                                                ],
                                                [
                                                        22.582428,
                                                        55.241101
                                                ],
                                                [
                                                        22.577545,
                                                        55.259565
                                                ],
                                                [
                                                        22.546894,
                                                        55.264307
                                                ],
                                                [
                                                        22.53302,
                                                        55.284133
                                                ],
                                                [
                                                        22.542515,
                                                        55.313362
                                                ],
                                                [
                                                        22.561611,
                                                        55.311186
                                                ],
                                                [
                                                        22.638687,
                                                        55.31314
                                                ],
                                                [
                                                        22.620886,
                                                        55.344469
                                                ],
                                                [
                                                        22.637417,
                                                        55.347943
                                                ],
                                                [
                                                        22.632012,
                                                        55.369375
                                                ],
                                                [
                                                        22.735954,
                                                        55.386967
                                                ],
                                                [
                                                        22.762921,
                                                        55.375902
                                                ],
                                                [
                                                        22.803371,
                                                        55.378456
                                                ],
                                                [
                                                        22.815356,
                                                        55.366538
                                                ],
                                                [
                                                        22.815356,
                                                        55.3265
                                                ],
                                                [
                                                        22.867791,
                                                        55.305187
                                                ],
                                                [
                                                        22.870788,
                                                        55.283009
                                                ],
                                                [
                                                        22.911238,
                                                        55.307745
                                                ],
                                                [
                                                        22.930714,
                                                        55.312008
                                                ],
                                                [
                                                        22.984647,
                                                        55.312008
                                                ],
                                                [
                                                        22.975658,
                                                        55.283009
                                                ],
                                                [
                                                        23.028094,
                                                        55.273622
                                                ],
                                                [
                                                        22.993636,
                                                        55.249719
                                                ],
                                                [
                                                        23.065547,
                                                        55.248011
                                                ],
                                                [
                                                        23.073038,
                                                        55.26338
                                                ],
                                                [
                                                        23.107496,
                                                        55.249719
                                                ],
                                                [
                                                        23.150942,
                                                        55.265087
                                                ],
                                                [
                                                        23.183901,
                                                        55.264233
                                                ],
                                                [
                                                        23.179407,
                                                        55.225801
                                                ],
                                                [
                                                        23.210868,
                                                        55.221529
                                                ],
                                                [
                                                        23.240831,
                                                        55.230928
                                                ],
                                                [
                                                        23.294765,
                                                        55.224092
                                                ],
                                                [
                                                        23.294765,
                                                        55.233491
                                                ],
                                                [
                                                        23.357687,
                                                        55.234345
                                                ],
                                                [
                                                        23.365178,
                                                        55.203579
                                                ],
                                                [
                                                        23.38765,
                                                        55.211273
                                                ],
                                                [
                                                        23.402632,
                                                        55.201014
                                                ],
                                                [
                                                        23.440685,
                                                        55.208334
                                                ],
                                                [
                                                        23.504844,
                                                        55.19316
                                                ],
                                                [
                                                        23.482825,
                                                        55.168158
                                                ],
                                                [
                                                        23.480769,
                                                        55.124919
                                                ],
                                                [
                                                        23.454004,
                                                        55.104202
                                                ],
                                                [
                                                        23.44004,
                                                        55.083447
                                                ],
                                                [
                                                        23.412358,
                                                        55.073543
                                                ],
                                                [
                                                        23.315688,
                                                        55.068043
                                                ],
                                                [
                                                        23.195358,
                                                        55.08735
                                                ],
                                                [
                                                        23.126174,
                                                        55.090055
                                                ],
                                                [
                                                        23.064719,
                                                        55.104395
                                                ],
                                                [
                                                        23.019443,
                                                        55.102259
                                                ],
                                                [
                                                        22.933487,
                                                        55.08245
                                                ],
                                                [
                                                        22.896834,
                                                        55.083374
                                                ],
                                                [
                                                        22.874164,
                                                        55.08952
                                                ],
                                                [
                                                        22.841212,
                                                        55.086198
                                                ],
                                                [
                                                        22.81478,
                                                        55.0762
                                                ],
                                                [
                                                        22.78489,
                                                        55.076602
                                                ],
                                                [
                                                        22.741055,
                                                        55.059166
                                                ],
                                                [
                                                        22.714458,
                                                        55.058342
                                                ],
                                                [
                                                        22.665434,
                                                        55.04956
                                                ],
                                                [
                                                        22.635417,
                                                        55.052537
                                                ],
                                                [
                                                        22.589129,
                                                        55.070525
                                                ],
                                                [
                                                        22.548155,
                                                        55.065836
                                                ],
                                                [
                                                        22.48519,
                                                        55.046216
                                                ],
                                                [
                                                        22.464888,
                                                        55.044409
                                                ],
                                                [
                                                        22.424043,
                                                        55.054266
                                                ],
                                                [
                                                        22.391806,
                                                        55.053296
                                                ],
                                                [
                                                        22.345458,
                                                        55.061949
                                                ],
                                                [
                                                        22.275282,
                                                        55.063967
                                                ],
                                                [
                                                        22.261556,
                                                        55.117213
                                                ],
                                                [
                                                        22.297262,
                                                        55.141748
                                                ]
                                        ]
                                ]
                        },
                        "properties": {
                                "longName": "Jurbarko rajonas",
                                "name": "Jurbarko r. sav.",
                                "id": "94",
                                "osmId": 365635,
                                "org_id": 11
                        },
                        "id": "94"
                },
                {
                        "type": "Feature",
                        "geometry": {
                                "type": "Polygon",
                                "coordinates": [
                                        [
                                                [
                                                        26.407564,
                                                        55.60151
                                                ],
                                                [
                                                        26.419303,
                                                        55.618486
                                                ],
                                                [
                                                        26.462924,
                                                        55.596738
                                                ],
                                                [
                                                        26.493445,
                                                        55.609205
                                                ],
                                                [
                                                        26.530264,
                                                        55.60443
                                                ],
                                                [
                                                        26.574302,
                                                        55.612294
                                                ],
                                                [
                                                        26.59799,
                                                        55.607712
                                                ],
                                                [
                                                        26.600176,
                                                        55.596427
                                                ],
                                                [
                                                        26.554364,
                                                        55.577906
                                                ],
                                                [
                                                        26.527304,
                                                        55.562042
                                                ],
                                                [
                                                        26.446739,
                                                        55.561209
                                                ],
                                                [
                                                        26.41536,
                                                        55.55065
                                                ],
                                                [
                                                        26.390361,
                                                        55.574227
                                                ],
                                                [
                                                        26.393265,
                                                        55.591385
                                                ],
                                                [
                                                        26.407564,
                                                        55.60151
                                                ]
                                        ]
                                ]
                        },
                        "properties": {
                                "longName": "Visagino m. savivaldyb\u0117",
                                "name": "Visagino m. sav.",
                                "id": 58,
                                "osmId": 366508
                        },
                        "id": 58
                },
                {
                        "type": "Feature",
                        "geometry": {
                                "type": "Polygon",
                                "coordinates": [
                                        [
                                                [
                                                        26.407564,
                                                        55.60151
                                                ],
                                                [
                                                        26.393265,
                                                        55.591385
                                                ],
                                                [
                                                        26.390361,
                                                        55.574227
                                                ],
                                                [
                                                        26.41536,
                                                        55.55065
                                                ],
                                                [
                                                        26.446739,
                                                        55.561209
                                                ],
                                                [
                                                        26.527304,
                                                        55.562042
                                                ],
                                                [
                                                        26.554364,
                                                        55.577906
                                                ],
                                                [
                                                        26.600176,
                                                        55.596427
                                                ],
                                                [
                                                        26.622352,
                                                        55.570576
                                                ],
                                                [
                                                        26.587087,
                                                        55.538713
                                                ],
                                                [
                                                        26.534626,
                                                        55.52425
                                                ],
                                                [
                                                        26.524882,
                                                        55.509481
                                                ],
                                                [
                                                        26.556816,
                                                        55.46356
                                                ],
                                                [
                                                        26.540045,
                                                        55.441446
                                                ],
                                                [
                                                        26.559234,
                                                        55.41113
                                                ],
                                                [
                                                        26.554102,
                                                        55.38882
                                                ],
                                                [
                                                        26.511044,
                                                        55.37949
                                                ],
                                                [
                                                        26.50345,
                                                        55.369875
                                                ],
                                                [
                                                        26.474728,
                                                        55.370105
                                                ],
                                                [
                                                        26.471895,
                                                        55.356862
                                                ],
                                                [
                                                        26.445629,
                                                        55.348979
                                                ],
                                                [
                                                        26.49521,
                                                        55.334234
                                                ],
                                                [
                                                        26.546487,
                                                        55.328971
                                                ],
                                                [
                                                        26.588477,
                                                        55.318931
                                                ],
                                                [
                                                        26.631526,
                                                        55.322095
                                                ],
                                                [
                                                        26.644403,
                                                        55.334649
                                                ],
                                                [
                                                        26.668586,
                                                        55.338355
                                                ],
                                                [
                                                        26.719945,
                                                        55.321832
                                                ],
                                                [
                                                        26.792037,
                                                        55.32127
                                                ],
                                                [
                                                        26.831961,
                                                        55.306845
                                                ],
                                                [
                                                        26.835492,
                                                        55.285549
                                                ],
                                                [
                                                        26.798069,
                                                        55.273604
                                                ],
                                                [
                                                        26.780478,
                                                        55.260023
                                                ],
                                                [
                                                        26.745408,
                                                        55.254777
                                                ],
                                                [
                                                        26.755198,
                                                        55.265647
                                                ],
                                                [
                                                        26.664003,
                                                        55.26116
                                                ],
                                                [
                                                        26.641303,
                                                        55.263795
                                                ],
                                                [
                                                        26.611942,
                                                        55.253858
                                                ],
                                                [
                                                        26.613643,
                                                        55.241692
                                                ],
                                                [
                                                        26.596582,
                                                        55.228715
                                                ],
                                                [
                                                        26.567962,
                                                        55.22853
                                                ],
                                                [
                                                        26.553769,
                                                        55.219481
                                                ],
                                                [
                                                        26.523894,
                                                        55.225072
                                                ],
                                                [
                                                        26.517842,
                                                        55.214695
                                                ],
                                                [
                                                        26.48474,
                                                        55.212892
                                                ],
                                                [
                                                        26.4572,
                                                        55.218912
                                                ],
                                                [
                                                        26.446597,
                                                        55.21038
                                                ],
                                                [
                                                        26.380382,
                                                        55.224604
                                                ],
                                                [
                                                        26.361853,
                                                        55.218896
                                                ],
                                                [
                                                        26.326026,
                                                        55.220074
                                                ],
                                                [
                                                        26.281789,
                                                        55.228884
                                                ],
                                                [
                                                        26.255198,
                                                        55.226616
                                                ],
                                                [
                                                        26.196393,
                                                        55.241804
                                                ],
                                                [
                                                        26.186049,
                                                        55.223098
                                                ],
                                                [
                                                        26.153626,
                                                        55.225561
                                                ],
                                                [
                                                        26.174751,
                                                        55.253492
                                                ],
                                                [
                                                        26.150993,
                                                        55.261395
                                                ],
                                                [
                                                        26.148914,
                                                        55.282888
                                                ],
                                                [
                                                        26.121746,
                                                        55.293621
                                                ],
                                                [
                                                        26.102468,
                                                        55.288241
                                                ],
                                                [
                                                        26.06925,
                                                        55.2965
                                                ],
                                                [
                                                        26.022941,
                                                        55.279176
                                                ],
                                                [
                                                        25.993621,
                                                        55.273531
                                                ],
                                                [
                                                        25.939577,
                                                        55.287356
                                                ],
                                                [
                                                        25.89645,
                                                        55.289159
                                                ],
                                                [
                                                        25.862674,
                                                        55.303235
                                                ],
                                                [
                                                        25.871967,
                                                        55.336901
                                                ],
                                                [
                                                        25.888415,
                                                        55.362329
                                                ],
                                                [
                                                        25.944109,
                                                        55.344447
                                                ],
                                                [
                                                        25.970214,
                                                        55.358523
                                                ],
                                                [
                                                        25.950897,
                                                        55.374871
                                                ],
                                                [
                                                        25.937946,
                                                        55.396162
                                                ],
                                                [
                                                        25.916339,
                                                        55.410993
                                                ],
                                                [
                                                        25.933752,
                                                        55.421938
                                                ],
                                                [
                                                        25.960813,
                                                        55.410418
                                                ],
                                                [
                                                        25.980875,
                                                        55.409624
                                                ],
                                                [
                                                        26.003503,
                                                        55.420416
                                                ],
                                                [
                                                        26.039482,
                                                        55.397412
                                                ],
                                                [
                                                        26.043073,
                                                        55.437477
                                                ],
                                                [
                                                        26.019911,
                                                        55.443833
                                                ],
                                                [
                                                        26.024999,
                                                        55.4634
                                                ],
                                                [
                                                        25.994755,
                                                        55.470989
                                                ],
                                                [
                                                        25.980876,
                                                        55.488799
                                                ],
                                                [
                                                        25.982522,
                                                        55.526356
                                                ],
                                                [
                                                        26.013171,
                                                        55.516148
                                                ],
                                                [
                                                        26.077454,
                                                        55.522069
                                                ],
                                                [
                                                        26.109288,
                                                        55.52172
                                                ],
                                                [
                                                        26.107054,
                                                        55.534062
                                                ],
                                                [
                                                        26.149762,
                                                        55.53635
                                                ],
                                                [
                                                        26.183877,
                                                        55.531345
                                                ],
                                                [
                                                        26.22848,
                                                        55.540068
                                                ],
                                                [
                                                        26.223568,
                                                        55.556004
                                                ],
                                                [
                                                        26.249076,
                                                        55.599007
                                                ],
                                                [
                                                        26.277699,
                                                        55.611879
                                                ],
                                                [
                                                        26.317841,
                                                        55.603
                                                ],
                                                [
                                                        26.407564,
                                                        55.60151
                                                ]
                                        ]
                                ]
                        },
                        "properties": {
                                "longName": "Ignalinos rajonas",
                                "name": "Ignalinos r. sav.",
                                "id": "45",
                                "osmId": 366509,
                                "org_id": 8
                        },
                        "id": "45"
                },
                {
                        "type": "Feature",
                        "geometry": {
                                "type": "Polygon",
                                "coordinates": [
                                        [
                                                [
                                                        26.045737,
                                                        55.944546
                                                ],
                                                [
                                                        26.089994,
                                                        55.900913
                                                ],
                                                [
                                                        26.120283,
                                                        55.879457
                                                ],
                                                [
                                                        26.151147,
                                                        55.87679
                                                ],
                                                [
                                                        26.173234,
                                                        55.865368
                                                ],
                                                [
                                                        26.203749,
                                                        55.858882
                                                ],
                                                [
                                                        26.229389,
                                                        55.83821
                                                ],
                                                [
                                                        26.231222,
                                                        55.812432
                                                ],
                                                [
                                                        26.268622,
                                                        55.767726
                                                ],
                                                [
                                                        26.308239,
                                                        55.744815
                                                ],
                                                [
                                                        26.35003,
                                                        55.742385
                                                ],
                                                [
                                                        26.36553,
                                                        55.731552
                                                ],
                                                [
                                                        26.375627,
                                                        55.709396
                                                ],
                                                [
                                                        26.44305,
                                                        55.709014
                                                ],
                                                [
                                                        26.470511,
                                                        55.702769
                                                ],
                                                [
                                                        26.492901,
                                                        55.687969
                                                ],
                                                [
                                                        26.530841,
                                                        55.676963
                                                ],
                                                [
                                                        26.572392,
                                                        55.680074
                                                ],
                                                [
                                                        26.597491,
                                                        55.674663
                                                ],
                                                [
                                                        26.630365,
                                                        55.680667
                                                ],
                                                [
                                                        26.638205,
                                                        55.653831
                                                ],
                                                [
                                                        26.633785,
                                                        55.610488
                                                ],
                                                [
                                                        26.63781,
                                                        55.599226
                                                ],
                                                [
                                                        26.622352,
                                                        55.570576
                                                ],
                                                [
                                                        26.600176,
                                                        55.596427
                                                ],
                                                [
                                                        26.59799,
                                                        55.607712
                                                ],
                                                [
                                                        26.574302,
                                                        55.612294
                                                ],
                                                [
                                                        26.530264,
                                                        55.60443
                                                ],
                                                [
                                                        26.493445,
                                                        55.609205
                                                ],
                                                [
                                                        26.462924,
                                                        55.596738
                                                ],
                                                [
                                                        26.419303,
                                                        55.618486
                                                ],
                                                [
                                                        26.407564,
                                                        55.60151
                                                ],
                                                [
                                                        26.317841,
                                                        55.603
                                                ],
                                                [
                                                        26.277699,
                                                        55.611879
                                                ],
                                                [
                                                        26.249076,
                                                        55.599007
                                                ],
                                                [
                                                        26.223568,
                                                        55.556004
                                                ],
                                                [
                                                        26.22848,
                                                        55.540068
                                                ],
                                                [
                                                        26.183877,
                                                        55.531345
                                                ],
                                                [
                                                        26.149762,
                                                        55.53635
                                                ],
                                                [
                                                        26.107054,
                                                        55.534062
                                                ],
                                                [
                                                        26.109288,
                                                        55.52172
                                                ],
                                                [
                                                        26.077454,
                                                        55.522069
                                                ],
                                                [
                                                        26.013171,
                                                        55.516148
                                                ],
                                                [
                                                        25.982522,
                                                        55.526356
                                                ],
                                                [
                                                        25.975842,
                                                        55.546893
                                                ],
                                                [
                                                        25.921751,
                                                        55.578912
                                                ],
                                                [
                                                        25.948654,
                                                        55.588426
                                                ],
                                                [
                                                        25.913687,
                                                        55.606471
                                                ],
                                                [
                                                        25.883081,
                                                        55.596948
                                                ],
                                                [
                                                        25.837098,
                                                        55.624757
                                                ],
                                                [
                                                        25.801613,
                                                        55.630433
                                                ],
                                                [
                                                        25.777495,
                                                        55.623364
                                                ],
                                                [
                                                        25.757922,
                                                        55.68665
                                                ],
                                                [
                                                        25.729386,
                                                        55.687192
                                                ],
                                                [
                                                        25.710917,
                                                        55.699647
                                                ],
                                                [
                                                        25.691037,
                                                        55.698711
                                                ],
                                                [
                                                        25.686184,
                                                        55.714946
                                                ],
                                                [
                                                        25.712502,
                                                        55.731017
                                                ],
                                                [
                                                        25.729884,
                                                        55.751263
                                                ],
                                                [
                                                        25.733929,
                                                        55.779342
                                                ],
                                                [
                                                        25.752917,
                                                        55.786118
                                                ],
                                                [
                                                        25.788834,
                                                        55.773774
                                                ],
                                                [
                                                        25.822407,
                                                        55.773482
                                                ],
                                                [
                                                        25.83914,
                                                        55.796501
                                                ],
                                                [
                                                        25.840297,
                                                        55.835011
                                                ],
                                                [
                                                        25.872705,
                                                        55.821011
                                                ],
                                                [
                                                        25.902336,
                                                        55.825936
                                                ],
                                                [
                                                        25.900662,
                                                        55.861255
                                                ],
                                                [
                                                        25.961007,
                                                        55.866955
                                                ],
                                                [
                                                        25.986626,
                                                        55.88941
                                                ],
                                                [
                                                        25.966387,
                                                        55.910018
                                                ],
                                                [
                                                        25.970412,
                                                        55.921827
                                                ],
                                                [
                                                        26.006177,
                                                        55.94296
                                                ],
                                                [
                                                        26.045737,
                                                        55.944546
                                                ]
                                        ]
                                ]
                        },
                        "properties": {
                                "longName": "Zaras\u0173 rajonas",
                                "name": "Zaras\u0173 r. sav.",
                                "id": "43",
                                "osmId": 366510,
                                "org_id": 59
                        },
                        "id": "43"
                },
                {
                        "type": "Feature",
                        "geometry": {
                                "type": "Polygon",
                                "coordinates": [
                                        [
                                                [
                                                        22.848211,
                                                        54.772778
                                                ],
                                                [
                                                        22.878609,
                                                        54.764439
                                                ],
                                                [
                                                        22.904476,
                                                        54.784863
                                                ],
                                                [
                                                        22.947343,
                                                        54.777236
                                                ],
                                                [
                                                        22.958963,
                                                        54.787699
                                                ],
                                                [
                                                        23.011572,
                                                        54.790759
                                                ],
                                                [
                                                        23.016833,
                                                        54.76302
                                                ],
                                                [
                                                        23.054219,
                                                        54.760081
                                                ],
                                                [
                                                        23.089804,
                                                        54.745125
                                                ],
                                                [
                                                        23.149031,
                                                        54.740642
                                                ],
                                                [
                                                        23.153874,
                                                        54.730273
                                                ],
                                                [
                                                        23.183281,
                                                        54.728501
                                                ],
                                                [
                                                        23.23966,
                                                        54.740345
                                                ],
                                                [
                                                        23.275144,
                                                        54.753143
                                                ],
                                                [
                                                        23.275315,
                                                        54.729559
                                                ],
                                                [
                                                        23.25854,
                                                        54.706832
                                                ],
                                                [
                                                        23.315612,
                                                        54.694158
                                                ],
                                                [
                                                        23.294026,
                                                        54.629718
                                                ],
                                                [
                                                        23.28304,
                                                        54.628823
                                                ],
                                                [
                                                        23.274114,
                                                        54.594427
                                                ],
                                                [
                                                        23.253343,
                                                        54.572939
                                                ],
                                                [
                                                        23.212644,
                                                        54.582669
                                                ],
                                                [
                                                        23.191015,
                                                        54.57869
                                                ],
                                                [
                                                        23.18535,
                                                        54.547338
                                                ],
                                                [
                                                        23.206464,
                                                        54.533197
                                                ],
                                                [
                                                        23.198911,
                                                        54.518154
                                                ],
                                                [
                                                        23.17814,
                                                        54.515862
                                                ],
                                                [
                                                        23.167841,
                                                        54.486655
                                                ],
                                                [
                                                        23.110849,
                                                        54.486257
                                                ],
                                                [
                                                        23.10957,
                                                        54.469748
                                                ],
                                                [
                                                        23.084757,
                                                        54.450742
                                                ],
                                                [
                                                        22.997896,
                                                        54.443355
                                                ],
                                                [
                                                        22.992403,
                                                        54.423586
                                                ],
                                                [
                                                        23.005449,
                                                        54.401109
                                                ],
                                                [
                                                        23.000496,
                                                        54.383905
                                                ],
                                                [
                                                        22.983984,
                                                        54.389621
                                                ],
                                                [
                                                        22.887398,
                                                        54.399765
                                                ],
                                                [
                                                        22.887981,
                                                        54.40912
                                                ],
                                                [
                                                        22.836269,
                                                        54.406566
                                                ],
                                                [
                                                        22.811419,
                                                        54.371011
                                                ],
                                                [
                                                        22.792047,
                                                        54.36332
                                                ],
                                                [
                                                        22.766094,
                                                        54.387239
                                                ],
                                                [
                                                        22.736342,
                                                        54.442901
                                                ],
                                                [
                                                        22.701062,
                                                        54.453663
                                                ],
                                                [
                                                        22.703643,
                                                        54.468008
                                                ],
                                                [
                                                        22.696154,
                                                        54.505455
                                                ],
                                                [
                                                        22.680588,
                                                        54.53379
                                                ],
                                                [
                                                        22.711701,
                                                        54.563071
                                                ],
                                                [
                                                        22.686001,
                                                        54.590819
                                                ],
                                                [
                                                        22.719999,
                                                        54.606612
                                                ],
                                                [
                                                        22.726252,
                                                        54.622592
                                                ],
                                                [
                                                        22.744481,
                                                        54.626544
                                                ],
                                                [
                                                        22.756186,
                                                        54.654007
                                                ],
                                                [
                                                        22.72929,
                                                        54.668807
                                                ],
                                                [
                                                        22.729852,
                                                        54.697861
                                                ],
                                                [
                                                        22.74363,
                                                        54.731514
                                                ],
                                                [
                                                        22.796344,
                                                        54.75289
                                                ],
                                                [
                                                        22.813803,
                                                        54.766596
                                                ],
                                                [
                                                        22.848211,
                                                        54.772778
                                                ]
                                        ]
                                ]
                        },
                        "properties": {
                                "longName": "Vilkavi\u0161kio rajonas",
                                "name": "Vilkavi\u0161kio r. sav.",
                                "id": "39",
                                "osmId": 366511,
                                "org_id": 55
                        },
                        "id": "39"
                },
                {
                        "type": "Feature",
                        "geometry": {
                                "type": "Polygon",
                                "coordinates": [
                                        [
                                                [
                                                        23.416344,
                                                        54.955426
                                                ],
                                                [
                                                        23.39179,
                                                        54.949696
                                                ],
                                                [
                                                        23.393985,
                                                        54.936723
                                                ],
                                                [
                                                        23.33426,
                                                        54.88524
                                                ],
                                                [
                                                        23.314412,
                                                        54.889642
                                                ],
                                                [
                                                        23.27568,
                                                        54.848859
                                                ],
                                                [
                                                        23.305411,
                                                        54.828179
                                                ],
                                                [
                                                        23.26866,
                                                        54.782956
                                                ],
                                                [
                                                        23.294398,
                                                        54.76346
                                                ],
                                                [
                                                        23.275144,
                                                        54.753143
                                                ],
                                                [
                                                        23.23966,
                                                        54.740345
                                                ],
                                                [
                                                        23.183281,
                                                        54.728501
                                                ],
                                                [
                                                        23.153874,
                                                        54.730273
                                                ],
                                                [
                                                        23.149031,
                                                        54.740642
                                                ],
                                                [
                                                        23.089804,
                                                        54.745125
                                                ],
                                                [
                                                        23.054219,
                                                        54.760081
                                                ],
                                                [
                                                        23.016833,
                                                        54.76302
                                                ],
                                                [
                                                        23.011572,
                                                        54.790759
                                                ],
                                                [
                                                        22.958963,
                                                        54.787699
                                                ],
                                                [
                                                        22.947343,
                                                        54.777236
                                                ],
                                                [
                                                        22.904476,
                                                        54.784863
                                                ],
                                                [
                                                        22.878609,
                                                        54.764439
                                                ],
                                                [
                                                        22.848211,
                                                        54.772778
                                                ],
                                                [
                                                        22.848143,
                                                        54.785081
                                                ],
                                                [
                                                        22.873647,
                                                        54.788933
                                                ],
                                                [
                                                        22.876717,
                                                        54.833404
                                                ],
                                                [
                                                        22.858565,
                                                        54.839297
                                                ],
                                                [
                                                        22.869419,
                                                        54.852627
                                                ],
                                                [
                                                        22.840731,
                                                        54.862972
                                                ],
                                                [
                                                        22.855236,
                                                        54.887883
                                                ],
                                                [
                                                        22.836037,
                                                        54.904103
                                                ],
                                                [
                                                        22.814288,
                                                        54.911632
                                                ],
                                                [
                                                        22.788467,
                                                        54.907598
                                                ],
                                                [
                                                        22.784492,
                                                        54.924404
                                                ],
                                                [
                                                        22.749657,
                                                        54.922907
                                                ],
                                                [
                                                        22.729375,
                                                        54.960698
                                                ],
                                                [
                                                        22.670847,
                                                        54.988212
                                                ],
                                                [
                                                        22.643714,
                                                        54.982384
                                                ],
                                                [
                                                        22.598767,
                                                        55.022947
                                                ],
                                                [
                                                        22.589129,
                                                        55.070525
                                                ],
                                                [
                                                        22.635417,
                                                        55.052537
                                                ],
                                                [
                                                        22.665434,
                                                        55.04956
                                                ],
                                                [
                                                        22.714458,
                                                        55.058342
                                                ],
                                                [
                                                        22.741055,
                                                        55.059166
                                                ],
                                                [
                                                        22.78489,
                                                        55.076602
                                                ],
                                                [
                                                        22.81478,
                                                        55.0762
                                                ],
                                                [
                                                        22.841212,
                                                        55.086198
                                                ],
                                                [
                                                        22.874164,
                                                        55.08952
                                                ],
                                                [
                                                        22.896834,
                                                        55.083374
                                                ],
                                                [
                                                        22.933487,
                                                        55.08245
                                                ],
                                                [
                                                        23.019443,
                                                        55.102259
                                                ],
                                                [
                                                        23.064719,
                                                        55.104395
                                                ],
                                                [
                                                        23.126174,
                                                        55.090055
                                                ],
                                                [
                                                        23.195358,
                                                        55.08735
                                                ],
                                                [
                                                        23.315688,
                                                        55.068043
                                                ],
                                                [
                                                        23.412358,
                                                        55.073543
                                                ],
                                                [
                                                        23.435507,
                                                        55.069419
                                                ],
                                                [
                                                        23.469496,
                                                        55.050936
                                                ],
                                                [
                                                        23.495245,
                                                        55.046019
                                                ],
                                                [
                                                        23.556905,
                                                        55.042535
                                                ],
                                                [
                                                        23.58718,
                                                        55.030438
                                                ],
                                                [
                                                        23.587814,
                                                        55.008535
                                                ],
                                                [
                                                        23.576861,
                                                        54.999513
                                                ],
                                                [
                                                        23.543559,
                                                        55.000695
                                                ],
                                                [
                                                        23.503734,
                                                        54.973215
                                                ],
                                                [
                                                        23.480731,
                                                        54.970555
                                                ],
                                                [
                                                        23.443824,
                                                        54.977156
                                                ],
                                                [
                                                        23.416344,
                                                        54.955426
                                                ]
                                        ]
                                ]
                        },
                        "properties": {
                                "longName": "\u0160aki\u0173 rajonas",
                                "name": "\u0160aki\u0173 r. sav.",
                                "id": "84",
                                "osmId": 366512,
                                "org_id": 41
                        },
                        "id": "84"
                },
                {
                        "type": "Feature",
                        "geometry": {
                                "type": "Polygon",
                                "coordinates": [
                                        [
                                                [
                                                        25.982522,
                                                        55.526356
                                                ],
                                                [
                                                        25.980876,
                                                        55.488799
                                                ],
                                                [
                                                        25.994755,
                                                        55.470989
                                                ],
                                                [
                                                        26.024999,
                                                        55.4634
                                                ],
                                                [
                                                        26.019911,
                                                        55.443833
                                                ],
                                                [
                                                        26.043073,
                                                        55.437477
                                                ],
                                                [
                                                        26.039482,
                                                        55.397412
                                                ],
                                                [
                                                        26.003503,
                                                        55.420416
                                                ],
                                                [
                                                        25.980875,
                                                        55.409624
                                                ],
                                                [
                                                        25.960813,
                                                        55.410418
                                                ],
                                                [
                                                        25.933752,
                                                        55.421938
                                                ],
                                                [
                                                        25.916339,
                                                        55.410993
                                                ],
                                                [
                                                        25.937946,
                                                        55.396162
                                                ],
                                                [
                                                        25.950897,
                                                        55.374871
                                                ],
                                                [
                                                        25.970214,
                                                        55.358523
                                                ],
                                                [
                                                        25.944109,
                                                        55.344447
                                                ],
                                                [
                                                        25.888415,
                                                        55.362329
                                                ],
                                                [
                                                        25.871967,
                                                        55.336901
                                                ],
                                                [
                                                        25.862674,
                                                        55.303235
                                                ],
                                                [
                                                        25.83962,
                                                        55.2991
                                                ],
                                                [
                                                        25.841121,
                                                        55.279727
                                                ],
                                                [
                                                        25.807728,
                                                        55.278529
                                                ],
                                                [
                                                        25.793602,
                                                        55.301232
                                                ],
                                                [
                                                        25.771794,
                                                        55.317206
                                                ],
                                                [
                                                        25.734141,
                                                        55.305915
                                                ],
                                                [
                                                        25.725149,
                                                        55.314348
                                                ],
                                                [
                                                        25.754935,
                                                        55.344809
                                                ],
                                                [
                                                        25.755201,
                                                        55.358813
                                                ],
                                                [
                                                        25.713564,
                                                        55.370952
                                                ],
                                                [
                                                        25.665488,
                                                        55.376264
                                                ],
                                                [
                                                        25.650366,
                                                        55.371476
                                                ],
                                                [
                                                        25.622535,
                                                        55.384344
                                                ],
                                                [
                                                        25.606076,
                                                        55.380915
                                                ],
                                                [
                                                        25.567999,
                                                        55.386635
                                                ],
                                                [
                                                        25.549329,
                                                        55.377596
                                                ],
                                                [
                                                        25.520048,
                                                        55.393227
                                                ],
                                                [
                                                        25.503972,
                                                        55.384803
                                                ],
                                                [
                                                        25.476041,
                                                        55.403606
                                                ],
                                                [
                                                        25.436808,
                                                        55.403937
                                                ],
                                                [
                                                        25.418835,
                                                        55.420074
                                                ],
                                                [
                                                        25.38906,
                                                        55.423133
                                                ],
                                                [
                                                        25.365893,
                                                        55.423573
                                                ],
                                                [
                                                        25.374133,
                                                        55.450739
                                                ],
                                                [
                                                        25.387106,
                                                        55.457792
                                                ],
                                                [
                                                        25.362637,
                                                        55.482642
                                                ],
                                                [
                                                        25.393807,
                                                        55.493974
                                                ],
                                                [
                                                        25.423178,
                                                        55.530584
                                                ],
                                                [
                                                        25.407872,
                                                        55.550551
                                                ],
                                                [
                                                        25.429981,
                                                        55.557093
                                                ],
                                                [
                                                        25.41717,
                                                        55.581376
                                                ],
                                                [
                                                        25.433567,
                                                        55.595747
                                                ],
                                                [
                                                        25.485031,
                                                        55.601901
                                                ],
                                                [
                                                        25.494772,
                                                        55.630403
                                                ],
                                                [
                                                        25.454938,
                                                        55.642613
                                                ],
                                                [
                                                        25.485511,
                                                        55.664085
                                                ],
                                                [
                                                        25.499934,
                                                        55.68103
                                                ],
                                                [
                                                        25.495127,
                                                        55.699322
                                                ],
                                                [
                                                        25.519145,
                                                        55.720467
                                                ],
                                                [
                                                        25.543254,
                                                        55.731236
                                                ],
                                                [
                                                        25.581977,
                                                        55.721528
                                                ],
                                                [
                                                        25.599445,
                                                        55.7427
                                                ],
                                                [
                                                        25.64535,
                                                        55.730422
                                                ],
                                                [
                                                        25.681659,
                                                        55.73835
                                                ],
                                                [
                                                        25.686184,
                                                        55.714946
                                                ],
                                                [
                                                        25.691037,
                                                        55.698711
                                                ],
                                                [
                                                        25.710917,
                                                        55.699647
                                                ],
                                                [
                                                        25.729386,
                                                        55.687192
                                                ],
                                                [
                                                        25.757922,
                                                        55.68665
                                                ],
                                                [
                                                        25.777495,
                                                        55.623364
                                                ],
                                                [
                                                        25.801613,
                                                        55.630433
                                                ],
                                                [
                                                        25.837098,
                                                        55.624757
                                                ],
                                                [
                                                        25.883081,
                                                        55.596948
                                                ],
                                                [
                                                        25.913687,
                                                        55.606471
                                                ],
                                                [
                                                        25.948654,
                                                        55.588426
                                                ],
                                                [
                                                        25.921751,
                                                        55.578912
                                                ],
                                                [
                                                        25.975842,
                                                        55.546893
                                                ],
                                                [
                                                        25.982522,
                                                        55.526356
                                                ]
                                        ]
                                ]
                        },
                        "properties": {
                                "longName": "Utenos rajonas",
                                "name": "Utenos r. sav.",
                                "id": "82",
                                "osmId": 366513,
                                "org_id": 53
                        },
                        "id": "82"
                },
                {
                        "type": "Feature",
                        "geometry": {
                                "type": "Polygon",
                                "coordinates": [
                                        [
                                                [
                                                        25.751565,
                                                        54.82349
                                                ],
                                                [
                                                        25.743695,
                                                        54.827335
                                                ],
                                                [
                                                        25.743841,
                                                        54.865927
                                                ],
                                                [
                                                        25.71893,
                                                        54.857326
                                                ],
                                                [
                                                        25.685801,
                                                        54.897571
                                                ],
                                                [
                                                        25.643743,
                                                        54.899547
                                                ],
                                                [
                                                        25.639103,
                                                        54.917353
                                                ],
                                                [
                                                        25.649356,
                                                        54.936504
                                                ],
                                                [
                                                        25.679375,
                                                        54.95151
                                                ],
                                                [
                                                        25.666327,
                                                        54.978003
                                                ],
                                                [
                                                        25.596536,
                                                        54.996757
                                                ],
                                                [
                                                        25.526205,
                                                        55.04086
                                                ],
                                                [
                                                        25.535739,
                                                        55.054096
                                                ],
                                                [
                                                        25.573878,
                                                        55.048532
                                                ],
                                                [
                                                        25.580062,
                                                        55.061337
                                                ],
                                                [
                                                        25.655968,
                                                        55.059849
                                                ],
                                                [
                                                        25.665949,
                                                        55.042226
                                                ],
                                                [
                                                        25.735496,
                                                        55.035944
                                                ],
                                                [
                                                        25.74311,
                                                        55.062462
                                                ],
                                                [
                                                        25.755846,
                                                        55.073102
                                                ],
                                                [
                                                        25.747422,
                                                        55.088446
                                                ],
                                                [
                                                        25.765831,
                                                        55.093997
                                                ],
                                                [
                                                        25.78145,
                                                        55.114558
                                                ],
                                                [
                                                        25.751253,
                                                        55.133382
                                                ],
                                                [
                                                        25.707093,
                                                        55.142993
                                                ],
                                                [
                                                        25.708032,
                                                        55.172574
                                                ],
                                                [
                                                        25.654935,
                                                        55.182686
                                                ],
                                                [
                                                        25.648727,
                                                        55.204201
                                                ],
                                                [
                                                        25.665405,
                                                        55.221042
                                                ],
                                                [
                                                        25.663019,
                                                        55.232684
                                                ],
                                                [
                                                        25.683844,
                                                        55.260513
                                                ],
                                                [
                                                        25.702885,
                                                        55.266556
                                                ],
                                                [
                                                        25.726965,
                                                        55.290674
                                                ],
                                                [
                                                        25.734141,
                                                        55.305915
                                                ],
                                                [
                                                        25.771794,
                                                        55.317206
                                                ],
                                                [
                                                        25.793602,
                                                        55.301232
                                                ],
                                                [
                                                        25.807728,
                                                        55.278529
                                                ],
                                                [
                                                        25.841121,
                                                        55.279727
                                                ],
                                                [
                                                        25.83962,
                                                        55.2991
                                                ],
                                                [
                                                        25.862674,
                                                        55.303235
                                                ],
                                                [
                                                        25.89645,
                                                        55.289159
                                                ],
                                                [
                                                        25.939577,
                                                        55.287356
                                                ],
                                                [
                                                        25.993621,
                                                        55.273531
                                                ],
                                                [
                                                        26.022941,
                                                        55.279176
                                                ],
                                                [
                                                        26.06925,
                                                        55.2965
                                                ],
                                                [
                                                        26.102468,
                                                        55.288241
                                                ],
                                                [
                                                        26.121746,
                                                        55.293621
                                                ],
                                                [
                                                        26.148914,
                                                        55.282888
                                                ],
                                                [
                                                        26.150993,
                                                        55.261395
                                                ],
                                                [
                                                        26.174751,
                                                        55.253492
                                                ],
                                                [
                                                        26.153626,
                                                        55.225561
                                                ],
                                                [
                                                        26.186049,
                                                        55.223098
                                                ],
                                                [
                                                        26.196393,
                                                        55.241804
                                                ],
                                                [
                                                        26.255198,
                                                        55.226616
                                                ],
                                                [
                                                        26.281789,
                                                        55.228884
                                                ],
                                                [
                                                        26.326026,
                                                        55.220074
                                                ],
                                                [
                                                        26.361853,
                                                        55.218896
                                                ],
                                                [
                                                        26.380382,
                                                        55.224604
                                                ],
                                                [
                                                        26.446597,
                                                        55.21038
                                                ],
                                                [
                                                        26.4572,
                                                        55.218912
                                                ],
                                                [
                                                        26.48474,
                                                        55.212892
                                                ],
                                                [
                                                        26.517842,
                                                        55.214695
                                                ],
                                                [
                                                        26.523894,
                                                        55.225072
                                                ],
                                                [
                                                        26.553769,
                                                        55.219481
                                                ],
                                                [
                                                        26.567962,
                                                        55.22853
                                                ],
                                                [
                                                        26.596582,
                                                        55.228715
                                                ],
                                                [
                                                        26.613643,
                                                        55.241692
                                                ],
                                                [
                                                        26.611942,
                                                        55.253858
                                                ],
                                                [
                                                        26.641303,
                                                        55.263795
                                                ],
                                                [
                                                        26.664003,
                                                        55.26116
                                                ],
                                                [
                                                        26.755198,
                                                        55.265647
                                                ],
                                                [
                                                        26.745408,
                                                        55.254777
                                                ],
                                                [
                                                        26.725809,
                                                        55.238123
                                                ],
                                                [
                                                        26.729767,
                                                        55.215792
                                                ],
                                                [
                                                        26.675132,
                                                        55.197404
                                                ],
                                                [
                                                        26.694342,
                                                        55.166878
                                                ],
                                                [
                                                        26.676625,
                                                        55.158787
                                                ],
                                                [
                                                        26.653525,
                                                        55.161088
                                                ],
                                                [
                                                        26.61805,
                                                        55.146755
                                                ],
                                                [
                                                        26.592781,
                                                        55.154053
                                                ],
                                                [
                                                        26.539321,
                                                        55.143672
                                                ],
                                                [
                                                        26.517003,
                                                        55.160874
                                                ],
                                                [
                                                        26.480316,
                                                        55.14869
                                                ],
                                                [
                                                        26.461204,
                                                        55.128602
                                                ],
                                                [
                                                        26.413795,
                                                        55.141011
                                                ],
                                                [
                                                        26.357922,
                                                        55.15055
                                                ],
                                                [
                                                        26.323451,
                                                        55.144907
                                                ],
                                                [
                                                        26.325322,
                                                        55.135662
                                                ],
                                                [
                                                        26.298597,
                                                        55.124748
                                                ],
                                                [
                                                        26.263202,
                                                        55.12132
                                                ],
                                                [
                                                        26.229526,
                                                        55.107302
                                                ],
                                                [
                                                        26.271222,
                                                        55.077564
                                                ],
                                                [
                                                        26.235431,
                                                        55.060668
                                                ],
                                                [
                                                        26.242192,
                                                        55.040392
                                                ],
                                                [
                                                        26.208827,
                                                        55.012466
                                                ],
                                                [
                                                        26.208455,
                                                        54.997515
                                                ],
                                                [
                                                        26.185931,
                                                        54.991692
                                                ],
                                                [
                                                        26.120684,
                                                        54.989526
                                                ],
                                                [
                                                        26.1098,
                                                        54.972082
                                                ],
                                                [
                                                        26.076048,
                                                        54.970163
                                                ],
                                                [
                                                        26.080693,
                                                        54.954712
                                                ],
                                                [
                                                        26.023306,
                                                        54.94318
                                                ],
                                                [
                                                        25.990503,
                                                        54.951905
                                                ],
                                                [
                                                        25.95586,
                                                        54.950958
                                                ],
                                                [
                                                        25.908494,
                                                        54.93139
                                                ],
                                                [
                                                        25.883489,
                                                        54.936764
                                                ],
                                                [
                                                        25.857746,
                                                        54.927654
                                                ],
                                                [
                                                        25.853482,
                                                        54.897244
                                                ],
                                                [
                                                        25.808675,
                                                        54.867336
                                                ],
                                                [
                                                        25.778053,
                                                        54.852594
                                                ],
                                                [
                                                        25.783547,
                                                        54.83884
                                                ],
                                                [
                                                        25.773152,
                                                        54.823066
                                                ],
                                                [
                                                        25.751565,
                                                        54.82349
                                                ]
                                        ]
                                ]
                        },
                        "properties": {
                                "longName": "\u0160ven\u010dioni\u0173 rajonas",
                                "name": "\u0160ven\u010dioni\u0173 r. sav.",
                                "id": "86",
                                "osmId": 366514,
                                "org_id": 48
                        },
                        "id": "86"
                },
                {
                        "type": "Feature",
                        "geometry": {
                                "type": "Polygon",
                                "coordinates": [
                                        [
                                                [
                                                        23.249394,
                                                        55.894823
                                                ],
                                                [
                                                        23.228379,
                                                        55.907432
                                                ],
                                                [
                                                        23.284557,
                                                        55.928067
                                                ],
                                                [
                                                        23.280235,
                                                        55.960765
                                                ],
                                                [
                                                        23.312919,
                                                        55.969937
                                                ],
                                                [
                                                        23.345987,
                                                        55.962785
                                                ],
                                                [
                                                        23.349996,
                                                        55.932573
                                                ],
                                                [
                                                        23.4185,
                                                        55.898112
                                                ],
                                                [
                                                        23.429009,
                                                        55.886184
                                                ],
                                                [
                                                        23.416519,
                                                        55.874396
                                                ],
                                                [
                                                        23.385562,
                                                        55.872509
                                                ],
                                                [
                                                        23.370411,
                                                        55.882575
                                                ],
                                                [
                                                        23.347095,
                                                        55.871391
                                                ],
                                                [
                                                        23.327719,
                                                        55.841065
                                                ],
                                                [
                                                        23.268691,
                                                        55.860531
                                                ],
                                                [
                                                        23.265236,
                                                        55.867458
                                                ],
                                                [
                                                        23.317535,
                                                        55.891046
                                                ],
                                                [
                                                        23.294684,
                                                        55.903656
                                                ],
                                                [
                                                        23.269089,
                                                        55.889222
                                                ],
                                                [
                                                        23.249394,
                                                        55.894823
                                                ]
                                        ]
                                ]
                        },
                        "properties": {
                                "longName": "\u0160iauli\u0173 m. savivaldyb\u0117",
                                "name": "\u0160iauli\u0173 m. sav.",
                                "id": "29",
                                "osmId": 366515,
                                "org_id": 43
                        },
                        "id": "29"
                },
                {
                        "type": "Feature",
                        "geometry": {
                                "type": "Polygon",
                                "coordinates": [
                                        [
                                                [
                                                        24.334054,
                                                        55.696958
                                                ],
                                                [
                                                        24.310708,
                                                        55.695183
                                                ],
                                                [
                                                        24.277921,
                                                        55.739565
                                                ],
                                                [
                                                        24.289765,
                                                        55.758019
                                                ],
                                                [
                                                        24.332337,
                                                        55.755604
                                                ],
                                                [
                                                        24.366008,
                                                        55.769349
                                                ],
                                                [
                                                        24.383666,
                                                        55.753897
                                                ],
                                                [
                                                        24.409173,
                                                        55.749556
                                                ],
                                                [
                                                        24.39574,
                                                        55.727904
                                                ],
                                                [
                                                        24.399629,
                                                        55.709403
                                                ],
                                                [
                                                        24.334054,
                                                        55.696958
                                                ]
                                        ]
                                ]
                        },
                        "properties": {
                                "longName": "Panev\u0117\u017eio m. savivaldyb\u0117",
                                "name": "Panev\u0117\u017eio m. sav.",
                                "id": "27",
                                "osmId": 366516,
                                "org_id": 31
                        },
                        "id": "27"
                },
                {
                        "type": "Feature",
                        "geometry": {
                                "type": "Polygon",
                                "coordinates": [
                                        [
                                                [
                                                        24.810257,
                                                        54.890007
                                                ],
                                                [
                                                        24.848527,
                                                        54.873759
                                                ],
                                                [
                                                        24.85338,
                                                        54.859237
                                                ],
                                                [
                                                        24.866455,
                                                        54.843671
                                                ],
                                                [
                                                        24.891608,
                                                        54.845744
                                                ],
                                                [
                                                        24.885059,
                                                        54.817226
                                                ],
                                                [
                                                        24.888355,
                                                        54.793276
                                                ],
                                                [
                                                        24.902972,
                                                        54.784996
                                                ],
                                                [
                                                        24.9343,
                                                        54.815599
                                                ],
                                                [
                                                        24.977284,
                                                        54.800205
                                                ],
                                                [
                                                        24.938737,
                                                        54.774911
                                                ],
                                                [
                                                        24.967113,
                                                        54.767345
                                                ],
                                                [
                                                        24.995094,
                                                        54.746841
                                                ],
                                                [
                                                        24.974695,
                                                        54.737304
                                                ],
                                                [
                                                        24.94815,
                                                        54.72432
                                                ],
                                                [
                                                        24.925094,
                                                        54.722059
                                                ],
                                                [
                                                        24.865295,
                                                        54.72729
                                                ],
                                                [
                                                        24.846245,
                                                        54.706428
                                                ],
                                                [
                                                        24.815893,
                                                        54.690447
                                                ],
                                                [
                                                        24.802965,
                                                        54.657107
                                                ],
                                                [
                                                        24.775417,
                                                        54.639909
                                                ],
                                                [
                                                        24.702783,
                                                        54.653845
                                                ],
                                                [
                                                        24.672265,
                                                        54.643214
                                                ],
                                                [
                                                        24.64417,
                                                        54.651853
                                                ],
                                                [
                                                        24.608044,
                                                        54.652156
                                                ],
                                                [
                                                        24.580933,
                                                        54.645227
                                                ],
                                                [
                                                        24.529855,
                                                        54.654155
                                                ],
                                                [
                                                        24.470446,
                                                        54.641447
                                                ],
                                                [
                                                        24.463804,
                                                        54.683432
                                                ],
                                                [
                                                        24.500732,
                                                        54.716174
                                                ],
                                                [
                                                        24.503518,
                                                        54.729079
                                                ],
                                                [
                                                        24.539549,
                                                        54.734269
                                                ],
                                                [
                                                        24.57711,
                                                        54.779196
                                                ],
                                                [
                                                        24.580845,
                                                        54.795173
                                                ],
                                                [
                                                        24.545222,
                                                        54.797865
                                                ],
                                                [
                                                        24.563835,
                                                        54.81216
                                                ],
                                                [
                                                        24.592005,
                                                        54.810352
                                                ],
                                                [
                                                        24.622057,
                                                        54.829925
                                                ],
                                                [
                                                        24.65578,
                                                        54.824354
                                                ],
                                                [
                                                        24.746744,
                                                        54.815559
                                                ],
                                                [
                                                        24.777643,
                                                        54.825449
                                                ],
                                                [
                                                        24.758589,
                                                        54.876246
                                                ],
                                                [
                                                        24.810257,
                                                        54.890007
                                                ]
                                        ]
                                ]
                        },
                        "properties": {
                                "longName": "Elektr\u0117n\u0173 savivaldyb\u0117",
                                "name": "Elektr\u0117n\u0173 sav.",
                                "id": "42",
                                "osmId": 366517,
                                "org_id": 7
                        },
                        "id": "42"
                },
                {
                        "type": "Feature",
                        "geometry": {
                                "type": "Polygon",
                                "coordinates": [
                                        [
                                                [
                                                        25.078418,
                                                        54.599229
                                                ],
                                                [
                                                        25.066091,
                                                        54.61973
                                                ],
                                                [
                                                        25.024535,
                                                        54.623194
                                                ],
                                                [
                                                        25.076861,
                                                        54.639986
                                                ],
                                                [
                                                        25.081535,
                                                        54.663376
                                                ],
                                                [
                                                        25.071019,
                                                        54.690289
                                                ],
                                                [
                                                        25.110956,
                                                        54.673632
                                                ],
                                                [
                                                        25.13656,
                                                        54.68115
                                                ],
                                                [
                                                        25.177964,
                                                        54.673483
                                                ],
                                                [
                                                        25.18233,
                                                        54.694335
                                                ],
                                                [
                                                        25.134551,
                                                        54.706065
                                                ],
                                                [
                                                        25.170111,
                                                        54.727026
                                                ],
                                                [
                                                        25.202157,
                                                        54.716833
                                                ],
                                                [
                                                        25.203223,
                                                        54.760057
                                                ],
                                                [
                                                        25.241984,
                                                        54.75808
                                                ],
                                                [
                                                        25.274167,
                                                        54.778331
                                                ],
                                                [
                                                        25.290854,
                                                        54.798053
                                                ],
                                                [
                                                        25.286732,
                                                        54.819784
                                                ],
                                                [
                                                        25.314461,
                                                        54.83232
                                                ],
                                                [
                                                        25.321491,
                                                        54.818182
                                                ],
                                                [
                                                        25.359722,
                                                        54.806279
                                                ],
                                                [
                                                        25.408682,
                                                        54.805551
                                                ],
                                                [
                                                        25.416631,
                                                        54.799149
                                                ],
                                                [
                                                        25.454934,
                                                        54.801719
                                                ],
                                                [
                                                        25.451538,
                                                        54.741068
                                                ],
                                                [
                                                        25.42696,
                                                        54.739003
                                                ],
                                                [
                                                        25.411858,
                                                        54.728285
                                                ],
                                                [
                                                        25.41254,
                                                        54.713416
                                                ],
                                                [
                                                        25.466113,
                                                        54.704391
                                                ],
                                                [
                                                        25.47154,
                                                        54.68839
                                                ],
                                                [
                                                        25.449652,
                                                        54.685403
                                                ],
                                                [
                                                        25.437018,
                                                        54.673838
                                                ],
                                                [
                                                        25.415188,
                                                        54.67822
                                                ],
                                                [
                                                        25.384568,
                                                        54.664788
                                                ],
                                                [
                                                        25.362441,
                                                        54.638774
                                                ],
                                                [
                                                        25.319852,
                                                        54.647066
                                                ],
                                                [
                                                        25.3217,
                                                        54.616417
                                                ],
                                                [
                                                        25.313776,
                                                        54.599404
                                                ],
                                                [
                                                        25.287657,
                                                        54.59278
                                                ],
                                                [
                                                        25.211207,
                                                        54.589254
                                                ],
                                                [
                                                        25.182476,
                                                        54.605597
                                                ],
                                                [
                                                        25.186531,
                                                        54.569723
                                                ],
                                                [
                                                        25.158369,
                                                        54.570572
                                                ],
                                                [
                                                        25.143091,
                                                        54.57903
                                                ],
                                                [
                                                        25.115757,
                                                        54.578688
                                                ],
                                                [
                                                        25.115664,
                                                        54.601197
                                                ],
                                                [
                                                        25.09941,
                                                        54.608863
                                                ],
                                                [
                                                        25.078418,
                                                        54.599229
                                                ]
                                        ]
                                ]
                        },
                        "properties": {
                                "longName": "Vilniaus m. savivaldyb\u0117",
                                "name": "Vilniaus m. sav.",
                                "id": "13",
                                "osmId": 366518,
                                "org_id": 56
                        },
                        "id": "13"
                },
                {
                        "type": "Feature",
                        "geometry": {
                                "type": "Polygon",
                                "coordinates": [
                                        [
                                                [
                                                        23.167841,
                                                        54.486655
                                                ],
                                                [
                                                        23.17814,
                                                        54.515862
                                                ],
                                                [
                                                        23.198911,
                                                        54.518154
                                                ],
                                                [
                                                        23.206464,
                                                        54.533197
                                                ],
                                                [
                                                        23.18535,
                                                        54.547338
                                                ],
                                                [
                                                        23.191015,
                                                        54.57869
                                                ],
                                                [
                                                        23.212644,
                                                        54.582669
                                                ],
                                                [
                                                        23.253343,
                                                        54.572939
                                                ],
                                                [
                                                        23.274114,
                                                        54.594427
                                                ],
                                                [
                                                        23.28304,
                                                        54.628823
                                                ],
                                                [
                                                        23.294026,
                                                        54.629718
                                                ],
                                                [
                                                        23.315612,
                                                        54.694158
                                                ],
                                                [
                                                        23.378419,
                                                        54.702198
                                                ],
                                                [
                                                        23.400833,
                                                        54.691255
                                                ],
                                                [
                                                        23.462424,
                                                        54.707882
                                                ],
                                                [
                                                        23.486971,
                                                        54.70441
                                                ],
                                                [
                                                        23.489203,
                                                        54.679408
                                                ],
                                                [
                                                        23.543448,
                                                        54.639194
                                                ],
                                                [
                                                        23.608851,
                                                        54.650617
                                                ],
                                                [
                                                        23.652968,
                                                        54.646346
                                                ],
                                                [
                                                        23.673768,
                                                        54.639116
                                                ],
                                                [
                                                        23.626047,
                                                        54.628585
                                                ],
                                                [
                                                        23.640295,
                                                        54.615167
                                                ],
                                                [
                                                        23.675485,
                                                        54.616161
                                                ],
                                                [
                                                        23.700204,
                                                        54.592795
                                                ],
                                                [
                                                        23.68527,
                                                        54.588916
                                                ],
                                                [
                                                        23.716684,
                                                        54.542439
                                                ],
                                                [
                                                        23.760801,
                                                        54.547816
                                                ],
                                                [
                                                        23.777967,
                                                        54.535965
                                                ],
                                                [
                                                        23.766811,
                                                        54.522798
                                                ],
                                                [
                                                        23.796182,
                                                        54.502348
                                                ],
                                                [
                                                        23.786207,
                                                        54.489884
                                                ],
                                                [
                                                        23.761018,
                                                        54.478376
                                                ],
                                                [
                                                        23.758059,
                                                        54.46844
                                                ],
                                                [
                                                        23.727797,
                                                        54.472999
                                                ],
                                                [
                                                        23.71765,
                                                        54.483551
                                                ],
                                                [
                                                        23.687175,
                                                        54.474224
                                                ],
                                                [
                                                        23.657461,
                                                        54.510261
                                                ],
                                                [
                                                        23.628793,
                                                        54.50787
                                                ],
                                                [
                                                        23.61403,
                                                        54.485239
                                                ],
                                                [
                                                        23.525796,
                                                        54.465989
                                                ],
                                                [
                                                        23.50966,
                                                        54.414776
                                                ],
                                                [
                                                        23.491121,
                                                        54.414576
                                                ],
                                                [
                                                        23.45721,
                                                        54.400843
                                                ],
                                                [
                                                        23.432376,
                                                        54.401194
                                                ],
                                                [
                                                        23.444251,
                                                        54.366083
                                                ],
                                                [
                                                        23.399233,
                                                        54.367313
                                                ],
                                                [
                                                        23.391696,
                                                        54.397112
                                                ],
                                                [
                                                        23.357526,
                                                        54.404006
                                                ],
                                                [
                                                        23.33624,
                                                        54.416394
                                                ],
                                                [
                                                        23.35684,
                                                        54.432773
                                                ],
                                                [
                                                        23.328516,
                                                        54.447947
                                                ],
                                                [
                                                        23.333837,
                                                        54.471695
                                                ],
                                                [
                                                        23.315047,
                                                        54.477189
                                                ],
                                                [
                                                        23.272989,
                                                        54.477727
                                                ],
                                                [
                                                        23.259562,
                                                        54.460209
                                                ],
                                                [
                                                        23.199598,
                                                        54.473092
                                                ],
                                                [
                                                        23.167841,
                                                        54.486655
                                                ]
                                        ]
                                ]
                        },
                        "properties": {
                                "longName": "Marijampol\u0117s savivaldyb\u0117",
                                "name": "Marijampol\u0117s sav.",
                                "id": "18",
                                "osmId": 366519,
                                "org_id": 24
                        },
                        "id": "18"
                },
                {
                        "type": "Feature",
                        "geometry": {
                                "type": "Polygon",
                                "coordinates": [
                                        [
                                                [
                                                        23.321542,
                                                        54.253404
                                                ],
                                                [
                                                        23.282295,
                                                        54.260805
                                                ],
                                                [
                                                        23.233983,
                                                        54.261025
                                                ],
                                                [
                                                        23.20259,
                                                        54.28865
                                                ],
                                                [
                                                        23.154161,
                                                        54.296943
                                                ],
                                                [
                                                        23.159821,
                                                        54.309734
                                                ],
                                                [
                                                        23.140455,
                                                        54.316089
                                                ],
                                                [
                                                        23.092258,
                                                        54.298568
                                                ],
                                                [
                                                        23.041872,
                                                        54.315712
                                                ],
                                                [
                                                        23.063303,
                                                        54.341063
                                                ],
                                                [
                                                        23.047067,
                                                        54.34957
                                                ],
                                                [
                                                        22.994032,
                                                        54.361923
                                                ],
                                                [
                                                        23.000496,
                                                        54.383905
                                                ],
                                                [
                                                        23.005449,
                                                        54.401109
                                                ],
                                                [
                                                        22.992403,
                                                        54.423586
                                                ],
                                                [
                                                        22.997896,
                                                        54.443355
                                                ],
                                                [
                                                        23.084757,
                                                        54.450742
                                                ],
                                                [
                                                        23.10957,
                                                        54.469748
                                                ],
                                                [
                                                        23.110849,
                                                        54.486257
                                                ],
                                                [
                                                        23.167841,
                                                        54.486655
                                                ],
                                                [
                                                        23.199598,
                                                        54.473092
                                                ],
                                                [
                                                        23.259562,
                                                        54.460209
                                                ],
                                                [
                                                        23.272989,
                                                        54.477727
                                                ],
                                                [
                                                        23.315047,
                                                        54.477189
                                                ],
                                                [
                                                        23.333837,
                                                        54.471695
                                                ],
                                                [
                                                        23.328516,
                                                        54.447947
                                                ],
                                                [
                                                        23.35684,
                                                        54.432773
                                                ],
                                                [
                                                        23.33624,
                                                        54.416394
                                                ],
                                                [
                                                        23.357526,
                                                        54.404006
                                                ],
                                                [
                                                        23.391696,
                                                        54.397112
                                                ],
                                                [
                                                        23.399233,
                                                        54.367313
                                                ],
                                                [
                                                        23.365039,
                                                        54.359067
                                                ],
                                                [
                                                        23.337507,
                                                        54.328615
                                                ],
                                                [
                                                        23.342738,
                                                        54.308183
                                                ],
                                                [
                                                        23.311761,
                                                        54.296741
                                                ],
                                                [
                                                        23.331589,
                                                        54.277617
                                                ],
                                                [
                                                        23.321542,
                                                        54.253404
                                                ]
                                        ]
                                ]
                        },
                        "properties": {
                                "longName": "Kalvarijos savivaldyb\u0117",
                                "name": "Kalvarijos sav.",
                                "id": "48",
                                "osmId": 366520,
                                "org_id": 13
                        },
                        "id": "48"
                },
                {
                        "type": "Feature",
                        "geometry": {
                                "type": "Polygon",
                                "coordinates": [
                                        [
                                                [
                                                        24.137506,
                                                        54.936073
                                                ],
                                                [
                                                        24.130557,
                                                        54.923486
                                                ],
                                                [
                                                        24.100556,
                                                        54.912693
                                                ],
                                                [
                                                        24.068437,
                                                        54.926056
                                                ],
                                                [
                                                        23.978347,
                                                        54.9318
                                                ],
                                                [
                                                        23.946809,
                                                        54.959457
                                                ],
                                                [
                                                        23.913106,
                                                        54.959675
                                                ],
                                                [
                                                        23.880858,
                                                        54.953226
                                                ],
                                                [
                                                        23.85571,
                                                        54.941454
                                                ],
                                                [
                                                        23.812014,
                                                        54.945167
                                                ],
                                                [
                                                        23.77956,
                                                        54.918777
                                                ],
                                                [
                                                        23.820709,
                                                        54.90291
                                                ],
                                                [
                                                        23.864088,
                                                        54.897625
                                                ],
                                                [
                                                        23.868006,
                                                        54.876277
                                                ],
                                                [
                                                        23.829808,
                                                        54.868298
                                                ],
                                                [
                                                        23.842619,
                                                        54.850672
                                                ],
                                                [
                                                        23.880589,
                                                        54.846253
                                                ],
                                                [
                                                        23.884344,
                                                        54.856866
                                                ],
                                                [
                                                        23.927672,
                                                        54.850939
                                                ],
                                                [
                                                        23.935557,
                                                        54.83076
                                                ],
                                                [
                                                        23.95853,
                                                        54.836126
                                                ],
                                                [
                                                        23.988092,
                                                        54.834161
                                                ],
                                                [
                                                        24.010853,
                                                        54.842671
                                                ],
                                                [
                                                        24.014913,
                                                        54.858051
                                                ],
                                                [
                                                        24.051036,
                                                        54.899487
                                                ],
                                                [
                                                        24.079073,
                                                        54.91424
                                                ],
                                                [
                                                        24.099,
                                                        54.911831
                                                ],
                                                [
                                                        24.102345,
                                                        54.896321
                                                ],
                                                [
                                                        24.122596,
                                                        54.892803
                                                ],
                                                [
                                                        24.136561,
                                                        54.873195
                                                ],
                                                [
                                                        24.18634,
                                                        54.858785
                                                ],
                                                [
                                                        24.208583,
                                                        54.83606
                                                ],
                                                [
                                                        24.247168,
                                                        54.818802
                                                ],
                                                [
                                                        24.241711,
                                                        54.808127
                                                ],
                                                [
                                                        24.209594,
                                                        54.801361
                                                ],
                                                [
                                                        24.167171,
                                                        54.815347
                                                ],
                                                [
                                                        24.133869,
                                                        54.808422
                                                ],
                                                [
                                                        24.148975,
                                                        54.774574
                                                ],
                                                [
                                                        24.124743,
                                                        54.743159
                                                ],
                                                [
                                                        24.108985,
                                                        54.752749
                                                ],
                                                [
                                                        24.078773,
                                                        54.748786
                                                ],
                                                [
                                                        24.040592,
                                                        54.772244
                                                ],
                                                [
                                                        24.023416,
                                                        54.776761
                                                ],
                                                [
                                                        23.993114,
                                                        54.757999
                                                ],
                                                [
                                                        23.933897,
                                                        54.755468
                                                ],
                                                [
                                                        23.899559,
                                                        54.746508
                                                ],
                                                [
                                                        23.839305,
                                                        54.73749
                                                ],
                                                [
                                                        23.812011,
                                                        54.742445
                                                ],
                                                [
                                                        23.805488,
                                                        54.759089
                                                ],
                                                [
                                                        23.778709,
                                                        54.765428
                                                ],
                                                [
                                                        23.762573,
                                                        54.802054
                                                ],
                                                [
                                                        23.674511,
                                                        54.810266
                                                ],
                                                [
                                                        23.652072,
                                                        54.804568
                                                ],
                                                [
                                                        23.667216,
                                                        54.819895
                                                ],
                                                [
                                                        23.624129,
                                                        54.836211
                                                ],
                                                [
                                                        23.626532,
                                                        54.848666
                                                ],
                                                [
                                                        23.581728,
                                                        54.854101
                                                ],
                                                [
                                                        23.583788,
                                                        54.874255
                                                ],
                                                [
                                                        23.539671,
                                                        54.89203
                                                ],
                                                [
                                                        23.507056,
                                                        54.886994
                                                ],
                                                [
                                                        23.481993,
                                                        54.89045
                                                ],
                                                [
                                                        23.477015,
                                                        54.932487
                                                ],
                                                [
                                                        23.416344,
                                                        54.955426
                                                ],
                                                [
                                                        23.443824,
                                                        54.977156
                                                ],
                                                [
                                                        23.480731,
                                                        54.970555
                                                ],
                                                [
                                                        23.503734,
                                                        54.973215
                                                ],
                                                [
                                                        23.543559,
                                                        55.000695
                                                ],
                                                [
                                                        23.576861,
                                                        54.999513
                                                ],
                                                [
                                                        23.587814,
                                                        55.008535
                                                ],
                                                [
                                                        23.58718,
                                                        55.030438
                                                ],
                                                [
                                                        23.556905,
                                                        55.042535
                                                ],
                                                [
                                                        23.495245,
                                                        55.046019
                                                ],
                                                [
                                                        23.469496,
                                                        55.050936
                                                ],
                                                [
                                                        23.435507,
                                                        55.069419
                                                ],
                                                [
                                                        23.412358,
                                                        55.073543
                                                ],
                                                [
                                                        23.44004,
                                                        55.083447
                                                ],
                                                [
                                                        23.454004,
                                                        55.104202
                                                ],
                                                [
                                                        23.480769,
                                                        55.124919
                                                ],
                                                [
                                                        23.482825,
                                                        55.168158
                                                ],
                                                [
                                                        23.504844,
                                                        55.19316
                                                ],
                                                [
                                                        23.533586,
                                                        55.200866
                                                ],
                                                [
                                                        23.526732,
                                                        55.179305
                                                ],
                                                [
                                                        23.562122,
                                                        55.176338
                                                ],
                                                [
                                                        23.561233,
                                                        55.157586
                                                ],
                                                [
                                                        23.587106,
                                                        55.148661
                                                ],
                                                [
                                                        23.612054,
                                                        55.156017
                                                ],
                                                [
                                                        23.810262,
                                                        55.158479
                                                ],
                                                [
                                                        23.81869,
                                                        55.167063
                                                ],
                                                [
                                                        23.863304,
                                                        55.185232
                                                ],
                                                [
                                                        23.883441,
                                                        55.16298
                                                ],
                                                [
                                                        23.943039,
                                                        55.140612
                                                ],
                                                [
                                                        23.994115,
                                                        55.128938
                                                ],
                                                [
                                                        24.016772,
                                                        55.116313
                                                ],
                                                [
                                                        24.027206,
                                                        55.107763
                                                ],
                                                [
                                                        24.06061,
                                                        55.118704
                                                ],
                                                [
                                                        24.088934,
                                                        55.107707
                                                ],
                                                [
                                                        24.081422,
                                                        55.087389
                                                ],
                                                [
                                                        24.061288,
                                                        55.071752
                                                ],
                                                [
                                                        24.096994,
                                                        55.059563
                                                ],
                                                [
                                                        24.064137,
                                                        55.036706
                                                ],
                                                [
                                                        24.067744,
                                                        55.028353
                                                ],
                                                [
                                                        24.109298,
                                                        55.017974
                                                ],
                                                [
                                                        24.08446,
                                                        54.97784
                                                ],
                                                [
                                                        24.125962,
                                                        54.979004
                                                ],
                                                [
                                                        24.114497,
                                                        54.950642
                                                ],
                                                [
                                                        24.137506,
                                                        54.936073
                                                ]
                                        ]
                                ]
                        },
                        "properties": {
                                "longName": "Kauno rajono savivaldyb\u0117",
                                "name": "Kauno r. sav.",
                                "id": "52",
                                "osmId": 366521,
                                "org_id": 15
                        },
                        "id": "52"
                },
                {
                        "type": "Feature",
                        "geometry": {
                                "type": "Polygon",
                                "coordinates": [
                                        [
                                                [
                                                        25.222264,
                                                        55.042678
                                                ],
                                                [
                                                        25.303038,
                                                        55.045986
                                                ],
                                                [
                                                        25.331497,
                                                        55.032052
                                                ],
                                                [
                                                        25.382157,
                                                        55.031652
                                                ],
                                                [
                                                        25.401771,
                                                        55.04038
                                                ],
                                                [
                                                        25.422192,
                                                        55.03399
                                                ],
                                                [
                                                        25.526205,
                                                        55.04086
                                                ],
                                                [
                                                        25.596536,
                                                        54.996757
                                                ],
                                                [
                                                        25.666327,
                                                        54.978003
                                                ],
                                                [
                                                        25.679375,
                                                        54.95151
                                                ],
                                                [
                                                        25.649356,
                                                        54.936504
                                                ],
                                                [
                                                        25.639103,
                                                        54.917353
                                                ],
                                                [
                                                        25.643743,
                                                        54.899547
                                                ],
                                                [
                                                        25.685801,
                                                        54.897571
                                                ],
                                                [
                                                        25.71893,
                                                        54.857326
                                                ],
                                                [
                                                        25.743841,
                                                        54.865927
                                                ],
                                                [
                                                        25.743695,
                                                        54.827335
                                                ],
                                                [
                                                        25.751565,
                                                        54.82349
                                                ],
                                                [
                                                        25.733575,
                                                        54.801528
                                                ],
                                                [
                                                        25.749643,
                                                        54.764822
                                                ],
                                                [
                                                        25.744511,
                                                        54.715164
                                                ],
                                                [
                                                        25.734442,
                                                        54.678155
                                                ],
                                                [
                                                        25.75715,
                                                        54.619833
                                                ],
                                                [
                                                        25.752921,
                                                        54.610472
                                                ],
                                                [
                                                        25.763117,
                                                        54.577168
                                                ],
                                                [
                                                        25.75115,
                                                        54.564912
                                                ],
                                                [
                                                        25.680393,
                                                        54.53494
                                                ],
                                                [
                                                        25.656994,
                                                        54.508601
                                                ],
                                                [
                                                        25.638641,
                                                        54.476816
                                                ],
                                                [
                                                        25.626399,
                                                        54.490119
                                                ],
                                                [
                                                        25.576547,
                                                        54.478033
                                                ],
                                                [
                                                        25.573835,
                                                        54.470929
                                                ],
                                                [
                                                        25.526822,
                                                        54.468376
                                                ],
                                                [
                                                        25.51661,
                                                        54.481582
                                                ],
                                                [
                                                        25.490941,
                                                        54.480995
                                                ],
                                                [
                                                        25.445369,
                                                        54.503644
                                                ],
                                                [
                                                        25.422195,
                                                        54.488658
                                                ],
                                                [
                                                        25.408361,
                                                        54.499694
                                                ],
                                                [
                                                        25.334625,
                                                        54.497827
                                                ],
                                                [
                                                        25.318656,
                                                        54.493799
                                                ],
                                                [
                                                        25.319236,
                                                        54.470224
                                                ],
                                                [
                                                        25.30479,
                                                        54.464671
                                                ],
                                                [
                                                        25.24162,
                                                        54.46419
                                                ],
                                                [
                                                        25.221253,
                                                        54.475534
                                                ],
                                                [
                                                        25.232069,
                                                        54.488258
                                                ],
                                                [
                                                        25.212426,
                                                        54.507034
                                                ],
                                                [
                                                        25.186639,
                                                        54.486694
                                                ],
                                                [
                                                        25.156385,
                                                        54.471968
                                                ],
                                                [
                                                        25.146146,
                                                        54.490753
                                                ],
                                                [
                                                        25.167629,
                                                        54.523721
                                                ],
                                                [
                                                        25.165508,
                                                        54.539934
                                                ],
                                                [
                                                        25.142039,
                                                        54.539008
                                                ],
                                                [
                                                        25.107463,
                                                        54.549978
                                                ],
                                                [
                                                        25.039748,
                                                        54.552291
                                                ],
                                                [
                                                        25.02874,
                                                        54.556293
                                                ],
                                                [
                                                        25.078418,
                                                        54.599229
                                                ],
                                                [
                                                        25.09941,
                                                        54.608863
                                                ],
                                                [
                                                        25.115664,
                                                        54.601197
                                                ],
                                                [
                                                        25.115757,
                                                        54.578688
                                                ],
                                                [
                                                        25.143091,
                                                        54.57903
                                                ],
                                                [
                                                        25.158369,
                                                        54.570572
                                                ],
                                                [
                                                        25.186531,
                                                        54.569723
                                                ],
                                                [
                                                        25.182476,
                                                        54.605597
                                                ],
                                                [
                                                        25.211207,
                                                        54.589254
                                                ],
                                                [
                                                        25.287657,
                                                        54.59278
                                                ],
                                                [
                                                        25.313776,
                                                        54.599404
                                                ],
                                                [
                                                        25.3217,
                                                        54.616417
                                                ],
                                                [
                                                        25.319852,
                                                        54.647066
                                                ],
                                                [
                                                        25.362441,
                                                        54.638774
                                                ],
                                                [
                                                        25.384568,
                                                        54.664788
                                                ],
                                                [
                                                        25.415188,
                                                        54.67822
                                                ],
                                                [
                                                        25.437018,
                                                        54.673838
                                                ],
                                                [
                                                        25.449652,
                                                        54.685403
                                                ],
                                                [
                                                        25.47154,
                                                        54.68839
                                                ],
                                                [
                                                        25.466113,
                                                        54.704391
                                                ],
                                                [
                                                        25.41254,
                                                        54.713416
                                                ],
                                                [
                                                        25.411858,
                                                        54.728285
                                                ],
                                                [
                                                        25.42696,
                                                        54.739003
                                                ],
                                                [
                                                        25.451538,
                                                        54.741068
                                                ],
                                                [
                                                        25.454934,
                                                        54.801719
                                                ],
                                                [
                                                        25.416631,
                                                        54.799149
                                                ],
                                                [
                                                        25.408682,
                                                        54.805551
                                                ],
                                                [
                                                        25.359722,
                                                        54.806279
                                                ],
                                                [
                                                        25.321491,
                                                        54.818182
                                                ],
                                                [
                                                        25.314461,
                                                        54.83232
                                                ],
                                                [
                                                        25.286732,
                                                        54.819784
                                                ],
                                                [
                                                        25.290854,
                                                        54.798053
                                                ],
                                                [
                                                        25.274167,
                                                        54.778331
                                                ],
                                                [
                                                        25.241984,
                                                        54.75808
                                                ],
                                                [
                                                        25.203223,
                                                        54.760057
                                                ],
                                                [
                                                        25.202157,
                                                        54.716833
                                                ],
                                                [
                                                        25.170111,
                                                        54.727026
                                                ],
                                                [
                                                        25.134551,
                                                        54.706065
                                                ],
                                                [
                                                        25.18233,
                                                        54.694335
                                                ],
                                                [
                                                        25.177964,
                                                        54.673483
                                                ],
                                                [
                                                        25.13656,
                                                        54.68115
                                                ],
                                                [
                                                        25.110956,
                                                        54.673632
                                                ],
                                                [
                                                        25.071019,
                                                        54.690289
                                                ],
                                                [
                                                        25.075508,
                                                        54.703444
                                                ],
                                                [
                                                        25.049338,
                                                        54.721819
                                                ],
                                                [
                                                        25.027374,
                                                        54.720411
                                                ],
                                                [
                                                        25.017557,
                                                        54.739074
                                                ],
                                                [
                                                        24.974695,
                                                        54.737304
                                                ],
                                                [
                                                        24.995094,
                                                        54.746841
                                                ],
                                                [
                                                        24.967113,
                                                        54.767345
                                                ],
                                                [
                                                        24.938737,
                                                        54.774911
                                                ],
                                                [
                                                        24.977284,
                                                        54.800205
                                                ],
                                                [
                                                        24.9343,
                                                        54.815599
                                                ],
                                                [
                                                        24.902972,
                                                        54.784996
                                                ],
                                                [
                                                        24.888355,
                                                        54.793276
                                                ],
                                                [
                                                        24.885059,
                                                        54.817226
                                                ],
                                                [
                                                        24.891608,
                                                        54.845744
                                                ],
                                                [
                                                        24.866455,
                                                        54.843671
                                                ],
                                                [
                                                        24.85338,
                                                        54.859237
                                                ],
                                                [
                                                        24.865646,
                                                        54.87559
                                                ],
                                                [
                                                        24.900681,
                                                        54.879413
                                                ],
                                                [
                                                        24.960743,
                                                        54.867948
                                                ],
                                                [
                                                        24.970253,
                                                        54.880848
                                                ],
                                                [
                                                        25.048,
                                                        54.883
                                                ],
                                                [
                                                        25.079175,
                                                        54.888298
                                                ],
                                                [
                                                        25.115825,
                                                        54.880472
                                                ],
                                                [
                                                        25.127101,
                                                        54.888781
                                                ],
                                                [
                                                        25.11636,
                                                        54.902823
                                                ],
                                                [
                                                        25.147949,
                                                        54.906247
                                                ],
                                                [
                                                        25.13552,
                                                        54.935355
                                                ],
                                                [
                                                        25.159394,
                                                        54.965475
                                                ],
                                                [
                                                        25.180976,
                                                        54.958533
                                                ],
                                                [
                                                        25.200548,
                                                        54.995687
                                                ],
                                                [
                                                        25.18709,
                                                        55.033024
                                                ],
                                                [
                                                        25.222264,
                                                        55.042678
                                                ]
                                        ]
                                ]
                        },
                        "properties": {
                                "longName": "Vilniaus rajonas",
                                "name": "Vilniaus r. sav.",
                                "id": "41",
                                "osmId": 366522,
                                "org_id": 57
                        },
                        "id": "41"
                }
        ]
};
export default map;